const jaJp = {
  "menu.overview": "概要",
  "menu.sales": "販売・営業",
  "menu.inventory-management": "商品・在庫管理",
  "menu.crm": "顧客・パートナー",
  "menu.finance": "財務・税務",
  "menu.utilities": "便利機能",
  "product.tax-rate": "税率",
  "table.import.tax-rate": "税率 (%)",
  /* 00.General */
  "general.copyright": "著作権",
  "general.refresh": "リストを更新",
  "general.btn-update": "更新",
  "general.btn-update-count": "数量更新",
  "general.btn-add": "追加",
  "general.btn-order": "今すぐ注文！",
  "general.btn-order-preview": "商品を見る",
  "general.product-unit": "商品",
  "general.btn-create-make-product": "レシピ作成",
  "general.btn-update-make-product": "レシピ更新",
  "general.btn-cancel": "キャンセル",
  "role.default.cashier": "レジ係",
  "role.default.kitchen": "バー / キッチン",
  "role.default.table-pending-payment": "テーブル担当",
  "general.info": "情報",
  "general.setting": "設定",
  "general.function": "機能",
  timeCreated: "作成日時",
  "print.cashier": "レジ係",
  "print.invoice": "請求書",
  "print.name-product": "商品名",
  "print.quantity": "数量",
  "print.price": "価格",
  "print.total-price": "合計金額",
  "print.discount": "割引",
  "print.tax": "税金",
  "print.fee-other": "手数料",
  "print.shipping": "配送",
  "print.amount-to-pay": "支払金額",
  "print.info-bill": "請求情報",
  "print.thank-you": "ありがとうございました！",
  "print.copy-right": "vmass.vnの著作権",

  /* 01.Order */
  "order.to-pending": "キッチンへ",
  "order.to-done": "支払いへ",
  "order.done": "完了",
  "order.to-refund": "返金",
  "order.to-change": "変更",
  "order.to-bill-draft": "仮請求書を印刷",
  "order.to-bill": "請求書を印刷",
  "order.to-end": "完了",
  "order.print-bill": "請求書を印刷",
  "order.to-excel": "Excelダウンロード",
  "order.to-destroy": "破棄",
  "order.transfer-table": "テーブル移動",
  "order.to-bill-now": "印刷",
  "order.to-bill-all": "すべて印刷",
  "order.open-menu": "商品追加",
  "order.search": "検索",
  "order.list-product-in-table": "テーブルの商品一覧",

  /* 02. Profile */
  "company-uuid": "店舗コード",
  "company-name": "店舗名",
  "profile.fullname": "氏名",
  "profile.username": "ユーザー名",
  "profile.email": "メール",
  "profile.address": "住所",
  "profile.description": "説明",
  "profile.avatar": "アバター",
  "profile.company-address": "店舗住所",
  "profile.company-website": "ウェブサイト",
  "profile.company-logo": "店舗ロゴ",
  "profile.company-image": "店舗カバー写真",
  "profile.company-start-time": "開店時間",
  "profile.company-end-time": "閉店時間",
  "profile.company-menu-hash": "店舗メニューコード",
  "profile.company-menu-hash-create": "新規追加",
  "profile.phone": "電話番号",
  "profile.birth-day": "誕生日",
  "profile.btn-update": "更新",
  "pages.responsibilities": "専門",
  "menu.contact": "ソーシャル",
  "profile.update-personal": "個人情報を更新",
  "profile.update-company": "店舗情報を更新",
  "profile.companyName": "店舗名",
  "profile.bankPay": "銀行名",
  "profile.namePay": "口座名義人",
  "profile.numberPay": "口座番号",

  /* 03.User Login, Logout, Register */
  "user.login-title": "サインイン",
  "user.register": "登録",
  "user.forgot-password": "パスワードをお忘れですか",
  "user.username": "ユーザー名",
  "user.email": "メール",
  "user.phone": "電話番号",
  "user.password": "パスワード",
  "user.re-password": "パスワード再入力",
  "user.forgot-password-question": "パスワードをお忘れですか？",
  "user.reset-password-button": "新しいコードを受け取る",
  "user.reset-password-button-submit": "パスワードを変更",
  "user.fullname": "氏名",
  "user.login-button": "ログイン",
  "user.register-button": "登録",
  "user.no-account": "アカウントをお持ちでないですか？ ",
  "user.register-link": "今すぐ登録",
  "user.code": "コード",

  /* 04.Menu */
  "menu.partner": "個人",
  "menu.money": "財務",
  "menu.m": "商品",
  "menu.warehouse": "倉庫",
  "menu.invoice": "請求書",
  "menu.sales-invoice": "販売請求書",
  "menu.einvoice": "電子請求書",
  "menu.order": "注文",
  "menu.app": "ホーム",
  "menu.affiliates": "アフィリエイト",
  "menu.affiliate-list": "アフィリエイト一覧",
  "menu.affiliate-payouts": "アフィリエイト支払",
  "menu.affiliate-commission": "コミッション設定",
  "menu.affiliate-reports": "アフィリエイトレポート",
  "menu.affiliate-fraud": "不正防止",
  "menu.calendars": "カレンダー",
  "menu.analytics": "分析",
  "menu.faq": "FAQ",
  "menu.view": "Q&A",
  "menu.default": "デフォルト",
  "menu.content": "コンテンツ",
  "menu.product": "商品",
  "menu.menu": "メニュー",
  "menu.pages": "ページ",
  "menu.thumb-list": "商品管理",
  // 'menu.order': '注文',
  "menu.search": "検索",
  "menu.login": "ログイン",
  "menu.register": "登録",
  "menu.company": "店舗情報",
  "menu.profile": "情報",
  "menu.forgot-password": "パスワードをお忘れですか",
  "menu.applications": "アプリケーション",
  "menu.promotion": "プロモーション",
  "menu.todo": "ToDo",
  "menu.category": "カテゴリ",
  "menu.ui": "UI",
  "menu.table-setting": "テーブル・座席",
  "menu.stock": "在庫",
  "menu.warehouse-import": "入庫伝票",
  "menu.warehouse-export": "出庫伝票",
  "menu.warehouse-transfer": "出荷伝票",
  "menu.make-product": "レシピ管理",
  "menu.payment": "支払い",
  "menu.table-pending-payment": "支払保留中",
  "menu.message": "メッセージ",
  "menu.ref": "アフィリエイト",
  "menu.upgrade": "アップグレード",
  "menu.setting": "設定",
  "menu.root": "VMASS",
  "menu.user-staff": "スタッフ",
  "menu.customer": "顧客",
  "menu.company-provider": "サプライヤー",
  "menu.treasury": "資金",
  "menu.income": "収入",
  "menu.outcome": "支出",
  "menu.cash-flow": "キャッシュフロー",
  "menu.role": "役割",
  "menu.form-dynamic": "フォームカスタマイズ",
  "menu.user-role": "アカウント作成",
  "menu.qrcode": "QRコード",
  "menu.companies": "店舗連携",
  "menu.shipping": "配送",
  "menu.facebook-settings": "Facebookファンページ",
  "menu.zalo-settings": "Zalo OA",
  "menu.dashboards": "ダッシュボード",
  "menu.calendars": "カレンダー",
  "menu.booking": "予約",
  "menu.analytics": "分析",
  "menu.pages": "ページ",
  "menu.todo": "ToDo",
  "menu.invoice": "請求書",
  "menu.promotion": "プロモーション",
  "menu.partner": "パートナー",
  "menu.money": "現金出納帳",
  "menu.m": "倉庫管理",
  "menu.thumb-list": "商品一覧",
  "menu.warehouse": "倉庫",
  "menu.stock": "在庫",
  "menu.inventory-audit": "棚卸",
  "menu.stock-return": "返品",
  "menu.stock-disposal": "廃棄",
  "menu.stock-out": "出庫",
  "stock-out.subtitle": "社内出庫、仕入先返品、廃棄を承認履歴付きで管理します。",
  "stock-out.create": "出庫伝票を作成",
  "menu.table-setting": "テーブル設定",
  "menu.message": "メッセージ",
  "menu.facebook-ads": "Facebook Ads",
  "menu.fb-ads-dashboard": "Dashboard",
  "menu.fb-ads-campaigns": "Campaigns",
  "menu.fb-ads-reports": "Reports",
  "menu.fb-ads-settings": "Settings",
  "menu.applications": "アプリケーション",
  "menu.profile": "プロフィール",
  "menu.upgrade": "アップグレード",
  "menu.setting": "設定",
  "warehouse.export": "出庫",
  "warehouse.transfer": "在庫移動",

  /* Shift Session */
  "menu.shift-session": "シフト締め",
  "menu.tax-accounting": "帳簿 & 税金",
  "menu.ai-copilot": "AIアシスタント",
  "shift.title": "シフト管理",
  "shift.open": "シフト開始",
  "shift.close": "シフト締め",
  "shift.current": "現在のシフト",
  "shift.history": "シフト履歴",
  "shift.no-open": "現在開いているシフトはありません",
  "shift.open-hint": "「シフト開始」を押して新しいシフトを開始してください",
  "shift.open-modal-title": "シフトを開始する",
  "shift.close-modal-title": "シフト締め & 現金照合",
  "shift.detail-modal-title": "シフト詳細",
  "shift.shift-name": "シフト名",
  "shift.shift-name-placeholder": "例：朝シフト、午後シフト...",
  "shift.staff-name": "スタッフ",
  "shift.opened-at": "開始時刻",
  "shift.closed-at": "終了時刻",
  "shift.opening-cash": "開始時現金",
  "shift.opening-cash-hint": "シフト開始時のレジ内現金",
  "shift.actual-cash": "シフト終了時実際現金",
  "shift.actual-cash-placeholder": "実際にカウントした現金を入力",
  "shift.expected-cash": "理論現金",
  "shift.cash-difference": "差額",
  "shift.total-revenue": "総売上",
  "shift.total-cash": "現金",
  "shift.total-transfer": "銀行振込",
  "shift.total-card": "クレジットカード",
  "shift.total-credit": "掛け売り",
  "shift.total-orders": "総注文数",
  "shift.total-products": "総商品数",
  "shift.note": "備考",
  "shift.note-optional": "備考（任意）",
  "shift.note-explain": "差額の説明",
  "shift.note-explain-required": "必須 - 現金差額の理由を入力してください",
  "shift.status": "ステータス",
  "shift.status-open": "営業中",
  "shift.status-closed": "締め済み",
  "shift.confirm-open": "シフト開始を確認",
  "shift.confirm-close": "シフト締めを確認",
  "shift.require-open": "販売前にシフトを開始してください",
  "shift.print": "シフト締めレポートを印刷",
  "shift.print-title": "シフト締めレポート",
  "shift.revenue-in-shift": "シフト内売上",
  "shift.cash-reconciliation": "現金照合",
  "shift.cash-revenue-add": "+ 現金売上",
  "shift.expected-cash-equals": "= 理論現金",
  "shift.no-data": "シフトデータがありません",
  "shift.detail": "詳細",
  "shift.page-prev": "← 前へ",
  "shift.page-next": "次へ →",
  "shift.page-of": "ページ {current} / {total}",
  "shift.open-success": "シフト開始に成功しました",
  "shift.close-success": "シフト締めに成功しました",
  "shift.open-error": "シフト開始エラー",
  "shift.close-error": "シフト締めエラー",
  "shift.close-warn-difference":
    "現金の差額があります。シフトを締める前に説明を入力してください。",
  "shift.store-name": "店舗",
  "shift.copyright": "著作権 vmass.vn",
  "shift.cancel": "キャンセル",

  /* 05.Dashboards */
  "dashboards.pending-orders": "注文受信",
  "dashboards.completed-orders": "完了した注文",
  "dashboards.refund-requests": "返金リクエスト",
  "dashboards.sales": "売上",
  "dashboards.sales-chart": "売上チャート",
  "dashboards.orders": "注文",
  "dashboards.refunds": "返金",
  "dashboards.calendar": "カレンダー",
  "dashboards.best-sellers": "ベストセラー",
  "dashboards.this-week": "今週",
  "dashboards.this-month": "今月",
  "dashboards.this-all-sales": "全売上",
  "dashboards.recent-orders": "最近の注文",
  "dashboards.stock-status": "在庫状況",
  "dashboards.logs": "ログ",
  "dashboards.message": "メッセージ",
  "dashboards.area": "エリア",
  "dashboards.status-order": "注文状況の概要",
  "dashboards.pending-order": "未受取商品一覧",
  "dashboards.order-undelivery": "未配送商品一覧",
  "dashboards.total-order": "総注文商品数",
  "dashboards.product-not-receive": "未受取商品",
  "dashboards.product-not-delivery": "未配送商品",
  "dashboards.table-notyet-pay": "未払いテーブル",
  "dashboards.product-received-full": "全商品受取済",
  "dashboards.total-product-received": "総受取商品数",
  "dashboards.product-delivery-full": "全商品配送済",
  "dashboards.table-payment-full": "全テーブル支払済",
  "dashboards.list-empty": "リストは空です",
  "dashboards.total": "合計",
  "dashboards.counter": "カウンター",
  "dashboards.table": "テーブル",
  "dashboards.ice": "氷",
  "dashboards.sugar": "甘さ",
  "dashboards.all": "すべて",
  "dashboards.completed": "完了",
  "dashboards.destroy": "破棄",
  "dashboards-empty-product": "リストに商品がまだありません",

  /** Analytics */
  "analytics.dashboards": "ダッシュボード",
  "analytics.user-staff": "スタッフ",
  "analytics.customer": "顧客",
  "analytics.company-provider": "サプライヤー",
  "analytics.treasury": "資金",
  "analytics.income": "収入",
  "analytics.outcome": "支出",
  "analytics.cash-flow": "キャッシュフロー",
  "analytics.role": "役割",
  "analytics.user-role": "アカウント作成",
  "analytics.form-dynamic": "フォームカスタマイズ",
  "analytics.companies": "店舗連携",
  "analytics.dashboards.outcome": "支出",
  "analytics.dashboards.income": "収入",
  "analytics.dashboards.stock-log": "入庫統計",
  "analytics.dashboards.order-payment": "販売商品統計一覧",
  "analytics.dashboards.debt": "債務統計",
  "analytics.dashboards.make-product": "使用在庫統計",
  "analytics.dashboards.order-table": "テーブル統計",
  "analytics.today": "今日",
  "analytics.yesterday": "昨日",
  "analytics.7-days-ago": "7日前",
  "analytics.this-week": "今週",
  "analytics.last-week": "先週",
  "analytics.30-days-ago": "30日前",
  "analytics.this-month": "今月",
  "analytics.last-month": "先月",
  "analytics.all": "すべて",
  "analytics.compare": "比較",
  // 'analytics.update': 'Update',
  "analytics.revenue": "売上",
  "analytics.costs": "固定費",
  "analytics.profit": "利益",
  "analytics.invoice-quantity": "請求書数",
  "analytics.number-products-sold": "販売商品数",
  "analytics.average-selling-price": "平均販売価格",
  "analytics.total-product": "総商品数",
  "analytics.product": "商品",
  "analytics.amount-of-inventory": "在庫量",
  "analytics.items": "アイテム",
  "analytics.inventory-value": "在庫価値",

  /* product */
  "product.title": "商品追加",
  "product.title.update": "更新",
  "product.add-new": "新規追加",
  "product.tab.import-excel": "Excelからインポート",
  "product.tab.import-image": "画像からインポート",
  "product.notify.create-stock-success": "在庫の新規作成に成功しました",
  "product.notify.create-stock-error": "在庫の作成中にエラーが発生しました",
  "product.notify.no-detail": "商品の詳細を読み込めませんでした。",
  "product.import.result": "インポート結果",
  "product.import.choose-file": "商品インポート用Excelファイルを選択",
  "product.import.support-format": ".xlsxおよび.xls形式に対応",
  "product.import.download-template": "テンプレートをダウンロード",
  "product.placeholder.select-category": "カテゴリを選択または作成...",
  "product.image.change": "画像を変更",
  "product.image.select": "画像を選択",
  "category.confirm.delete": "削除",
  "product.error.invalid-data": "無効なデータ",
  "product.error.name-required": "商品名は必須です",
  "product.error.category-required": "商品カテゴリは必須です",
  "product.error.price-required": "販売価格は必須です",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "商品価格が無効です（0以上である必要があります）",
  "product.api.error.promo-price-invalid": "プロモーション価格が無効です（0以上である必要があります）",
  "product.api.error.barcode-invalid": "バーコードが無効です（8〜13桁の数字が必要です）",
  "product.api.error.sku-duplicate": "このSKUはすでにシステムに存在します",
  "product.api.error.category-not-found": "商品カテゴリが存在しません",
  "product.api.error.duplicate": "この商品はすでにシステムに存在します",
  "product.api.error.limit-reached": "商品数の上限に達しました。プランをアップグレードしてください！",
  "product.api.error.not-found": "商品が見つからないかアクセス権がありません",
  "product.api.error.variant-price-invalid": "バリエーション価格が無効です（0以上である必要があります）",
  "product.api.error.variant-promo-invalid": "バリエーションプロモーション価格が無効です（0以上である必要があります）",
  "product.api.error.import-missing-fields": "商品に名前またはカテゴリがありません",

  /* Product OCR */
  "product.ocr.title": "画像から商品を抽出",
  "product.ocr.description": "メニュー/価格表の画像をアップロードすると、AIが自動で商品を認識します。",
  "product.ocr.prompt-placeholder": "空欄 = ビジネスタイプに応じて自動認識",
  "product.ocr.choose-images": "画像を選択",
  "product.ocr.more-images": "枚の他の画像",
  "product.ocr.show-prompt": "AIプロンプトをカスタマイズ",
  "product.ocr.hide-prompt": "カスタムプロンプトを非表示",
  "product.ocr.extract-btn": "データ抽出",
  "product.ocr.extracting": "処理中...",
  "product.ocr.save-btn": "保存",
  "product.ocr.saving": "保存中...",
  "product.ocr.save-success": "商品のインポートに成功しました！",
  "product.ocr.items": "商品",
  "product.ocr.col-name": "商品名",
  "product.ocr.col-category": "カテゴリ",
  "product.ocr.col-size": "サイズ",
  "product.ocr.col-price": "販売価格",
  "product.ocr.col-price-sale": "セール価格",
  "product.ocr.col-barcode": "バーコード",
  "product.ocr.step-upload": "アップロード",
  "product.ocr.step-mapping": "列マッピング",
  "product.ocr.step-preview": "確認・保存",
  "product.ocr.mapping-title": "データ列のマッピング",
  "product.ocr.mapping-desc": "AIが左側の列を検出しました。右側の対応する商品フィールドにマッピングしてください。",
  "product.ocr.ai-column": "AI列",
  "product.ocr.db-field": "データフィールド",
  "product.ocr.status": "ステータス",
  "product.ocr.skip-column": "-- スキップ --",
  "product.ocr.mapped": "マッピング済",
  "product.ocr.rows-found": "行のデータ",
  "product.ocr.cols-mapped": "列マッピング済",
  "product.ocr.back": "戻る",
  "product.ocr.next": "続行",
  "product.ocr.reset": "リセット",
  "product.ocr.preview-title": "確認 & 保存",
  "product.ocr.stat-products": "商品",
  "product.ocr.stat-categories": "カテゴリ",
  "product.ocr.stat-with-price": "価格あり",
  "product.ocr.import-done": "完了！",
  "product.ocr.created": "新規作成",
  "product.ocr.updated": "更新",
  "product.ocr.skipped": "スキップ",
  "product.ocr.raw-result": "AI生データ：",
  "product.ocr.error-no-image": "少なくとも1枚の画像を選択してください。",
  "product.ocr.error-no-data": "画像からデータを抽出できませんでした。もう一度お試しください。",
  "product.ocr.error-extract": "画像分析中にエラーが発生しました。",
  "product.ocr.error-empty": "保存するデータがありません。",
  "product.ocr.error-save": "エラーが発生しました。もう一度お試しください。",
  "product.ocr.error-name-required": "続行するには「商品名」列のマッピングが必要です。",

  "pages.add-new": "新規追加",
  "pages.add-new-user-staff": "新規追加",
  "pages.add-new-log": "新規追加",
  "pages.order-new": "注文",
  "pages.image": "商品画像",
  "pages.add-new-modal-title": "新規追加",
  "pages.order-new-modal-title": "新規注文",
  "pages.update-modal-title": "商品更新",
  "pages.display-options": "オプションを表示",
  "pages.orderby": "並び替え: ",
  "pages.product-name": "商品名",
  "pages.product-barcode": "バーコード",
  "pages.product-sku": "商品コード",
  "pages.category": "カテゴリ",
  "pages.description": "説明",
  "pages.status": "ステータス",
  "pages.cancel": "キャンセル",
  "pages.submit": "送信",
  "pages.delete": "削除",
  "pages.delete-forever": "完全に削除",
  "pages.another-action": "他のアクション",
  "pages.update": "更新",
  "pages.price": "価格",
  "pages.select-category": "商品タイプを1つ選択",
  "pages.select-product": "商品を1つ選択",
  "pages.order-number": "重量",
  "pages.no-selected": "アクションなし",
  "pages.order-more": "商品追加",
  "pages.total-order-price": "合計金額",
  "pages.current-order-price": "現在の注文金額",
  "pages.error-title": "おっと... エラーが発生しました！",
  "pages.error-code": "エラー",
  "pages.go-back-home": "ホームに戻る",
  "pages.softhide": "商品を一時非表示",
  "pages.un-softhide": "商品を再表示",
  "pages.bestter": "おすすめ商品",
  "pages.un-bestter": "おすすめ解除",
  "pages.print-tem": "ラベル印刷",
  "pages.expand": "バリエーションを表示",
  "pages.collapse": "折りたたみ",

  "product.title": "商品情報",
  "product.price.original": "価格",
  "product.price.sale": "プロモーション価格",
  "product.price.cost": "原価",
  "product.quantity": "数量",
  "product.inventory": "在庫",
  "product.ice": "氷の量",
  "product.sugar": "甘さ",
  "product.size": "サイズ",
  "product.topping": "トッピング",
  "product.color": "色",
  "product.material": "素材",
  "product.add.name": "名前",
  "product.add.value": "追加料金",
  "product.add_price": "追加価格",
  "product.update_cost": "原価更新",
  "product.edit_cost": "原価編集",
  "product.search": "検索",
  "product.variants": "バリエーション",
  "product.variant-name": "バリエーション名",
  "product.sku": "SKU",
  "product.price": "価格",
  "product.stock": "在庫",
  "product.promo-time": "プロモーション期間",

  /* 07.Category */
  "category.add-new-modal-title": "新規追加",
  "category.update-title": "商品カテゴリ更新",
  "category.title": "商品名",
  "category.thumb-list": "商品タイプ",
  "category.nav-tab": "カテゴリ",
  "category.add-new-category": "新規追加",
  "category.btn-add": "カテゴリ追加",

  /* 08.Todo */
  "todo.add-new": "新規追加",
  "todo.thumb-list": "イベント",
  "todo.add-new-modal-title": "新規追加",
  "todo.update-modal-title": "イベント更新",
  "todo.title": "イベント名",
  "todo.description": "説明",
  "todo.date": "日付",
  "todo.time": "時間",
  "todo.update-done": "完了",
  "todo.update-pending": "保留中",
  "todo.delete": "削除",
  "todo.no-selected": "アクションなし",
  "todo.update": "更新",
  "todo.date-time": "時間",
  "todo.orderby": "並び替え: ",
  "todo.btn-add": "イベント追加",

  /*table setting */
  "table-setting.row": "行",
  "table-setting.col": "列",
  "table-setting.floor": "エリア",
  "table-setting.btn-generate": "テーブル作成",
  "table-setting.map": "マップ",
  "table-setting.btn-save": "保存",
  "table-setting.title": "テーブル・座席設定",

  /* stock */
  "stock.thumb-list": "在庫",
  "stock.add-new-modal-title": "新規追加",
  "stock.name": "名前",
  "stock.unit": "単位",
  "stock.unit-price": "仕入価格",
  "stock.unit-price-update": "仕入価格",
  "stock.unit-price-new": "新仕入価格",
  "stock.price": "価格",
  "stock.count": "数量",
  "stock.count-new": "数量",
  "stock.delete": "削除",
  "stock.reset": "0にリセット",
  "stock.count-update": "在庫更新",
  "stock.count-edit": "在庫編集",
  "stock.count-current": "残り",
  "stock.count-total": "総輸入",
  "stock.update-title": "在庫追加更新",
  "stock.search": "検索",
  "stock.btn-add": "在庫追加",

  /* warehouse */
  "warehouse.add-new-modal-title": "新規追加",
  "warehouse.phone": "電話番号",
  "warehouse.address": "住所",
  "warehouse.code": "コード",
  "warehouse.unit": "単位",
  "warehouse.description": "説明",
  "warehouse.btn-add": "追加",

  "warehouse.import-search": "入庫検索",
  "warehouse.import": "インポート",
  "warehouse.import-stock": "入庫品目",
  "warehouse.import-title": "入庫更新",
  "warehouse.import-name": "入庫担当者名",
  "warehouse.import-quantity": "数量",
  "warehouse.import-price": "入庫価格",
  "warehouse.btn-add-import": "作成",

  "warehouse.export-search": "出荷検索",
  "warehouse.export": "エクスポート",
  "warehouse.export-stock": "出荷品目",
  "warehouse.export-title": "出荷更新",
  "warehouse.export-name": "出庫担当者名",
  "warehouse.export-quantity": "数量",
  "warehouse.export-price": "出荷価格",
  "warehouse.btn-add-export": "作成",

  "warehouse.transfer-search": "在庫移動検索",
  "warehouse.transfer": "在庫移動伝票",
  "warehouse.transfer-stock": "移動品目",
  "warehouse.transfer-title": "在庫移動伝票更新",
  "warehouse.transfer-name": "移動担当者名",
  "warehouse.transfer-quantity": "数量",
  "warehouse.transfer-price": "移動価格",
  "warehouse.transfer-name-carrier": "配送業者名",
  "warehouse.transfer-phone-carrier": "配送業者電話番号",
  "warehouse.transfer-receiving-warehouse": "移動先倉庫",
  "warehouse.transportation": "輸送手段",
  "warehouse.cost-transfer": "輸送費",
  "warehouse.btn-add-transfer": "作成",

  /* make product */
  "make-product.thumb-list": "レシピ一覧",
  "make-product.add-new-modal-title": "新規追加",
  "make-product.name": "名前",
  "make-product.unit": "単位",
  "make-product.count": "数量",
  "make-product.make-more": "追加",
  "make-product.product-name": "商品名",
  "make-product.stock-name": "在庫名",
  "make-product.select-stock": "在庫を1つ選択",
  "make-product.add-modal-title": "新規追加",
  "make-product.update-modal-title": "編集",
  "make-product.number-product-used": "使用在庫数",
  "make-product.price": "価格",
  "make-product.cost": "原価",
  "make-product.percent-cost": "原価率",
  "make-product.btn-add": "作成",

  /* FAQ */
  "faq.title": "ガイド",
  "faq.text-title": "質問",
  "faq.text-content": "回答",
  "faq.modal-title": "Q&A",

  /** Ref */
  "ref.name": "名前",
  "ref.companyName": "店舗名",
  "ref.email": "メール",
  "ref.phone": "電話番号",
  "ref.address": "住所",
  "ref.content": "コンテンツ",
  "ref.title": "紹介者情報",
  "ref.btn-submit": "送信",

  /** Chat */
  "chat.messages": "メッセージ",
  "chat.messages-inbox": "受信トレイ",
  "chat.messages-new": "電話帳",
  "chat.start-conversation": "会話を開始！",

  /** Discount */
  "discount.add-new-modal-title": "新規追加",
  "discount.note": "メモ",
  "discount.type": "割引タイプ",
  "discount.value": "割引額",
  "discount.user": "スタッフ",
  "discount.products": "商品",
  "discount.select-all-products": "全商品",
  "discount.select-one-type": "値タイプを選択",
  "discount.select-one-product": "商品を1つ選択",
  "discount.select-one-type-product": "商品タイプを1つ選択",
  "discount.to-bill": "他を追加",
  "discount.add-feetax": "割引・税金・手数料を追加",
  "discount.discount": "割引",
  "discount.tax": "税金",
  "discount.fee-other": "その他手数料",
  "order.adjustment.add-products-first":
    "コードを入力する前に商品を追加してください",
  "order.adjustment.invalid-code": "無効なプロモーションコード",
  "order.adjustment.apply": "適用",
  "order.adjustment.note-optional": "メモ（任意）",
  "order.adjustment.promo-code": "プロモーションコード",
  "order.adjustment.promo-placeholder": "プロモーションコードを入力",
  "order.adjustment.coupon-help":
    "コードを入力して適用すると割引が反映されます。",
  "order.adjustment.remove-code": "プロモーションコードを削除",
  "order.adjustment.discount-value": "割引額",
  "order.adjustment.estimated-discount": "割引予定額",
  "order.adjustment.discount-note-placeholder": "例：常連のお客様",
  "order.adjustment.subtotal": "小計",
  "order.adjustment.total-after-discount": "割引後合計",
  "order.adjustment.tax-title": "税金を追加",
  "order.adjustment.tax-rate": "税率",
  "order.adjustment.other": "その他",
  "order.adjustment.tax-value": "税額",
  "order.adjustment.estimated-tax": "予定税額",
  "order.adjustment.calculation": "計算方法",
  "order.adjustment.tax-added": "注文に追加",
  "order.adjustment.tax-added-help": "税金は支払合計に追加されます。",
  "order.adjustment.tax-included": "価格に含む",
  "order.adjustment.tax-included-help":
    "税金は商品またはサービス価格に含まれています。",
  "order.adjustment.tax-note-placeholder": "例：小売販売の消費税",
  "order.adjustment.total-payment": "支払合計",
  "order.adjustment.fee-title": "追加料金を追加",
  "order.adjustment.fee-name": "追加料金名",
  "order.adjustment.shipping-fee": "配送料",
  "order.adjustment.service-fee": "サービス料",
  "order.adjustment.packing-fee": "梱包料",
  "order.adjustment.other-fee": "その他手数料",
  "order.adjustment.fee-value": "追加料金額",
  "order.adjustment.estimated-fee": "予定追加料金",
  "order.adjustment.apply-on": "適用対象",
  "order.adjustment.calculation-base": "追加料金の計算基準",
  "order.adjustment.fixed-fee-base-help":
    "VNDの固定追加料金は計算基準に依存しません。",
  "order.adjustment.after-discount": "割引後合計",
  "order.adjustment.fee-note-placeholder": "例：市内配送",

  /** Customer */
  "customer.add-new-modal-title": "新規追加",
  "customer.title": "情報",
  "customer.name": "名前",
  "customer.phone": "電話番号",
  "customer.email": "メール",
  "customer.address": "住所",
  "customer.point": "ポイント",
  "customer.armorial": "ランク",
  "customer.used-item": "利用回数",
  "customer.tags": "タグ",
  "customer.info": "情報",
  "customer.used": "購入商品",
  "customer.setting": "設定",
  "customer.search": "検索",
  "customer.btn-add": "作成",
  "customer.amount-spent": "総支出額",
  "customer.debt": "借金",

  /** Income, Outcome, Treasury */
  action: "アクション",
  name: "名前",
  phone: "電話番号",
  email: "メール",
  address: "住所",
  price: "価格",
  note: "説明",
  time: "統計",
  "time-created": "作成日時",
  "user.created": "作成ユーザー",
  "select-one-time": "タイプを1つ選択",
  "select-one-time-discount": "割引タイプを1つ選択",
  "select-one-time-gift": "ギフトタイプを1つ選択",

  "income.title": "収入",
  "income.sub_title": "タイトル",
  "income.add-new-modal-title": "新規追加",
  "income.name": "名前",
  "income.search": "検索",
  "income.btn-add": "作成",

  "outcome.title": "支出",
  "outcome.sub_title": "タイトル",
  "outcome.add-new-modal-title": "新規追加",
  "outcome.name": "名前",
  "outcome.search": "検索",
  "outcome.btn-add": "作成",

  "treasury.name": "名前",
  "treasury.title": "資金",
  "treasury.add-new-modal-title": "新規追加",
  "treasury.timeCreated": "作成日時",
  "treasury.search": "検索",
  "treasury.btn-add": "作成",

  /** Break Event */
  "breakeven.title": "損益分岐点",

  /** Company Provider */
  "company-provider.info": "情報",
  "company-provider.title": "サプライヤー",
  "company-provider.title-log": "取引追加",
  "company-provider.title-log-add": "取引追加",
  "company-provider.title-log-add-more": "追加支払い",
  "company-provider.add-new-modal-title": "新規追加",
  "company-provider.name": "名前",
  "company-provider.item_name": "項目",
  "company-provider.total_price_income": "総入庫額",
  "company-provider.total_price_outcome": "支払済",
  "company-provider.total_price_pending": "残り",
  "company-provider.item_product": "供給品目",
  "company-provider.price": "価格",
  // 'company-provider.name': 'Name of supplier',
  "company-provider.search": "検索",
  "company-provider.btn-add": "作成",
  "company-provider.transaction": "取引",
  "company-provider.sku": "SKU",
  "company-provider.price_new": "価格",
  "company-provider.quantity": "数量",
  "company-provider.debt": "借金",
  "company-provider.total": "合計",
  "company-provider.time": "時間",
  "company-provider.action": "アクション",

  /** User Staff */
  "user-staff.title": "スタッフ情報",
  "user-staff.add-new-modal-title": "新規追加",
  "user-staff.add-new-logs-modal-title": "新規追加",
  // 'user-staff.title': 'Staff',
  "user-staff.permission_name": "職位",
  "user-staff.date_join": "入社日",
  "user-staff.date_get_salary": "給与支払日",
  "user-staff.hour_working_on_day": "1日の労働時間",
  "user-staff.status_working": "就労状況",
  "user-staff.salary_by": "給与計算方法",
  "user-staff.salary_value": "賃金",
  "user-staff.working_hours": "労働時間",
  "user-staff.current_commission": "コミッション",
  "user-staff.current_bonus": "ボーナス",
  "user-staff.current_overtime": "残業手当",
  "user-staff.current_advence": "前払い",
  "user-staff.current_fined": "罰金",
  "user-staff.current_dayoff": "休暇手当",
  "user-staff.current_day_working": "今月の出勤日数",
  "user-staff.current_salary": "今月の給与",
  "user-staff.total_salary": "総給与",
  "user-staff.total_day_working": "総出勤日数",
  "user-staff.working_hours_from": "* 勤務開始",
  "user-staff.working_hours_to": "* 勤務終了",
  "user-staff.logs_users_staff": "名前",
  "user-staff.logs_type": "タイプ",
  "user-staff.logs_value_salary": "金額",
  "user-staff.logs_value_hour": "時間",
  "user-staff.overtime_coefficient": "残業係数",
  "user-staff.select-all-users": "スタッフを選択",
  "user-staff.select-one": "タイプを1つ選択",
  "user-staff.name": "名前",
  "user-staff.phone": "電話番号",
  "user-staff.address": "住所",
  "user-staff.email": "メール",
  "user-staff.search": "検索",
  "user-staff.btn-add": "作成",
  "user-staff.add-log-title": "スタッフ給与情報を追加",
  "user-staff.kpi.total": "スタッフ総数",
  "user-staff.kpi.active": "勤務中",
  "user-staff.kpi.inactive": "退職",
  "user-staff.kpi.manager": "管理者",
  "user-staff.kpi.revenue-today": "本日の売上",
  "user-staff.kpi.current": "現在のデータ",
  "user-staff.kpi.current-page": "現在のページ",
  "user-staff.kpi.today": "本日",
  "user-staff.search-placeholder": "スタッフを検索...",
  "user-staff.filter.position-all": "職位：すべて",
  "user-staff.filter.status-all": "状態：すべて",
  "user-staff.filter.shift-all": "シフト：すべて",
  "user-staff.filter.clear": "フィルター",
  "user-staff.table.employee": "スタッフ",
  "user-staff.table.position": "職位",
  "user-staff.table.shift": "シフト",
  "user-staff.table.phone": "電話",
  "user-staff.table.revenue-today": "本日の売上",
  "user-staff.table.bills": "伝票",
  "user-staff.table.status": "状態",
  "user-staff.table.action": "操作",
  "user-staff.action.call": "電話",
  "user-staff.action.message": "メッセージ",
  "user-staff.action.edit": "編集",
  "user-staff.action.more": "その他",
  "user-staff.action.delete": "削除",
  "user-staff.empty": "スタッフデータがありません",
  "user-staff.detail.empty": "スタッフを選択して詳細を表示",
  "user-staff.detail.tab.info": "情報",
  "user-staff.detail.tab.schedule": "勤務予定",
  "user-staff.detail.tab.performance": "実績",
  "user-staff.detail.tab.salary": "給与",
  "user-staff.detail.tab.permission": "権限",
  "user-staff.detail.basic": "基本情報",
  "user-staff.detail.staff-code": "スタッフコード",
  "user-staff.detail.birthday": "生年月日",
  "user-staff.detail.schedule": "勤務予定",
  "user-staff.detail.performance": "本日の実績",
  "user-staff.detail.salary": "給与",
  "user-staff.detail.permission": "権限",
  "user-staff.detail.dynamic-fields": "カスタム項目",
  "user-staff.today.revenue": "売上",
  "user-staff.today.bills": "伝票数",
  "user-staff.today.products": "対応商品",
  "user-staff.today.revenue-per-hour": "売上/時",
  "user-staff.total.revenue": "総売上",

  /** Role */
  "role.name": "名前",
  "role.title": "権限分散",
  "role.add-new-modal-title": "新規追加",
  "role.btn-add": "作成",

  /** User Role */
  "user-role.title": "権限分散編集",
  "user-role.name": "名前",
  "user-role.add-new-modal-title": "新規追加",
  "user-role.select-one": "権限を選択",
  "user-role.place-holder-password": "変更しない場合は空欄",
  "user-role.btn-add": "作成",

  /** Form Dynamic */
  "form-dynamic.title": "フォームカスタマイズ",
  "form-dynamic.add-new-modal-title": "新規追加",
  "form-dynamic.label": "タイトル",
  "form-dynamic.alias": "フォームタイプ",
  "form-dynamic.select-one-alias": "フォームを1つ選択",
  "form-dynamic.type": "データ型",
  "form-dynamic.select-one-type": "タイプを1つ選択",
  "form-dynamic.btn-add": "作成",

  "url.placeholder": "http:// または https://",

  /** Compananies */
  "companies.find-company-uuid": "店舗コード検索",
  "companies.title": "店舗連携",
  "companies.add-new-modal-title": "新規追加",
  "companies.name": "名前",
  "companies.type": "タイプ",
  "companies.unset": "リンクなし",
  "companies.btn-add": "作成",

  /** Promotion */
  "promotion.thumb-list": "プロモーション",
  "promotion-add": "新規追加",
  "promotion-update": "更新",
  "promotion-name": "プロモーション名",
  "promotion-code": "コード",
  "promotion-quantity": "適用数量",
  "promotion-description": "説明",
  "promotion-max-per-customer": "顧客ごとの最大使用回数",
  "promotion-date_start": "開始時間",
  "promotion-date_end": "終了時間",
  "promotion-isAutoUse": "自動有効化",

  /** Calendar */
  "calendar.add-event": "イベント追加",

  /** Booking */
  "menu.booking": "予約",
  "booking.title": "予約管理",
  "booking.add-new": "新規追加",
  "booking.today": "今日",
  "booking.week": "今週",
  "booking.month": "今月",
  "booking.calendar": "カレンダー",
  "booking.settings": "設定",
  "booking.customer-name": "顧客名",
  "booking.customer-phone": "電話番号",
  "booking.customer-email": "メール",
  "booking.date": "予約日",
  "booking.time": "到着時間",
  "booking.party-size": "人数",
  "booking.table": "テーブル",
  "booking.special-requests": "特別リクエスト",
  "booking.notes": "メモ",
  "booking.status": "ステータス",
  "booking.status.pending": "保留中",
  "booking.status.confirmed": "確認済",
  "booking.status.cancelled": "キャンセル",
  "booking.status.completed": "完了",
  "booking.status.no_show": "無断キャンセル",
  "booking.deposit": "手付金",
  "booking.deposit-required": "手付金必須",
  "booking.deposit-amount": "手付金金額",
  "booking.confirm": "確認",
  "booking.cancel": "キャンセル",
  "booking.complete": "完了",
  "booking.source": "ソース",
  "booking.no-bookings": "予約はまだありません",

  /** Wizard */
  "wizard.title": "セットアップウィザード",
  "wizard.next": "次へ",
  "wizard.prev": "前へ",
  "wizard.finish": "完了",
  "wizard.skip": "スキップ",
  "wizard.step-name-1": "ステップ 1",
  "wizard.step-desc-1": "基本情報",
  "wizard.step-name-2": "ステップ 2",
  "wizard.step-desc-2": "商品追加",
  "wizard.step-name-3": "ステップ 3",
  "wizard.step-desc-3": "支払い情報",
  "wizard.content-thanks": "ありがとうございます！",

  /* Facebook Settings */
  "facebook.settings-title": "Facebookファンページ",
  "facebook.config-guide": "Webhook設定 (開発者向け):",
  "facebook.callback-url": "コールバックURL:",
  "facebook.verify-token": "確認トークン:",
  "facebook.fields": "フィールド:",
  "facebook.guide": "ガイド",
  "facebook.guide-step-1": "'新しいファンページを接続'をクリック",
  "facebook.guide-step-2": "Facebookにログイン (必要な場合)",
  "facebook.guide-step-3": "接続したいファンページを選択",
  "facebook.guide-step-4": "アプリに権限を付与",
  "facebook.guide-step-5": "完了！",
  "facebook.connect-new": "新しいファンページを接続",
  "facebook.how-to-connect": "ファンページの接続方法:",
  "facebook.upgrade-now": "今すぐアップグレード",
  "facebook.connect-new-locked":
    "新しいファンページを接続 (ベーシックプランが必要)",
  "facebook.loading": "読み込み中...",
  "facebook.no-pages": "接続されたファンページはまだありません。",
  "facebook.page-name": "ページ名",
  "facebook.page-id": "ページID",
  "facebook.connected-date": "接続日",
  "facebook.action": "アクション",
  "facebook.disconnect": "切断",
  "facebook.go-to-messenger": "チャットへ移動",
  "facebook.manual.btn": "手動トークン",
  "facebook.manual.title": "ページアクセストークンで接続",
  "facebook.manual.desc":
    "下記にページアクセストークンを貼り付けてください。Facebook Developer ToolsまたはBusiness Suiteから取得できます。",
  "facebook.manual.guide": "トークン取得方法",
  "facebook.manual.guide-title": "ページアクセストークンの取得方法:",
  "facebook.manual.guide-step-1":
    "Facebook Graph API Explorer (developers.facebook.com/tools/explorer) にアクセス",
  "facebook.manual.guide-step-2": "アプリと接続するファンページを選択",
  "facebook.manual.guide-step-3":
    "権限を付与: pages_show_list, pages_messaging, pages_read_engagement",
  "facebook.manual.guide-step-4":
    "'Generate Access Token'をクリックしてトークンをコピー",
  "facebook.manual.placeholder": "ここにページアクセストークンを貼り付け...",
  "facebook.manual.connect-btn": "接続",
  "facebook.manual.connecting": "接続中...",
  "facebook.manual.error-empty": "ページアクセストークンを入力してください",
  "facebook.manual.error-failed": "接続に失敗しました。トークンを確認してください。",
  "facebook.manual.error-no-selection": "接続するファンページを少なくとも1つ選択してください",
  "facebook.manual.check-btn": "確認",
  "facebook.manual.checking": "確認中...",
  "facebook.manual.select-pages": "接続するファンページを選択:",
  "facebook.manual.select-all": "すべて選択",
  "facebook.manual.deselect-all": "すべて解除",
  "facebook.manual.pages-selected": "ページ選択済み",

  /* Settings - General */
  "settings.general": "一般設定",
  "settings.general.ui-title": "UI外観",
  "settings.general.font-size-label": "フォントサイズ",
  "settings.general.font-size-small": "小",
  "settings.general.font-size-large": "大",
  "settings.general.report-title": "レポート設定",
  "settings.general.daily-report-time": "日次レポート時間",
  "settings.general.select-time-placeholder": "時間を選択...",

  /* Settings - Invoice */
  "settings.invoice.title": "請求書設定",
  "settings.invoice.section-1": "1. 顧客請求書設定",
  "settings.invoice.print-at-counter": "カウンター注文時に請求書を印刷",
  "settings.invoice.section-2": "2. キッチンチケット設定",
  "settings.invoice.section-3": "3. 注文プロセスワークフロー",
  "settings.invoice.process-1": "注文して即座に完了",
  "settings.invoice.process-2": "注文 > キッチン > 完了",
  "settings.invoice.process-3": "注文 > 会計 > 完了",
  "settings.invoice.process-4": "注文 > レジ > バー/キッチン > 完了",
  "settings.invoice.process-4-title": "4. QRコードによる注文プロセスフロー",

  /* Settings - Email */
  "settings.email.title": "メール設定",
  "settings.email.guide-title": "Gmailアプリパスワードの作成方法:",
  "settings.email.guide-step-1": "Googleアカウントへ移動",
  "settings.email.guide-step-2": "セキュリティ → 2段階認証をオン",
  "settings.email.guide-step-3":
    '"アプリパスワード"を検索、またはここをクリック',
  "settings.email.guide-step-5": "16文字のパスワードをコピー",
  "settings.email.smtp-custom-title": "カスタムSMTP:",
  "settings.email.mode-default": "VMASSデフォルトメールを使用",
  "settings.email.mode-custom": "カスタムメールを使用",
  "settings.email.type-label": "メールタイプ",
  "settings.email.type-gmail": "Gmail (アプリパスワード)",
  "settings.email.type-smtp": "カスタムSMTP (Zoho, Office 365...)",
  "settings.email.address-label": "メールアドレス",
  "settings.email.password-label": "メールパスワード",
  "settings.email.app-password-label": "アプリパスワード",
  "settings.email.create-app-password": "ここでアプリパスワードを作成",
  "settings.email.smtp-server-config": "SMTPサーバー設定",
  "settings.email.smtp-host": "SMTPホスト",
  "settings.email.smtp-port": "ポート",
  "settings.email.smtp-secure": "セキュリティ",
  "settings.email.quick-config": "クイック設定:",
  "settings.email.test-button": "テストメール送信",
  "settings.email.save-button": "設定保存",
  "settings.email.saving": "保存中...",
  "settings.email.success": "成功",
  "settings.email.guide-button": "ガイド",

  /* Settings - Shipping */
  "settings.shipping.title": "配送設定",
  "settings.shipping.upgrade-btn": "今すぐアップグレード",
  "settings.shipping.business-type-label": "ビジネスタイプ:",
  "settings.business.cafe": "カフェ",
  "settings.business.restaurant": "レストラン",
  "settings.business.retail": "小売",
  "settings.business.other": "その他",
  "settings.shipping.connected-title": "接続済みプロバイダー",
  "settings.shipping.edit-btn": "編集",
  "settings.shipping.disconnect-btn": "切断",
  "settings.shipping.available-title": "利用可能なプロバイダー",
  "settings.shipping.status-connected": "接続済み",
  "settings.shipping.connect-btn": "今すぐ接続",
  "settings.shipping.guide-title": "手順",
  "settings.shipping.modal.connect-title": "{name} を接続",
  "settings.shipping.modal.token": "APIトークン",
  "settings.shipping.modal.shop-id": "ショップID",
  "settings.shipping.modal.client-id": "クライアントID",
  "settings.shipping.modal.secret-key": "シークレットキー",
  "settings.shipping.modal.token-placeholder":
    "プロバイダーからのAPIトークンを入力",
  "settings.shipping.modal.shop-id-placeholder": "ショップIDを入力 (ある場合)",
  "settings.shipping.modal.client-id-placeholder": "クライアントIDを入力",
  "settings.shipping.modal.secret-key-placeholder": "シークレットキーを入力",
  "settings.shipping.modal.origin-title": "ショップ発地住所",
  "settings.shipping.modal.province": "省/市",
  "settings.shipping.modal.district": "郡/区",
  "settings.shipping.modal.ward": "区/町",
  "settings.shipping.modal.select-province": "省/市を選択",
  "settings.shipping.modal.select-district": "郡/区を選択",
  "settings.shipping.modal.select-ward": "区/町を選択",
  "settings.shipping.modal.cancel": "キャンセル",
  "settings.shipping.modal.connect": "接続",
  "settings.shipping.modal.connecting": "接続中...",
  "settings.shipping.alert.missing-token": "APIトークンを入力してください",
  "settings.shipping.alert.connect-success": "接続に成功しました",
  "settings.shipping.alert.connect-error": "接続エラー",
  "settings.shipping.alert.disconnect-success": "切断に成功しました",
  "settings.shipping.alert.disconnect-error": "切断エラー",
  "settings.shipping.guide.ghn.step1": "api.ghn.vnへ移動",
  "settings.shipping.guide.ghn.step2": "アカウント登録/ログイン",
  "settings.shipping.guide.ghn.step3": '"ドキュメント"へ移動してトークンを取得',
  "settings.shipping.guide.ghn.step4": "トークンとショップIDをフォームに入力",
  "settings.shipping.guide.ghtk.step2": '"ショップ情報"または"API管理"へ移動',
  "settings.shipping.guide.ghtk.step3": "APIトークンをコピー",
  "settings.shipping.guide.viettel.step1": "partner.viettelpost.vnへログイン",
  "settings.shipping.guide.viettel.step2": '"アカウント設定"へ移動',
  "settings.shipping.guide.viettel.step3": "APIトークンをコピー",
  "settings.shipping.guide.jt.step1": "パートナー登録のためJ&Tに連絡",
  "settings.shipping.guide.jt.step2": "クライアントIDとシークレットキーを取得",
  "settings.shipping.modal.token-guide.jt": "APIアカウント取得のためJ&Tに連絡",

  /* Settings - Customer */
  "settings.customer.tier.bronze": "ブロンズ",
  "settings.customer.tier.silver": "シルバー",
  "settings.customer.tier.gold": "ゴールド",
  "settings.customer.tier.diamond": "ダイヤモンド",
  "settings.customer.alert.success": "成功",
  "settings.customer.alert.error": "エラー",
  "settings.customer.alert.missing-info": "すべての情報を入力してください",
  "settings.customer.alert.min-tiers": "少なくとも1つの顧客ランクが必要です",
  "settings.customer.loading": "読み込み中...",
  "settings.customer.saving": "保存中...",
  "settings.customer.point-rule": "ポイント付与ルール",
  "settings.customer.point-value": "1ポイント =",
  "settings.customer.currency": "VND",
  "settings.customer.tier-title": "ポイントマイルストーン & 顧客ランク",
  "settings.customer.add-tier": "ランク追加",
  "settings.customer.new-tier": "新規ランク",
  "settings.customer.table.color": "色",
  "settings.customer.table.name": "名前",
  "settings.customer.table.points": "最低ポイント",
  "settings.customer.table.actions": "アクション",
  "settings.customer.placeholder.name": "名前",
  "settings.customer.placeholder.points": "ポイント",
  "settings.customer.points-suffix": "ポイント",
  "settings.customer.note-title": "メモ:",
  "settings.customer.save-btn": "変更を保存",

  /* Settings - Staff */
  "settings.staff.alert.load-error": "設定を読み込めません",
  "settings.staff.alert.save-success": "設定が正常に保存されました！",
  "settings.staff.alert.save-error": "設定を保存できません",
  "settings.staff.alert.position-exists": "この職位は既に存在します",
  "settings.staff.shift-title": "勤務シフト設定",
  "settings.staff.add-shift": "シフト追加",
  "settings.staff.from": "開始",
  "settings.staff.to": "終了",
  "settings.staff.delete": "削除",
  "settings.staff.position-title": "職位",
  "settings.staff.add-position": "新規職位追加",
  "settings.staff.position-placeholder": "職位名を入力...",
  "settings.staff.save-btn": "設定保存",
  "settings.staff.saving": "保存中...",

  /* Settings - Partner & API */
  "settings.partner.title": "APIキー",
  "settings.partner.doc-btn": "統合ドキュメント",
  "settings.partner.create-btn": "+ APIキー作成",
  "settings.partner.alert.create-error": "APIキー名を入力してください",
  "settings.partner.alert.create-success": "APIキーが正常に作成されました！",
  "settings.partner.alert.create-fail": "APIキー作成失敗",
  "settings.partner.alert.revoke-title": "APIキー削除",
  "settings.partner.alert.revoke-success": "APIキーが取り消されました",
  "settings.partner.alert.revoke-fail": "APIキー取り消し失敗: ",
  "settings.partner.alert.regenerate-title": "APIキー再生成",
  "settings.partner.alert.regenerate-fail": "APIキー再生成失敗",
  "settings.partner.alert.update-fail": "APIキー更新失敗",
  "settings.partner.analytics.total": "総リクエスト",
  "settings.partner.analytics.today": "今日",
  "settings.partner.analytics.success-rate": "成功率",
  "settings.partner.analytics.avg-time": "平均時間",
  "settings.partner.table.name": "名前",
  "settings.partner.table.keys": "APIキー",
  "settings.partner.table.permissions": "権限",
  "settings.partner.table.note": "メモ",
  "settings.partner.table.action": "アクション",
  "settings.partner.modal.create.title": "新規APIキー作成",
  "settings.partner.modal.create.name": "名前",
  "settings.partner.modal.create.permissions": "権限",
  "settings.partner.modal.create.env": "API環境",
  "settings.partner.modal.create.env-test": "テスト (サンドボックス)",
  "settings.partner.modal.create.env-live": "ライブ (本番)",
  "settings.partner.modal.create.desc": "説明",
  "settings.partner.modal.create.cancel": "キャンセル",
  "settings.partner.modal.create.submit": "送信",
  "settings.partner.modal.create.submitting": "作成中...",
  "settings.partner.modal.result.title": "APIキー作成済",
  "settings.partner.modal.result.copy": "コピー",
  "settings.partner.modal.result.copied": "✓ コピーしました！",
  "settings.partner.modal.result.copy-alert":
    "APIキーをクリップボードにコピーしました！",
  "settings.partner.modal.result.expires": "有効期限:",
  "settings.partner.modal.result.close": "保存済",

  /* Partner Permissions */
  "settings.partner.perm.orders-read": "注文読み取り",
  "settings.partner.perm.orders-write": "注文書き込み",
  "settings.partner.perm.products-read": "商品読み取り",
  "settings.partner.perm.products-write": "商品書き込み",
  "settings.partner.perm.inventory-read": "在庫読み取り",
  "settings.partner.perm.inventory-write": "在庫書き込み",
  "settings.partner.perm.recipes-read": "レシピ読み取り",
  "settings.partner.perm.recipes-write": "レシピ書き込み",
  "settings.partner.perm.customers-read": "顧客読み取り",
  "settings.partner.perm.customers-write": "顧客書き込み",
  "settings.partner.perm.user-read": "ユーザー情報読み取り",

  "settings.partner.env.live-label": "ライブ:",
  "settings.partner.create-btn-pro-auto": "+ APIキー作成 (Pro Auto)",
  "settings.partner.list-title": "APIキーリスト",
  "settings.partner.upgrade-alert.text": "アップグレードが必要です",
  "settings.partner.upgrade-alert.link": "今すぐアップグレード",
  "settings.partner.modal.confirm.cancel": "キャンセル",
  "settings.partner.modal.confirm.confirm": "確認",

  "settings.webhook.title": "Webhookサブスクリプション",
  "settings.webhook.doc-btn": "APIドキュメント",
  "settings.webhook.create-btn": "+ Webhook作成",
  "settings.webhook.create-btn-pro-auto": "+ Webhook作成 (Pro Auto)",
  "settings.webhook.upgrade-alert.text": "アップグレードが必要です",
  "settings.webhook.upgrade-alert.action": "Webhookを使用するためのプラン。",
  "settings.webhook.upgrade-alert.link": "今すぐアップグレード",

  "settings.webhook.alert.create-success": "Webhookが正常に作成されました！",
  "settings.webhook.alert.create-error": "情報を確認してください。",
  "settings.webhook.alert.create-fail": "Webhook作成失敗",
  "settings.webhook.alert.delete-success": "Webhook削除済",
  "settings.webhook.alert.delete-fail": "Webhook削除失敗",
  "settings.webhook.alert.update-fail": "Webhook更新失敗",
  "settings.webhook.alert.rotate-fail": "シークレットキー再生成失敗",

  "settings.webhook.table.url": "URL",
  "settings.webhook.table.events": "イベント",
  "settings.webhook.table.status": "ステータス",
  "settings.webhook.table.last-triggered": "最終トリガー",
  "settings.webhook.table.action": "アクション",
  "settings.webhook.status.active": "有効",
  "settings.webhook.status.inactive": "無効",

  "settings.webhook.modal.create.title": "新規Webhook作成",
  "settings.webhook.modal.create.url-label": "Webhook URL *",
  "settings.webhook.modal.create.events-label": "イベント選択 *",
  "settings.webhook.modal.create.events-placeholder": "イベントを選択...",
  "settings.webhook.modal.create.cancel": "キャンセル",
  "settings.webhook.modal.create.submit": "送信",
  "settings.webhook.modal.create.submitting": "作成中...",

  "settings.webhook.modal.secret.title": "Webhookシークレットキー",
  "settings.webhook.modal.secret.copy": "コピー",
  "settings.webhook.modal.secret.copied": "✓ コピーしました！",
  "settings.webhook.modal.secret.verify-guide": "署名の検証方法:",
  "settings.webhook.modal.secret.close": "シークレットキー保存済",

  "settings.webhook.modal.logs.title": "Webhook配信履歴",
  "settings.webhook.modal.logs.empty": "ログが見つかりません",
  "settings.webhook.modal.logs.time": "時間",
  "settings.webhook.modal.logs.event": "イベント",
  "settings.webhook.modal.logs.status": "ステータス",
  "settings.webhook.modal.logs.response-time": "応答時間",
  "settings.webhook.modal.logs.close": "閉じる",

  "settings.webhook.modal.confirm.title": "確認",
  "settings.webhook.modal.confirm.cancel": "キャンセル",
  "settings.webhook.modal.confirm.confirm": "確認",

  "settings.webhook.event.order.created": "新規注文作成",
  "settings.webhook.event.order.paid": "注文支払完了",
  "settings.webhook.event.order.shipped": "注文発送",
  "settings.webhook.event.order.completed": "注文完了",
  "settings.webhook.event.order.cancelled": "注文キャンセル",
  "settings.webhook.event.product.updated": "商品更新",
  "settings.webhook.event.inventory.low_stock": "在庫僅少",
  "settings.webhook.event.inventory.expiring": "在庫期限切れ",
  "settings.webhook.event.customer.created": "新規顧客作成",
  "settings.webhook.event.payment.received": "支払受領",

  "settings.ai.title": "AIアシスタント統合 (マルチエージェント)",
  "settings.ai.switch.on": "有効",
  "settings.ai.switch.off": "無効",
  "settings.ai.switch.desc":
    "有効にすると、AIが通常の自動応答の代わりにメッセージに自動返信します。",
  "settings.ai.provider.label": "プライマリプロバイダー",
  "settings.ai.provider.gemini": "Google Gemini (推奨 - 無料/低価格)",
  "settings.ai.provider.openai": "OpenAI (GPT-4o - 高性能/有料)",
  "settings.ai.failover.label": "自動フェイルオーバー",
  "settings.ai.failover.desc":
    "プライマリプロバイダーが失敗した場合（クォータ超過、サーバーエラー）、システムは自動的にバックアッププロバイダーに切り替えます。",
  "settings.ai.gemini.label": "Gemini APIキー",
  "settings.ai.gemini.placeholder": "Google Gemini APIキーを入力...",
  "settings.ai.gemini.help.text": "キーの取得先: ",
  "settings.ai.gemini.help.link": "Google AI Studio",
  "settings.ai.openai.label": "OpenAI APIキー",
  "settings.ai.openai.placeholder": "OpenAI APIキーを入力 (sk-...)...",
  "settings.ai.openai.help.text": "キーの取得先: ",
  "settings.ai.openai.help.link": "OpenAI Dashboard",
  "settings.ai.persona.label": "ペルソナ",
  "settings.ai.persona.desc":
    'AIの性格を定義します。例: "あなたは絵文字を使う親切なサポートエージェントです。"',
  "settings.ai.knowledge.label": "ナレッジベース",
  "settings.ai.knowledge.placeholder":
    "例:\\n- Wifi: CoffeeHouse / pass: 12345678\\n- 営業時間: 7am - 10pm\\n- 住所: 123 Nguyen Van Linh...",
  "settings.ai.knowledge.desc":
    "AIはこの情報を使用して、一般的な顧客の質問に答えます。",
  "settings.ai.save": "設定を保存",

  /* Shipping Providers */
  "settings.shipping.provider.ghn.name": "名前",
  "settings.shipping.provider.ghtk.name": "名前",
  "settings.shipping.provider.ghtk.desc": "費用対効果の高い全国配送",
  "settings.shipping.provider.viettelpost.name": "名前",
  "settings.shipping.provider.jt.name": "名前",
  "settings.shipping.provider.jt.desc": "J&T Express配送",

  "settings.quickreply.title": "クイック返信テンプレート",
  "settings.quickreply.add": "テンプレートを追加",
  "settings.quickreply.empty.title": "テンプレートが見つかりません",
  "settings.quickreply.create-first": "最初のテンプレートを作成",
  "settings.quickreply.col.title": "タイトル",
  "settings.quickreply.col.content": "内容",
  "settings.quickreply.col.shortcut": "ショートカット",
  "settings.quickreply.col.category": "カテゴリ",
  "settings.quickreply.col.action": "アクション",
  "settings.quickreply.modal.title-add": "クイック返信を追加",
  "settings.quickreply.modal.title-edit": "クイック返信を編集",
  "settings.quickreply.modal.label.title": "タイトル *",
  "settings.quickreply.modal.placeholder.title": "例: ありがとうございます",
  "settings.quickreply.modal.label.content": "内容 *",
  "settings.quickreply.modal.placeholder.content":
    "送信するメッセージの内容...",
  "settings.quickreply.modal.label.shortcut": "ショートカット",
  "settings.quickreply.modal.placeholder.shortcut": "例: /thanks",
  "settings.quickreply.modal.help.shortcut":
    "ショートカットを入力して素早く検索",
  "settings.quickreply.modal.label.category": "カテゴリ",
  "settings.quickreply.cat.general": "一般",
  "settings.quickreply.cat.greeting": "挨拶",
  "settings.quickreply.cat.thanks": "感謝",
  "settings.quickreply.cat.faq": "よくある質問",
  "settings.quickreply.cat.promotion": "プロモーション",
  "settings.quickreply.modal.cancel": "キャンセル",
  "settings.quickreply.modal.save": "作成",
  "settings.quickreply.modal.update": "更新",
  "settings.quickreply.notify.load-error": "テンプレートを読み込めません",
  "settings.quickreply.notify.input-error": "タイトルと内容を入力してください",
  "settings.quickreply.notify.update-success": "テンプレートを更新しました",
  "settings.quickreply.notify.create-success": "テンプレートを作成しました",
  "settings.quickreply.notify.save-error": "テンプレートを保存できません",
  "settings.quickreply.notify.delete-confirm":
    "このテンプレートを削除してもよろしいですか？",
  "settings.quickreply.notify.delete-success": "テンプレートを削除しました",
  "settings.quickreply.notify.delete-error": "テンプレートを削除できません",

  "settings.autoreply.title": "自動返信ルール",
  "settings.autoreply.add": "ルールを追加",
  "settings.autoreply.empty.title": "自動返信ルールが見つかりません",
  "settings.autoreply.create-first": "最初のルールを作成",
  "settings.autoreply.col.enable": "有効",
  "settings.autoreply.col.name": "ルール名",
  "settings.autoreply.col.keyword": "キーワード",
  "settings.autoreply.col.response": "返信",
  "settings.autoreply.col.page": "ファンページ",
  "settings.autoreply.col.match": "一致",
  "settings.autoreply.col.action": "アクション",
  "settings.autoreply.modal.title-add": "自動返信ルールを追加",
  "settings.autoreply.modal.title-edit": "自動返信ルールを編集",
  "settings.autoreply.modal.label.name": "ルール名 *",
  "settings.autoreply.modal.placeholder.name": "例: 新規顧客へのお知らせ",
  "settings.autoreply.modal.label.page": "ファンページに適用",
  "settings.autoreply.modal.option.all-pages": "すべてのファンページ",
  "settings.autoreply.modal.label.trigger": "トリガーキーワード",
  "settings.autoreply.modal.placeholder.trigger":
    "hello, hi, welcome (カンマ区切り)",
  "settings.autoreply.modal.help.trigger":
    "メッセージがいずれかのキーワードを含む場合にボットが返信します",
  "settings.autoreply.modal.label.response": "返信内容 *",
  "settings.autoreply.modal.placeholder.response":
    "こんにちは！お問い合わせありがとうございます...",
  "settings.autoreply.modal.label.priority": "優先度",
  "settings.autoreply.modal.help.priority":
    "数字が大きいほど優先度が高くなります（複数のルールが一致する場合）",
  "settings.autoreply.modal.cancel": "キャンセル",
  "settings.autoreply.modal.save": "作成",
  "settings.autoreply.modal.update": "更新",
  "settings.autoreply.test.placeholder":
    "自動返信をテストするメッセージを入力...",
  "settings.autoreply.test.button": "テスト",
  "settings.autoreply.test.matched": "一致しました！",
  "settings.autoreply.test.no-match": "一致しません",
  "settings.autoreply.test.rule": "ルール:",
  "settings.autoreply.test.response": "返信:",
  "settings.autoreply.notify.load-error": "ルールを読み込めません",
  "settings.autoreply.notify.input-error": "名前と返信内容を入力してください",
  "settings.autoreply.notify.update-success": "ルールを更新しました",
  "settings.autoreply.notify.create-success": "ルールを作成しました",
  "settings.autoreply.notify.save-error": "ルールを保存できません",
  "settings.autoreply.notify.delete-confirm":
    "このルールを削除してもよろしいですか？",
  "settings.autoreply.notify.delete-success": "ルールを削除しました",
  "settings.autoreply.notify.delete-error": "ルールを削除できません",
  "settings.autoreply.notify.toggle-error": "ルールの状態を切り替えられません",

  /* Quick Reply Settings */
  "settings.quickreply.title": "クイック返信テンプレート",
  "settings.quickreply.add": "追加",
  "settings.quickreply.empty.title": "テンプレートが見つかりません",
  "settings.quickreply.create-first": "最初のテンプレートを作成",
  "settings.quickreply.col.title": "タイトル",
  "settings.quickreply.col.content": "コンテンツ",
  "settings.quickreply.col.shortcut": "ショートカット",
  "settings.quickreply.col.category": "カテゴリ",
  "settings.quickreply.col.action": "アクション",
  "settings.quickreply.modal.title-add": "クイック返信追加",
  "settings.quickreply.modal.title-edit": "クイック返信編集",
  "settings.quickreply.modal.label.title": "タイトル *",
  "settings.quickreply.modal.placeholder.title": "例: ありがとうございます",
  "settings.quickreply.modal.label.content": "コンテンツ",
  "settings.quickreply.modal.label.shortcut": "ショートカット",
  "settings.quickreply.modal.placeholder.shortcut": "例: /thanks",
  "settings.quickreply.modal.help.shortcut":
    "ショートカットを入力して素早く検索",
  "settings.quickreply.modal.label.category": "カテゴリ",
  "settings.quickreply.cat.general": "一般",
  "settings.quickreply.cat.greeting": "挨拶",
  "settings.quickreply.cat.thanks": "感謝",
  "settings.quickreply.cat.faq": "FAQ",
  "settings.quickreply.cat.promotion": "プロモーション",
  "settings.quickreply.modal.cancel": "キャンセル",
  "settings.quickreply.modal.save": "作成",
  "settings.quickreply.modal.update": "更新",
  "settings.quickreply.notify.load-error": "テンプレートを読み込めません",
  "settings.quickreply.notify.input-error":
    "タイトルとコンテンツを入力してください",
  "settings.quickreply.notify.update-success": "テンプレート更新済",
  "settings.quickreply.notify.create-success": "テンプレート作成済",
  "settings.quickreply.notify.save-error": "テンプレートを保存できません",
  "settings.quickreply.notify.delete-success": "テンプレート削除済",
  "settings.quickreply.notify.delete-error": "テンプレートを削除できません",

  /* Auto Reply Settings */
  "settings.autoreply.title": "自動返信ルール",
  "settings.autoreply.add": "追加",
  "settings.autoreply.empty.title": "自動返信ルールが見つかりません",
  "settings.autoreply.create-first": "最初のルールを作成",
  "settings.autoreply.col.enable": "有効",
  "settings.autoreply.col.name": "名前",
  "settings.autoreply.col.keyword": "キーワード",
  "settings.autoreply.col.response": "返信",
  "settings.autoreply.col.page": "ファンページ",
  "settings.autoreply.col.match": "一致",
  "settings.autoreply.col.action": "アクション",
  "settings.autoreply.modal.title-add": "自動返信ルール追加",
  "settings.autoreply.modal.title-edit": "自動返信ルール編集",
  "settings.autoreply.modal.label.name": "名前",
  "settings.autoreply.modal.placeholder.name": "名前",
  "settings.autoreply.modal.label.page": "ファンページに適用",
  "settings.autoreply.modal.option.all-pages": "すべてのファンページ",
  "settings.autoreply.modal.label.trigger": "トリガーキーワード",
  "settings.autoreply.modal.label.response": "返信内容 *",
  "settings.autoreply.modal.label.priority": "優先度",
  "settings.autoreply.modal.cancel": "キャンセル",
  "settings.autoreply.modal.save": "作成",
  "settings.autoreply.modal.update": "更新",
  "settings.autoreply.test.placeholder":
    "自動返信をテストするメッセージを入力...",
  "settings.autoreply.test.button": "テスト",
  "settings.autoreply.test.matched": "一致しました！",
  "settings.autoreply.test.no-match": "不一致",
  "settings.autoreply.test.rule": "ルール:",
  "settings.autoreply.test.response": "返信:",
  "settings.autoreply.notify.load-error": "ルールを読み込めません",
  "settings.autoreply.notify.input-error": "名前と返信内容を入力してください",
  "settings.autoreply.notify.update-success": "ルール更新済",
  "settings.autoreply.notify.create-success": "ルール作成済",
  "settings.autoreply.notify.save-error": "ルールを保存できません",
  "settings.autoreply.notify.delete-success": "ルール削除済",
  "settings.autoreply.notify.delete-error": "ルールを削除できません",
  "settings.autoreply.notify.toggle-error":
    "ルールステータスを切り替えられません",

  /* Upgrade Page */
  "upgrade.title": "アカウントアップグレード",
  "upgrade.subtitle": "ビジネスニーズに合ったプランを選択してください",
  "upgrade.current-package": "現在のプラン",
  "upgrade.expired": "期限切れ",
  "upgrade.remaining-days": "残り{days}日",
  "upgrade.lifetime": "永久",
  "upgrade.activated": "有効化済",
  "upgrade.renew": "更新",
  "upgrade.downgrade": "ダウングレード",
  "upgrade.upgrade": "アップグレード",
  "upgrade.contact": "お問い合わせ",
  "upgrade.using": "使用中",
  "upgrade.best-value": "ベストバリュー",

  "upgrade.feature.billing": "会計機能",
  "upgrade.feature.print_invoice": "請求書・レシート印刷",
  "upgrade.feature.accounts": "レジ係、キッチン＆サーバーアカウント",
  "upgrade.feature.sales": "売上",
  "upgrade.feature.products": "商品管理",
  "upgrade.feature.materials": "材料管理",
  "upgrade.feature.staff": "スタッフ",
  "upgrade.feature.chain": "複数店舗管理",
  "upgrade.feature.reports": "収益＆利益レポート",
  "upgrade.feature.social": "ソーシャルメディア連携",
  "upgrade.feature.shipping": "配送連携",
  "upgrade.feature.ecommerce": "TikTok Shop / Shopee連携",
  "upgrade.feature.einvoice": "電子請求書",
  "upgrade.feature.api": "Webhook / API統合",
  "upgrade.feature.api-limit": "APIリクエスト制限",
  "upgrade.feature.automation": "自動化システム",
  "upgrade.feature.support": "テクニカルサポート & セットアップ",

  "upgrade.value.products.free": "30商品",
  "upgrade.value.products.basic": "無制限",
  "upgrade.value.materials.free": "30材料",
  "upgrade.value.materials.basic": "無制限",
  "upgrade.value.staff.free": "2スタッフ",
  "upgrade.value.unlimited": "無制限",
  "upgrade.value.reports.basic": "当日のレポート",
  "upgrade.value.reports.detailed": "リアルタイム売上レポート",
  "upgrade.value.reports.advanced": "詳細な利益分析レポート",
  "upgrade.value.api.limit": "30,000 / 月",
  "upgrade.value.api.custom": "カスタム",
  "upgrade.value.support.docs": "ドキュメント",
  "upgrade.value.support.online": "オンライン 24/7",
  "upgrade.value.support.priority": "優先度 1-1",

  "upgrade.package.free.title": "無料プラン",
  "upgrade.package.basic.title": "ベーシックプラン",
  "upgrade.package.pro.title": "プロプラン",
  "upgrade.package.pro-auto.title": "プロ + 自動化",
  "upgrade.package.enterprise.title": "エンタープライズ",

  "upgrade.time.1m": "1ヶ月",
  "upgrade.time.6m": "6ヶ月",
  "upgrade.time.1y": "1年",
  "upgrade.time.2y": "2年",
  "upgrade.time.5y": "5年",

  "upgrade.modal.payment.title": "支払い情報",
  "upgrade.modal.payment.instant-title": "即時有効化対象",
  "upgrade.modal.payment.term": "期間:",
  "upgrade.modal.payment.scan-note": "スキャンして支払う",
  "upgrade.modal.payment.owner": "口座名義人:",
  "upgrade.modal.payment.account": "口座番号:",
  "upgrade.modal.payment.bank": "銀行:",
  "upgrade.modal.payment.amount": "金額:",
  "upgrade.modal.payment.content": "コンテンツ",
  "upgrade.modal.payment.remaining": "(残高)",
  "upgrade.modal.payment.wallet": "(ウォレット)",

  "upgrade.modal.downgrade.title": "ダウングレード確認",
  "upgrade.modal.downgrade.remaining-value": "残り価値:",
  "upgrade.modal.downgrade.equivalent": "({days} 日相当)",
  "upgrade.modal.downgrade.exchange": "新パッケージに変換:",
  "upgrade.modal.downgrade.refund": "ウォレットへの返金額:",
  "upgrade.modal.downgrade.calculating": "計算中...",
  "upgrade.modal.downgrade.cancel": "キャンセル",
  "upgrade.modal.downgrade.confirm": "ダウングレード確認",
  "upgrade.modal.downgrade.ineligible": "対象外 (1ヶ月未満)",

  "upgrade.modal.success.title": "アップグレード成功！",
  "upgrade.modal.success.msg": "アップグレードおめでとうございます！",
  "upgrade.modal.success.lifetime":
    "あなたのアカウントは無期限にアップグレードされました",
  "upgrade.modal.success.new-expiry": "新しい有効期限:",
  "upgrade.modal.success.close": "閉じる",

  "profile.fullname": "氏名",
  "profile.description": "説明",
  "profile.address": "住所",
  "profile.phone": "電話番号",
  "profile.email": "メール",
  "profile.company-name": "店舗名",
  "profile.company-address": "店舗住所",
  "profile.company-website": "ウェブサイト",
  "profile.company-start-time": "開店時間",
  "profile.company-end-time": "閉店時間",
  "profile.company-menu-hash": "オンラインメニュー",
  "profile.bankPay": "銀行",
  "profile.namePay": "口座名義人",
  "profile.numberPay": "口座番号",
  "profile.update-personal": "個人情報を更新",
  "profile.update-company": "店舗情報を更新",
  "profile.placeholder.fullname": "氏名",
  "profile.placeholder.description": "説明",
  "profile.placeholder.address": "住所",
  "profile.placeholder.phone": "電話番号",
  "profile.placeholder.email": "メール",
  "profile.placeholder.hotline": "例: 1900 1234",
  "profile.placeholder.website": "例: vmass.vn",
  "profile.placeholder.bank": "銀行を選択",
  "profile.placeholder.account-name": "例: 山田 太郎",
  "profile.placeholder.account-number": "例: 0123456789",
  "profile.business-type.cafe": "コーヒー、タピオカティー",
  "profile.business-type.restaurant": "レストラン、食堂",
  "profile.business-type.retail": "食料品、小売",
  "profile.business-type.fashion": "ファッション",
  "profile.business-type.cosmetics": "化粧品",
  "profile.business-type.unknown": "不明",
  "profile.business-type.label": "業種",
  "profile.payment-info.title": "支払い情報",

  /* Affiliate List */
  "affiliate.col.name": "名前",
  "affiliate.col.email": "メール",
  "affiliate.col.phone": "電話番号",
  "affiliate.col.bank": "銀行",
  "affiliate.col.status": "ステータス",
  "affiliate.col.date": "登録日",
  "affiliate.col.action": "アクション",
  "affiliate.empty": "データがありません",
  "affiliate.status.approved": "承認済",
  "affiliate.status.pending": "保留中",
  "affiliate.status.deactivated": "無効",

  /* Guest View & Orders */
  "guest.cart": "カート",
  "guest.price": "価格",
  "guest.quantity": "数量",
  "guest.total": "合計",
  "guest.product": "商品",
  "guest.total-amount": "合計金額",
  "guest.payment": "支払い",
  "guest.call-service": "店員を呼ぶ",
  "guest.call-service-cooldown": "{seconds}秒後に再試行してください",
  "guest.request-payment": "会計を依頼",
  "guest.invoice": "請求書",

  /* Order Summary */
  "order.summary.discount": "割引",
  "order.summary.tax": "税金",
  "order.summary.fee": "手数料",
  "order.summary.gift": "ギフト",
  "order.summary.total-payment": "支払総額",

  /* Product Management Tools */
  /* Recipe Builder */
  "recipe.unit.default": "個, 箱, パック...",
  "recipe.unit.cafe": "カップ, グラス, 皿...",
  "recipe.unit.fashion": "個, 足, セット...",
  "recipe.unit.cosmetics": "ボトル, チューブ, ジャー...",
  "recipe.unit.retail": "個, パック, 箱, kg...",
  "recipe.unit.generic": "単位",
  "recipe.title": "レシピ / 原材料",
  "recipe.count-badge": "原材料",
  "recipe.empty-state":
    "まだ原材料がありません。「原材料を追加」をクリックして開始してください。",
  "recipe.label.name": "原材料名",
  "recipe.placeholder.select": "選択または新規作成...",
  "recipe.create-label": '"{val}" を作成',
  "recipe.label.usage": "使用量",
  "recipe.label.total": "小計",
  "recipe.btn.delete": "行を削除",
  "recipe.btn.delete-tooltip": "原材料を削除",
  "recipe.new-stock.title": "新しい在庫をインポート:",
  "recipe.label.unit": "単位",
  "recipe.label.import-qty": "輸入量",
  "recipe.label.cost-price": "原価",
  "recipe.unit.per-unit": " / 単位",
  "recipe.label.paid": "支払済",
  "recipe.label.provider": "サプライヤー",
  "recipe.create-provider": '"{val}" を作成',
  "recipe.label.debt": "負債",
  "recipe.btn.add": "原材料を追加",
  "recipe.footer.total-cost": "総原価:",
  "recipe.footer.expected-profit": "予想利益:",

  "product.name": "商品名",
  "product.price": "販売価格",
  "product.promotion-price": "セール価格",
  "product.price.cost": "原価",
  "product.image": "画像",
  "label.enter-barcode": "バーコードを入力",
  "label.enter-product-name": "商品名を入力",
  "stock.unit": "単位",
  "label.select-or-create": "選択または作成...",
  "label.create-new": "新規作成",
  "label.select-create-provider": "サプライヤーを選択または作成...",
  "unit.placeholder.default": "個, 箱, パック...",
  "unit.placeholder.cafe": "カップ, グラス, 皿...",
  "unit.placeholder.fashion": "個, 足, セット...",
  "unit.placeholder.cosmetics": "ボトル, チューブ, ジャー...",
  "unit.placeholder.retail": "個, パック, 箱, kg...",
  "modal.stock.stt": "No.",
  "modal.product.unit": "レシピ",
  "modal.product.combo": "コンボ",
  "product.edit_cost": "構成編集",
  "tooltip.enable-combo": "コンボを有効化",
  "modal.product.variant": "バリエーション",
  "tooltip.not-for-combo": "コンボには適用不可",
  "modal.stock.supplier": "サプライヤー",
  "modal.product.paid": "支払済",
  "modal.stock.remaining": "未払",
  "modal.product.image": "画像",
  "tooltip.unit-hint": "商品単位",
  "warehouse.import-quantity": "輸入量",

  "product.add-title": "商品追加",
  "product.import-excel": "Excelからインポート",
  "product.import-image": "画像からインポート",
  "product.notify.stock-success": "新規在庫が正常に作成されました",
  "product.sku": "SKUコード",
  "product.barcode": "バーコード",
  "product.stock-count": "在庫数",

  "breakeven.title": "損益分岐点",
  "breakeven.period.day": "日",
  "breakeven.period.month": "月",
  "breakeven.period.quarter": "四半期",
  "breakeven.period.year": "年",
  "breakeven.fixed-costs.title": "固定費 (VND)",
  "breakeven.fixed-costs.rent": "家賃",
  "breakeven.fixed-costs.salary": "固定給",
  "breakeven.fixed-costs.depreciation": "設備減価償却費",
  "breakeven.fixed-costs.management": "管理費 & マーケティング費",
  "breakeven.fixed-costs.other": "その他固定費",
  "breakeven.product.title": "商品情報",
  "breakeven.product.price": "価格",
  "breakeven.product.variable-cost": "平均原価/個",
  "breakeven.product.profit-margin": "利益率 %",
  "breakeven.loading": "データ読み込み中...",
  "breakeven.empty.title": "損益分岐点を計算できません",
  "breakeven.empty.sub": "最初の注文後に表示されます。",
  "breakeven.result.fixed-cost": "総固定費",
  "breakeven.result.revenue": "現在の売上",
  "breakeven.result.gross-profit": "現在の粗利益",
  "breakeven.result.sold-quantity": "販売数量",
  "breakeven.result.breakeven-units": "損益分岐点販売数",
  "breakeven.result.breakeven-revenue": "損益分岐点売上",
  "breakeven.table.title": "利益分析詳細表",
  "breakeven.table.volume": "数量",
  "breakeven.table.revenue": "売上",
  "breakeven.table.variable-cost": "変動費",
  "breakeven.table.fixed-cost": "固定費",
  "breakeven.table.total-cost": "総費用",
  "breakeven.table.profit": "利益",
  "breakeven.error.price-invalid":
    "平均販売価格は0より大きくなければなりません。",
  "breakeven.error.cost-invalid": "変動費は負の値にできません。",
  "breakeven.error.fetch-fail": "データを取得できません",
  "breakeven.error.connect-fail": "接続エラー: ",
  "breakeven.chart.title": "損益分岐点分析チャート",
  "breakeven.chart.revenue": "売上 (TR)",
  "breakeven.chart.total-cost": "総費用 (TC)",
  "breakeven.chart.fixed-cost": "固定費 (FC)",
  "breakeven.chart.x-axis": "数量 (Q)",
  "breakeven.chart.y-axis": "金額 (VND)",
  "profile.success": "成功",
  "profile.error": "エラー",
  "company-uuid": "UUID",

  /* Navigation Tabs */
  "settings.nav.general": "一般",
  "settings.nav.invoice": "請求書",
  "settings.nav.social": "ソーシャル連携",
  "settings.nav.shipping": "配送連携",
  "settings.nav.staff": "スタッフ",
  "settings.nav.customer": "顧客",
  "settings.nav.ecommerce": "Eコマース",
  "settings.nav.einvoice": "電子請求書",
  "settings.nav.apikeys": "APIキー",
  "settings.nav.webhooks": "Webhooks",
  "settings.nav.email": "メール",
  "settings.nav.ai": "AIアシスタント",

  /* Notifications & Confirms */
  "settings.notification.no-data": "データがありません",
  "settings.notification.saved": "設定を保存しました！",
  "settings.notification.error": "エラー",
  "settings.social.fb.disconnect-success": "ページの連携を解除しました！",
  "settings.social.fb.disconnect-error": "ページ連携解除エラー",
  "settings.social.zalo.disconnect-success": "Zalo OAの連携を解除しました！",
  "settings.social.zalo.disconnect-error": "Zalo OA連携解除エラー",
  "settings.ecommerce.shopee.connect-error": "Shopee接続エラー",
  "settings.ecommerce.shop.disconnect-success":
    "ショップの連携を解除しました！",
  "settings.ecommerce.shop.disconnect-error": "ショップ連携解除エラー",
  "settings.ecommerce.tiktok.connect-error": "TikTok Shop接続エラー",
  "settings.ecommerce.tiktok.disconnect-success":
    "TikTok Shopの連携を解除しました！",
  "settings.ecommerce.product-import-success": "商品をインポートしました！",
  "settings.ecommerce.product-import-error": "商品インポートエラー",
  "settings.ecommerce.order-sync-success": "注文を同期しました！",
  "settings.ecommerce.order-sync-error": "注文同期エラー",
  "settings.einvoice.save-success": "電子請求書設定を保存しました！",
  "settings.einvoice.save-error": "電子請求書設定保存エラー",
  "settings.email.save-success": "メール設定を保存しました！",
  "settings.email.save-error": "メール設定保存エラー",
  "settings.email.test-success": "テストメールを送信しました！",
  "settings.email.test-error": "テストメール送信エラー",

  /* Social Settings (Zalo) */
  "settings.zalo.title": "Zalo Official Account",
  "settings.zalo.guide": "ガイド",
  "settings.zalo.guide.title": "Zalo OAの接続方法:",
  "settings.zalo.guide.step1": "「新しいZalo OAを接続」をクリック",
  "settings.zalo.guide.step2": "Zaloにログイン (必要な場合)",
  "settings.zalo.guide.step3": "接続するOAを選択",
  "settings.zalo.guide.step4": "権限を許可",
  "settings.zalo.guide.step5": "完了！",
  "settings.zalo.upgrade-btn": "今すぐアップグレード",
  "settings.zalo.connect-locked":
    "新しいZalo OAを接続 (ベーシックプラン以上が必要)",
  "settings.zalo.connect-btn": "新しいZalo OAを接続",
  "settings.zalo.loading": "読み込み中...",
  "settings.zalo.no-oa": "Zalo OAは接続されていません。",
  "settings.zalo.table.name": "名前",
  "settings.zalo.table.id": "OA ID",
  "settings.zalo.table.date": "接続日",
  "settings.zalo.table.action": "アクション",
  "settings.zalo.disconnect-btn": "連携解除",

  /* Ecommerce Settings (Shopee/TikTok) */
  "settings.ecommerce.shopee.guide": "ガイド",
  "settings.ecommerce.shopee.guide.title": "Shopeeの接続方法:",
  "settings.ecommerce.shopee.guide.step1": "「新しいショップを接続」をクリック",
  "settings.ecommerce.shopee.guide.step2": "Shopeeにログイン (必要な場合)",
  "settings.ecommerce.shopee.guide.step3": "接続するショップを選択",
  "settings.ecommerce.shopee.guide.step4": "権限を許可",
  "settings.ecommerce.shopee.guide.step5": "完了！",
  "settings.ecommerce.connect-locked":
    "新しいショップを接続 (ベーシックプラン以上が必要)",
  "settings.ecommerce.connect-btn": "新しいショップを接続",
  "settings.ecommerce.loading": "読み込み中...",
  "settings.ecommerce.no-shop": "ショップは接続されていません。",
  "settings.ecommerce.table.name": "名前",
  "settings.ecommerce.table.id": "ショップID",
  "settings.ecommerce.table.region": "地域",
  "settings.ecommerce.table.date": "接続日",
  "settings.ecommerce.table.action": "アクション",
  "settings.ecommerce.action.syncing": "同期中...",
  "settings.ecommerce.action.import-product": "商品インポート",
  "settings.ecommerce.action.sync-order": "注文同期",
  "settings.ecommerce.action.disconnect": "連携解除",
  "settings.ecommerce.tiktok.guide": "ガイド",
  "settings.ecommerce.tiktok.guide.title": "TikTok Shopの接続方法:",

  /* E-Invoice Settings */
  "settings.einvoice.title": "電子請求書設定",
  "settings.einvoice.provider": "プロバイダー",
  "settings.einvoice.vat-rate": "デフォルトVAT税率 (%)",
  "settings.einvoice.api-info": "API認証情報",
  "settings.einvoice.username": "ユーザー名",
  "settings.einvoice.password": "パスワード",
  "settings.einvoice.company-info": "会社情報",
  "settings.einvoice.tax-id": "税ID",
  "settings.einvoice.company-name": "会社名",
  "settings.einvoice.address": "住所",
  "settings.einvoice.phone": "電話番号",
  "settings.einvoice.email": "メール",
  "settings.einvoice.series": "請求書シリーズ",
  "settings.einvoice.bank-info": "銀行情報 (任意)",
  "settings.einvoice.bank-account": "口座番号",
  "settings.einvoice.bank-name": "銀行名",
  "settings.einvoice.save-btn": "設定を保存",
  "settings.einvoice.saving": "保存中...",
  "settings.einvoice.api-url": "API URL",
  "settings.einvoice.api-url-help": "テスト環境はテスト用、本番環境は実運用用",
  "settings.einvoice.signing-method": "請求書に署名する方法",
  "settings.einvoice.sign-type": "署名タイプ",
  "settings.einvoice.sign-type-help":
    "USBトークン（手動）、HSM（サーバー自動）、eSign（CAリモート）",
  "settings.einvoice.esign-config": "eSign高度設定",
  "settings.einvoice.esign-provider": "CAプロバイダー",
  "settings.einvoice.esign-username": "eSignユーザー名",
  "settings.einvoice.esign-password": "eSignパスワード",
  "settings.einvoice.esign-serial": "証明書シリアル",
  "settings.einvoice.test-connection": "接続テスト",
  "settings.einvoice.testing": "テスト中...",
  "settings.einvoice.test-success": "接続成功！",
  "settings.einvoice.test-fail": "サーバーに接続できません",
  "settings.ai.saving-btn": "保存中...",
  "settings.ai.notification.error": "エラー",
  "settings.ai.notification.success-title": "成功",
  "settings.ai.notification.error-title": "エラー",

  "facebook.go-to-messenger": "チャットへ移動",

  "settings.shipping.alert.connect-success": "接続に成功しました",
  "settings.shipping.alert.connect-error": "接続エラー",
  "settings.shipping.alert.disconnect-success": "接続解除に成功しました",
  "settings.shipping.alert.disconnect-error": "接続解除エラー",

  "warehouse.transfer-search": "転送名を検索",
  "warehouse.transfer": "在庫移動伝票",
  "warehouse.transfer-stock": "移動品目",
  "warehouse.transfer-title": "在庫移動伝票更新",
  "warehouse.transfer-name": "担当者名",
  "warehouse.transfer-quantity": "数量",
  "warehouse.transfer-price": "移動価格",

  /* Inventory Audit */
  "audit.title": "棚卸と在庫調整",
  "audit.button.create": "作成",
  "audit.modal.detail.title": "棚卸詳細",
  "audit.date": "日付",
  "audit.status": "ステータス",
  "audit.note": "メモ",
  "audit.table.stock": "在庫",
  "audit.table.system": "システム",
  "audit.table.actual": "実数",
  "audit.table.discrepancy": "差異",
  "audit.table.reason": "理由",
  "audit.total-discrepancy": "差異総額",
  "audit.button.continue": "棚卸を続ける",
  "audit.status.completed": "完了",
  "audit.status.pending": "保留中",

  /* Stock Return */
  "return.title": "サプライヤーへの返品",
  "return.button.create": "作成",
  "return.modal.detail.title": "返品詳細",
  "return.date": "日付",
  "return.status": "ステータス",
  "return.reason": "理由",
  "return.table.stock": "在庫",
  "return.table.quantity": "数量",
  "return.table.price": "価格",
  "return.table.provider": "プロバイダー",
  "return.table.total": "合計",
  "return.total-value": "合計金額",
  "return.status.completed": "完了",
  "return.status.pending": "保留中",

  /* Stock Disposal */
  "disposal.title": "期限切れまたは破損した材料の廃棄",
  "disposal.button.create": "作成",
  "disposal.modal.detail.title": "廃棄詳細",
  "disposal.date": "日付",
  "disposal.type": "タイプ",
  "disposal.status": "ステータス",
  "disposal.type.expired": "期限切れ",
  "disposal.type.damaged": "破損",
  "disposal.type.other": "その他",
  "disposal.status.completed": "完了",
  "disposal.status.pending": "保留中",
  "disposal.status.rejected": "却下",
  "disposal.table.stock": "在庫",
  "disposal.table.quantity": "数量",
  "disposal.table.unit": "単位",
  "disposal.table.provider": "プロバイダー",
  "disposal.table.refundable": "返金可能",
  "disposal.table.price": "価格",
  "disposal.table.total": "合計",
  "disposal.table.reason": "理由",
  "disposal.total": "合計",
  "disposal.button.close": "閉じる",
  "disposal.refundable.yes": "はい",
  "disposal.refundable.no": "いいえ",

  /* Invoice (Order) */
  "invoice.title": "請求書",
  "invoice.tab.info": "情報",
  "invoice.tab.deleted": "削除された請求書",
  "invoice.empty": "データがありません...",
  "invoice.menu.restore": "請求書を復元",
  "invoice.menu.destroy": "完全に削除",
  "invoice.badge.id": "請求書ID",
  "invoice.badge.no-print": "未印刷",
  "invoice.discount": "割引",
  "invoice.tax": "税金",
  "invoice.fee": "手数料",
  "invoice.no-permission": "この機能を使用する権限がありません！",
  "invoice.success.restore": "請求書が正常に復元されました",
  "invoice.error.unknown": "不明なエラーが発生しました。",

  /* Home Page (Dashboard) */
  "home.wizard.title": "初期設定",
  "home.warning.add-product": "最初の商品を追加してください",
  "home.warning.update-info": "店舗情報を更新してください",
  "home.warning.update-payment": "支払い情報を更新してください",
  "home.warning.dismiss-template": "サンプルデータを閲覧中です。実際の運用の前に非表示または削除してください",
  "home.warning.dismiss-btn": "サンプルデータを非表示",
  "home.warning.dismiss-confirm": "すべてのサンプルデータを非表示にしますか？",
  "home.warning.dismiss-success": "サンプルデータを非表示にしました！",
  "home.warning.here": "こちら",
  "home.status-order": "注文状況",
  "home.btn.order-preview": "注文プレビュー",
  "home.table.title-orders": "注文商品",
  "home.table.title-adjust": "注文調整",
  "home.btn.save-provisional": "一時保存",
  "home.btn.provisional-invoice": "仮請求書",
  "home.btn.return-order": "返品注文",

  "home.header.product": "商品名",
  "home.header.quantity": "数量",
  "home.header.price": "価格",
  "home.header.total": "合計",
  "home.header.delete": "削除",
  "home.empty": "商品がまだ注文されていません！",
  "home.summary.total": "小計",
  "home.summary.discount": "割引",
  "home.summary.tax": "税金",
  "home.summary.fee-other": "その他手数料",
  "home.summary.shipping": "配送料",
  "home.summary.payment-total": "支払総額",
  "home.shipping.ghn": "Giao Hang Nhanh (GHN)",
  "home.shipping.ghtk": "Giao Hang Tiet Kiem (GHTK)",
  "home.shipping.viettelpost": "Viettel Post",
  "home.shipping.vnpost": "VN Post",
  "home.shipping.ahamove": "Ahamove",
  "home.shipping.lalamove": "Lalamove",
  "home.shipping.grabexpress": "GrabExpress",
  "home.shipping.shopeexpress": "Shopee Xpress",
  "home.shipping.jtexpress": "J&T Express",
  "home.shipping.ninjavan": "Ninja Van",
  "home.shipping.bestexpress": "BEST Express",
  "home.shipping.kerryexpress": "Kerry Express",
  "home.summary.customer-pay": "顧客支払",
  "home.summary.refund": "お釣り",
  "home.summary.missing": "不足",
  "home.order.ice": "氷",
  "home.order.sugar": "甘さ",

  "home.placeholder.customer-name": "顧客名",
  "home.placeholder.phone": "電話番号",
  "home.btn.complete-adjust": "調整完了",
  "home.tooltip.tax-fee": "この金額は合計金額に加算されます。",
  "home.tooltip.fee-other": "この金額は合計金額に加算されます。",
  "home.notify.no-products":
    "商品が注文されていません。少なくとも1つの商品を追加してください。",
  "general.loading": "読み込み中...",
  "general.done": "完了",
  "general.not-yet": "未完了",
  "general.error.title": "エラー！",
  "home.btn.close": "閉じる",
  "home.btn.order": "注文 (F9)",
  "home.btn.payment": "支払い",
  "home.btn.print-provisional": "仮請求書印刷 (F8)",
  "home.btn.calculating": "計算中...",

  "home.alert.call-payment": "お客様が会計を求めています！",
  "home.alert.call-service": "お客様が店員を呼んでいます！",
  "home.alert.stock-warning": "在庫僅少警告",
  "home.notify.no-order-discount": "割引を適用する注文がありません",
  "home.notify.no-order-print": "印刷する注文がありません",
  "home.notify.no-payment-btn": "支払いボタンが見つかりません",
  "home.notify.no-order-pay": "支払う注文がありません",
  "home.notify.save-not-supported": "一時保存機能はまだサポートされていません",
  "home.notify.no-order-save": "一時保存する注文がありません",
  "home.notify.scan-success": "スキャン成功",
  "home.notify.updated": "更新済",
  "home.notify.success": "成功",
  "home.notify.update-failed": "更新失敗",
  "home.notify.error": "エラー",
  "general.setting": "設定",
  "general.error.invalid-data": "無効なデータ",
  "home.summary.no-info": "情報なし",
  "home.summary.no-setup": "未設定",
  "home.summary.no-data": "データがありません...",
  "home.btn.save-all": "すべての変更を保存",
  "home.notify.transfer-success": "テーブル移動成功",
  "home.notify.transfer-failed": "テーブル移動失敗",
  "home.notify.status-error": "注文状況更新中にエラーが発生しました。",

  /* Shortcuts */
  "home.shortcut.f1": "ガイドを開く",
  "home.shortcut.f2": "商品検索",
  "home.shortcut.f3": "商品管理",
  "home.shortcut.f4": "割引 / 税金 / 手数料",
  "home.shortcut.f8": "仮請求書印刷",
  "home.shortcut.f9": "注文 / 支払い",
  "home.shortcut.f10": "仮請求書保存",
  "home.shortcut.title": "キーボードショートカット",
  "home.shortcut.close": "ESCを押して閉じる",

  /* Provisional Invoice (Drafts) */
  "home.provisional.title": "仮請求書一覧",
  "home.provisional.empty": "保存された仮請求書はありません！",
  "home.provisional.btn-reorder": "再注文",
  "home.provisional.btn-cancel": "キャンセル",
  "home.provisional.counter": "カウンター",

  /* Order History & Return */
  "home.history.title": "注文履歴検索",
  "home.history.search": "検索",
  "home.history.empty": "選択した期間に注文が見つかりませんでした。",
  "home.history.loading": "データ読み込み中...",
  "home.history.error": "エラー",
  "home.history.invoice": "請求書",
  "home.history.sku": "SKU",
  "home.history.btn-return": "返品",
  "home.history.confirm-return": "この商品を返品してもよろしいですか？",
  "home.history.return-success": "返品と在庫の復元に成功しました。",

  /* Common Labels & Options */
  "home.label.product-name": "商品名",
  "home.label.quantity": "数量",
  "home.label.price": "価格",
  "home.label.total": "合計",
  "home.label.delete": "削除",
  "home.label.customer-name": "顧客名",
  "home.label.phone": "電話番号",
  "home.btn.order-now": "今すぐ注文！",
  "home.msg.preview-detail": "詳細プレビュー",

  "home.option.payment.cash": "現金",
  "home.option.payment.transfer": "銀行振込",
  "home.option.payment.card": "クレジットカード",
  "home.option.payment.credit": "掛け払い",
  "home.option.shipping.select": "配送業者を選択",
  "home.placeholder.staff": "スタッフ",
  "home.placeholder.shipping": "配送業者",
  "home.placeholder.payment": "支払い",

  /* Analytics */
  "analytics.tabs.overview": "概要",
  "analytics.tabs.products": "商品",
  "analytics.tabs.materials": "材料",
  "analytics.tabs.customers": "顧客",
  "analytics.tabs.staff": "スタッフ",
  "analytics.tabs.debt": "サプライヤー",
  "analytics.tabs.payment": "支払い",
  "analytics.tabs.other": "その他",

  "analytics.summary.total_products": "総商品数",
  "analytics.summary.products_with_variants": "バリエーションあり商品",
  "analytics.summary.products_on_sale": "セール中",
  "analytics.summary.products_without_recipe": "レシピなし",
  "analytics.summary.unsold_products_count": "未販売商品数",
  "analytics.summary.avg_profit_margin": "平均利益率",
  "analytics.summary.total_materials": "総材料数",
  "analytics.summary.low_stock": "在庫僅少 (<20% | <10%)",
  "analytics.summary.unassigned_materials": "未割り当て材料",
  "analytics.summary.total_inventory_value": "総在庫価値",
  "analytics.summary.import_value": "入庫額",
  "analytics.summary.import_count": "入庫回数",
  "analytics.summary.total_new_customers": "新規顧客数",
  "analytics.summary.total_returning_customers": "リピーター数",
  "analytics.summary.total_spent": "総支出額",
  "analytics.summary.avg_spent_per_customer": "平均客単価",
  "analytics.summary.customer_debt": "売掛金",
  "analytics.summary.return_rate": "返品率",
  "analytics.summary.total_sales": "総売上",
  "analytics.summary.total_bills": "総請求書数",
  "analytics.summary.total_items": "総アイテム数",
  "analytics.summary.avg_revenue_per_hour": "時間あたり平均売上",
  "analytics.summary.active_staff": "アクティブスタッフ",

  "analytics.table.top_selling": "売れ筋商品トップ",
  "analytics.table.top_slow": "死に筋商品",
  "analytics.table.payment_method": "支払方法",

  "analytics.error.agency": "代理店データの取得エラー",
  "analytics.error.activity": "アクティビティデータの取得エラー",
  "analytics.error.outcome": "支出",
  "analytics.error.income": "収入",
  "analytics.error.sold_products": "販売商品データの取得エラー",
  "analytics.error.material_import": "入庫材料データの取得エラー",
  "analytics.error.debt": "債務データの取得エラー",
  "analytics.error.material_usage": "材料使用データの取得エラー",
  "analytics.error.table": "テーブルデータの取得エラー",
  "analytics.error.payment_method": "支払方法データの取得エラー",
  "analytics.error.top_products": "トップ商品データの取得エラー",
  "analytics.error.best_selling": "ベストセラー商品データの取得エラー",
  "analytics.error.customer": "顧客",
  "analytics.error.staff": "スタッフ",
  "analytics.error.booking": "予約データの取得エラー",
  "analytics.error.materials": "材料データの取得エラー",
  "analytics.dashboards.outcome": "支出",
  "analytics.dashboards.income": "収入",
  "analytics.dashboards.stock-log": "在庫ログ",
  "analytics.dashboards.make-product": "レシピ作成",
  "analytics.dashboards.order-table": "テーブル統計",
  "analytics.dashboards.debt": "債務",
  "analytics.chart.income": "収入",
  "analytics.chart.outcome": "支出",
  "analytics.filter.my_store": "マイストア",
  "analytics.filter.all": "すべて",
  "analytics.filter.today": "今日",
  "analytics.upgrade.title": "プラン制限",
  "analytics.profit": "利益",
  "analytics.imported-stock-quantity": "入庫在庫数",
  "analytics.total-stock-value": "総在庫価値",
  "analytics.pnl.title": "詳細損益レポート (P&L)",
  "analytics.pnl.revenue-header": "💰 収益",
  "analytics.pnl.sales-revenue": "売上収益",
  "analytics.pnl.gross-revenue": "総収益",
  "analytics.pnl.discount": "割引",
  "analytics.pnl.tax": "税金",
  "analytics.pnl.other-fees": "(+) その他手数料",
  "analytics.pnl.other-income": "その他収入",
  "analytics.pnl.total-revenue": "総収益",
  "analytics.pnl.cost-header": "📉 費用",
  "analytics.pnl.cogs": "売上原価 (COGS)",
  "analytics.pnl.material-cost": "材料費",
  "analytics.pnl.gross-profit": "粗利益",
  "analytics.pnl.operating-expenses": "営業費用",
  "analytics.pnl.fixed-costs": "固定費 (電気、水道、人件費...)",
  "analytics.pnl.gift-cost": "🎁 プロモーションギフト費用",
  "analytics.pnl.total-expenses": "総費用",
  "analytics.pnl.net-profit": "💰 純利益",
  "analytics.pnl.net-loss": "📉 純損失",

  "analytics.table.stt": "No.",
  "analytics.table.name": "名前",
  "analytics.table.quantity": "数量",
  "analytics.table.total": "合計",
  "analytics.table.price": "価格",
  "analytics.table.product": "商品",
  "analytics.table.sold_quantity": "販売数",
  "analytics.table.revenue": "売上",
  "analytics.table.cogs": "原価",
  "analytics.table.profit": "利益",
  "analytics.table.ratio": "比率",
  "analytics.table.material": "材料",
  "analytics.table.stock": "在庫",
  "analytics.table.total_import": "総入庫",
  "analytics.table.value": "価値",
  "analytics.table.remaining": "残り",
  "analytics.table.gift": "ギフト",
  "analytics.table.discount": "割引",
  "analytics.table.method": "方法",
  "analytics.table.order_count": "注文数",
  "analytics.table.product_count": "商品数",
  "analytics.table.total_amount": "合計金額",
  "analytics.table.stock_status.critical": "危険",
  "analytics.table.stock_status.warning": "警告",
  "analytics.table.stock_status.normal": "正常",
  "analytics.table.unit_price": "単価",

  "analytics.staff.rank": "ランク",
  "analytics.staff.name": "スタッフ",
  "analytics.staff.position": "役職",
  "analytics.staff.sales": "売上",
  "analytics.staff.bill_count": "注文数",
  "analytics.staff.product_count": "販売商品数",
  "analytics.staff.revenue_per_hour": "売上/時",
  "analytics.staff.commission": "コミッション",
  "analytics.staff.bonus": "ボーナス",
  "analytics.staff.overtime": "残業 (h)",
  "analytics.staff.advance": "前払い",
  "analytics.staff.fined": "罰金",
  "analytics.staff.no_data": "スタッフデータがありません",
  "analytics.staff.top": "🏆 トップ",

  "analytics.booking.title": "予約統計",
  "analytics.booking.summary.total": "総予約数",
  "analytics.booking.summary.pending": "保留中",
  "analytics.booking.summary.confirmed": "確定済",
  "analytics.booking.summary.completed": "完了",
  "analytics.booking.summary.cancelled": "キャンセル",
  "analytics.booking.summary.guests": "総ゲスト数",
  "analytics.booking.source.phone": "電話",
  "analytics.booking.source.walk_in": "来店",
  "analytics.booking.source.website": "ウェブサイト",
  "analytics.booking.source.app": "アプリ",
  "analytics.booking.source.facebook": "Facebook",
  "analytics.booking.source.zalo": "Zalo",
  "analytics.booking.table.stt": "#",
  "analytics.booking.table.date": "日付",
  "analytics.booking.table.time": "時間",
  "analytics.booking.table.customer": "顧客",
  "analytics.booking.table.phone": "電話番号",
  "analytics.booking.table.party_size": "人数",
  "analytics.booking.table.status": "ステータス",
  "analytics.booking.table.source": "ソース",
  "analytics.booking.table.no_data": "予約データがありません",

  "analytics.customer.name": "顧客",
  "analytics.customer.phone": "電話番号",
  "analytics.customer.order_count": "注文数",
  "analytics.customer.products_purchased": "購入商品数",
  "analytics.customer.total_spent": "総支出額",
  "analytics.customer.point": "ポイント",
  "analytics.customer.debt": "債務",
  "analytics.customer.created_at": "登録日時",
  "analytics.customer.no_data": "データがありません",

  "chat.permission_denied": "この機能を使用する権限がありません！",
  "chat.internal_msg": "一般メッセージ",
  "chat.search_placeholder": "検索",
  "chat.max_files_error": "最大3ファイルまで送信可能です",
  "chat.no_file_guest_error": "ゲストへのファイル送信はサポートされていません",
  "chat.file_size_error": "最大サイズ 100 MB / ファイル",

  "chat.facebook.messenger": "Messenger",
  "chat.facebook.syncing": "Facebookからメッセージを同期中...",
  "chat.facebook.synced_success": "{count} 件の会話を同期しました",
  "chat.facebook.sync_failed": "同期失敗",
  "chat.facebook.sync_error": "メッセージ同期エラー",
  "chat.facebook.all_pages": "すべてのページ",
  "chat.facebook.customer": "顧客",
  "chat.facebook.no_messages": "メッセージはまだありません",
  "chat.facebook.outside_24h": "24時間外 - 送信するメッセージタグを選択:",
  "chat.facebook.select_tag": "-- タグを選択 --",
  "chat.facebook.tag.human_agent": "カスタマーサポート (7日間)",
  "chat.facebook.tag.post_purchase": "注文更新",
  "chat.facebook.tag.account_update": "アカウント更新",
  "chat.facebook.tag.event_update": "イベント更新",
  "chat.facebook.send_file_error": "メッセージを送信できません",
  "chat.facebook.sync_btn": "同期",
  "chat.facebook.processing": "処理中...",
  "chat.facebook.search_customer": "顧客を検索...",
  "chat.facebook.send_error": "ファイルを送信できません",
  "chat.facebook.token_expired_title": "⚠️ Facebookトークンの有効期限が切れました！メッセージの送受信ができません。",
  "chat.facebook.token_reconnect_btn": "Facebookに再接続",
  "fb.comment.no-posts": "投稿が見つかりませんでした",
  "fb.comment.no-posts-hint": "「同期」をクリックしてページから読み込みます",
  "fb.comment.loading-comments": "コメントを読み込み中...",
  "fb.comment.no-comments": "コメントが見つかりませんでした",
  "fb.comment.select-post": "コメントを表示する投稿を選択してください",
  "fb.comment.post-detail": "投稿の詳細",
  "fb.comment.view-on-fb": "Facebookで表示",
  "fb.comment.like": "いいね",
  "fb.comment.reply": "返信",
  "fb.comment.hide": "非表示",
  "fb.comment.unhide": "表示",
  "fb.comment.hidden": "非表示中",
  "fb.comment.reply-placeholder": "返信を入力...",
  "fb.comment.edit": "編集",
  "fb.comment.delete": "削除",
  "fb.comment.filter-all": "すべて",
  "fb.comment.filter-unread": "未読",
  "fb.comment.filter-unreplied": "未返信",
  "fb.comment.status-replied": "返信済み",
  "fb.comment.loading-posts": "投稿を読み込み中...",
  "fb.comment.no-pages-desc": "VMASSに接続されているFanpageがまだありません。管理を開始するにはアクセストークンを使用してください。",

  "topnav.search.placeholder.default": "デフォルト",
  "topnav.search.placeholder.dashboard": "商品検索...",
  "topnav.search.placeholder.product": "商品検索...",
  "topnav.search.placeholder.stock": "在庫",
  "topnav.search.placeholder.customer": "顧客",
  "topnav.search.placeholder.order": "注文検索...",
  "topnav.search.placeholder.staff": "スタッフ",
  "topnav.search.placeholder.promotion": "プロモーション",
  "topnav.search.placeholder.provider": "プロバイダー",
  "topnav.search.placeholder.income": "収入",
  "topnav.search.placeholder.outcome": "支出",
  "topnav.search.placeholder.cash-flow": "収入と支出を検索...",
  "topnav.search.placeholder.treasury": "資金",
  "topnav.search.placeholder.warehouse_export": "出庫伝票検索...",
  "topnav.search.placeholder.warehouse_import": "入庫伝票検索...",
  "topnav.search.placeholder.warehouse_transfer": "移動伝票検索...",
  "topnav.search.placeholder.todo": "ToDo",

  "topnav.menu.account": "アカウント",
  "topnav.menu.cashier": "レジ係",
  "topnav.menu.waiter": "ウェイター",
  "topnav.menu.kitchen": "キッチン / バーテンダー",
  "topnav.menu.settings": "設定",
  "topnav.menu.logout": "ログアウト",

  "topnav.noti.todo.message": "'To Do'を確認してください",
  "topnav.noti.todo.title": "リマインダー",
  "topnav.noti.order.message": "新しい注文が入りました。確認してください！",
  "topnav.noti.stock_down.message": "材料の在庫が少なくなっています！",
  "topnav.noti.stock_down.title": "追加購入の提案",

  "page.heading.excel": "Excel",
  "page.heading.add_from_image": "画像から商品を追加",
  "page.heading.create_quantitative": "レシピ作成",
  "page.heading.add_bulk": "商品を一括追加",
  "page.heading.add_quantitative_one": "レシピ作成",
  "page.heading.best_seller": "おすすめ",
  "page.heading.un_best_seller": "おすすめ解除",
  "page.heading.mark_best_seller": "おすすめに設定",
  "page.heading.soft_hide_mixed": "商品の表示/非表示",
  "page.heading.soft_hide_show": "商品を表示",
  "page.heading.soft_hide_hide": "商品を非表示",
  "page.heading.print_sticker": "シール印刷",
  "page.heading.import_excel_title": "Excelファイルからデータをインポート",
  "page.heading.import_result": "インポート結果",
  "page.heading.import_btn": "インポート",
  "page.heading.error.limit_title": "プラン制限",

  "product.confirm.delete": "削除",
  "product.error.invalid-data": "無効なデータ",
  "product.error.variant-required": "バリエーションには価格と数量が必要です",

  "product.multi.name": "商品名",
  "product.multi.barcode": "バーコード",
  "product.multi.sku": "SKU",
  "product.multi.unit": "単位",
  "product.multi.category": "カテゴリ",
  "product.multi.hot": "人気",
  "product.multi.price": "価格",
  "product.multi.price_sale": "セール価格",
  "product.multi.active_sale": "セール中",
  "product.multi.recipe": "定量",
  "product.multi.variant": "バリエーション",
  "product.multi.image": "画像",
  "product.multi.soft_hide": "非表示",

  "product.variant.default": "デフォルト",
  "product.variant.coming_soon": "{date} から開始",
  "product.variant.starts_from": "{date} から",
  "product.variant.name": "名前",
  "product.variant.sku": "SKU",
  "product.variant.price": "価格",
  "product.variant.stock": "在庫",
  "product.variant.promo_time": "プロモーション期間",
  "product.variants": "バリエーション",

  "customer.export.stt": "No.",
  "customer.export.name": "名前",
  "customer.export.phone": "電話番号",
  "customer.export.email": "メール",
  "customer.export.address": "住所",
  "customer.export.used": "利用回数",
  "customer.export.point": "ポイント",
  "customer.export.armorial": "バッジ",
  "customer.export.tags": "タグ",
  "customer.export.debt": "債務",
  "customer.export.total_spent": "総支出額",
  "customer.export.created_at": "初回利用日",
  "customer.export.updated_at": "更新日",
  "customer.export.filename": "顧客リスト",

  "stock.export.stt": "No.",
  "stock.export.id": "ID",
  "stock.export.name": "名前",
  "stock.export.sku": "SKU",
  "stock.export.unit": "単位",
  "stock.export.price_new": "入庫価格",
  "stock.export.inventory": "在庫",
  "stock.export.total": "合計金額",
  "stock.export.created_at": "作成日",
  "stock.export.updated_at": "更新日",
  "stock.export.filename": "材料リスト",

  "income.export.stt": "No.",
  "income.export.name": "名前",
  "income.export.value": "金額",
  "income.export.address": "住所",
  "income.export.note": "メモ",
  "income.export.created_at": "作成日",
  "income.export.statistic": "統計",
  "income.statistic.exclude": "除外",
  "income.statistic.include": "含む",
  "income.export.creator": "作成者",
  "income.export.filename": "収入リスト",

  "outcome.export.stt": "No.",
  "outcome.export.name": "名前",
  "outcome.export.value": "金額",
  "outcome.export.address": "住所",
  "outcome.export.note": "メモ",
  "outcome.export.created_at": "作成日",
  "outcome.export.statistic": "統計",
  "outcome.statistic.exclude": "除外",
  "outcome.statistic.include": "含む",
  "outcome.export.creator": "作成者",
  "outcome.export.filename": "支出リスト",

  "todo.export.filename": "Todoリスト",
  "page.heading.excel.tooltip": "データをExcelファイルにダウンロード",
  "analytics.export.name": "名前",
  "analytics.export.quantity": "数量",
  "analytics.export.total_price": "合計金額",
  "analytics.export.product": "商品",
  "analytics.export.revenue": "売上",
  "analytics.export.method": "支払方法",
  "analytics.export.order_count": "注文数",
  "analytics.export.supplier": "サプライヤー",
  "analytics.export.customer": "顧客",
  "analytics.export.phone": "電話番号",
  "analytics.export.spent": "支出",
  "analytics.export.created_at": "登録日時",
  "analytics.export.material": "材料",
  "analytics.export.unit": "単位",
  "analytics.export.table": "テーブル",
  "analytics.export.discount": "割引",
  "analytics.export.stock": "在庫",
  "analytics.export.min_stock": "最小在庫",
  "analytics.export.date": "日付",
  "analytics.export.time": "時間",
  "analytics.export.party_size": "人数",
  "analytics.export.status": "ステータス",
  "analytics.export.source": "ソース",
  "analytics.export.sheet.sold_products": "販売商品",
  "analytics.export.sheet.top_spenders": "高額利用者",
  "analytics.export.sheet.imported_materials": "入庫材料",
  "analytics.export.sheet.used_materials": "使用材料",
  "analytics.export.sheet.booking": "予約",
  "analytics.export.success": "成功",

  /* AI Configuration */
  "settings.ai.default_persona":
    "あなたはフレンドリーなカスタマーサポートエージェントです。",

  /* Upgrade */
  "upgrade.price.currency": "{price} VND",
  "upgrade.feature.billing": "会計機能",
  "upgrade.feature.print_invoice": "請求書・レシート印刷",
  "upgrade.feature.accounts": "スタッフアカウント",
  "upgrade.feature.sales": "売上",
  "upgrade.feature.products": "商品・在庫",
  "upgrade.value.products.free": "30商品",
  "upgrade.value.products.basic": "無制限",
  "upgrade.value.unlimited": "無制限",
  "upgrade.time.1m": "1ヶ月",
  "upgrade.features": "機能",
  "make-product.select-or-create": "選択または新規作成",
  "make-product.unit": "単位",
  "make-product.no-recipe": "この商品にはレシピがありません！",
  "make-product.cost-price": "原価",
  "make-product.cost-ratio": "原価率",
  "general.add": "追加",

  "stock.header.material_name": "材料名",
  "stock.header.unit": "単位",
  "stock.header.total_import": "総入庫",
  "stock.header.new_quantity": "新数量",
  "stock.header.inventory": "在庫",
  "stock.header.below_20": "20%未満",
  "stock.header.below_10": "10%未満",
  "stock.header.true": "はい",
  "stock.header.false": "いいえ",

  "income.header.name": "名前",
  "income.header.payer": "支払人",
  "income.header.address": "住所",
  "income.header.amount": "金額",
  "income.header.description": "説明",
  "income.header.status": "ステータス",
  "income.header.statistic": "統計",
  "income.header.creator": "作成者",
  "income.header.created_at": "作成日",

  "outcome.header.name": "名前",
  "outcome.header.receiver": "受取人",
  "outcome.header.amount": "金額",
  "outcome.header.description": "説明",
  "outcome.header.address": "住所",
  "outcome.header.status": "ステータス",
  "outcome.header.statistic": "統計",
  "outcome.header.creator": "作成者",
  "outcome.header.created_at": "作成日",

  "customer.header.name": "名前",
  "customer.header.phone": "電話番号",
  "customer.header.email": "メール",
  "customer.header.address": "住所",
  "customer.header.points": "ポイント",
  "customer.header.used_count": "利用回数",
  "customer.header.total_spent": "総支出額",
  "customer.header.rank": "ランク",
  "customer.header.debt": "債務",
  "customer.header.created_at": "初回利用日",
  "customer.header.updated_at": "更新日",

  "provider.header.name": "名前",
  "provider.header.phone": "電話番号",
  "provider.header.email": "メール",
  "provider.header.address": "住所",
  "provider.header.total_import": "総入庫",
  "provider.header.paid": "支払済",
  "provider.header.remaining": "残金",

  "warehouse.transfer.header.item": "移動アイテム",
  "warehouse.transfer.header.quantity": "数量",
  "warehouse.transfer.header.price": "価格",
  "warehouse.transfer.header.description": "説明",
  "warehouse.transfer.header.status": "ステータス",
  "warehouse.transfer.header.sender": "送信者",
  "warehouse.transfer.header.phone": "電話番号",
  "warehouse.transfer.header.carrier": "配送業者",
  "warehouse.transfer.header.carrier_phone": "配送業者電話番号",
  "warehouse.transfer.header.destination": "移動先倉庫",
  "warehouse.transfer.header.transport": "輸送手段",
  "warehouse.transfer.header.shipping_cost": "配送料",
  "warehouse.transfer.header.creator": "作成者",
  "warehouse.transfer.header.created_at": "作成日",

  "warehouse.import.header.item": "入庫アイテム",
  "warehouse.import.header.unit": "単位",
  "warehouse.import.header.quantity": "数量",
  "warehouse.import.header.price": "価格",
  "warehouse.import.header.status": "ステータス",
  "warehouse.import.header.importer": "入庫担当者",
  "warehouse.import.header.phone": "電話番号",
  "warehouse.import.header.address": "住所",
  "warehouse.import.header.created_at": "作成日",

  "warehouse.export.header.item": "出庫アイテム",
  "warehouse.export.header.quantity": "数量",
  "warehouse.export.header.price": "価格",
  "warehouse.export.header.status": "ステータス",
  "warehouse.export.header.description": "説明",
  "warehouse.export.header.creator": "作成者",
  "warehouse.export.header.created_at": "作成日",

  "treasury.header.name": "名前",
  "treasury.header.value": "金額",
  "treasury.header.note": "メモ",
  "treasury.header.statistic": "統計",
  "treasury.header.creator": "作成者",
  "treasury.header.created_at": "作成日",

  "modal.stock.stt": "No.",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "バーコード",
  "modal.stock.supplier": "サプライヤー",
  "modal.stock.remaining": "残り",
  "modal.stock.expired": "有効期限",

  "table.import.sku": "SKU",
  "table.import.barcode": "バーコード",
  "table.import.price_sale": "販売価格",
  "table.import.price_promotion": "プロモーション価格",
  "table.import.apply_promotion": "プロモーション適用",
  "table.import.image": "画像",
  "table.import.image_sub": "サブ画像",
  "table.import.recommend": "おすすめ",
  "table.import.hidden": "非表示",
  "table.import.description": "説明",
  "table.import.size": "サイズ",
  "table.import.topping": "トッピング",
  "table.import.ice": "氷の量",
  "table.import.sugar": "甘さ",
  "table.import.color": "色",
  "table.import.material": "材料",
  "table.import.result": "インポート結果",
  "table.import.reason": "エラー理由",

  "modal.product.stt": "#",
  "modal.product.barcode_enter": "バーコード (入力)",
  "modal.product.unit": "定量",
  "modal.product.combo": "コンボ/製造",
  "modal.product.variant": "バリエーション",
  "modal.product.supplier": "サプライヤー",
  "modal.product.paid": "支払済",
  "modal.product.remaining": "残り",
  "modal.product.image": "画像",
  "modal.product.hot": "人気",
  "modal.product.delete": "削除",
  "modal.auto-generate": "自動生成",
  "modal.stock.confirm-import": "入庫確認",
  "modal.add-row": "行を追加",
  "tooltip.not-for-combo": "コンボアイテムには適用されません",
  "label.create-new": "新規作成",
  "label.select-or-create": "選択または作成...",
  "label.enter-product-name": "商品名を入力...",
  "label.enter-barcode": "バーコードを入力...",
  "label.select-create-provider": "サプライヤーを選択/作成...",
  "menu.product.recommended": "おすすめ商品",
  "menu.product.discount": "割引",
  "menu.product.recipe": "レシピ",
  "menu.stock.inventory": "在庫",
  "menu.stock.less-than-50": "50%未満",
  "menu.stock.less-than-20": "20%未満",
  "menu.stock.less-than-10": "10%未満",
  "menu.stock.cost-price": "原価",
  "menu.stock.cost-price-done": "原価入力済",
  "menu.stock.cost-price-not-yet": "原価未入力",
  "menu.stock.import-time": "入庫時間",
  "menu.stock.recent-5-days": "最近5日間",
  "menu.stock.recent-10-days": "最近10日間",
  "todo.tasks": "タスク",
  "todo.today": "今日",
  "todo.this-week": "今週",
  "todo.this-month": "今月",
  "todo.upcoming": "予定",
  "todo.next-1-hour": "次の1時間",
  "todo.next-3-hours": "次の3時間",
  "todo.next-6-hours": "次の6時間",
  "todo.past": "過去",
  "todo.past-7-days": "過去7日間",
  "todo.past-30-days": "過去30日間",
  "todo.past-6-months": "過去6ヶ月",
  "chat.broadcast-all-stores": "全店舗に送信",
  "menu.customer.debt": "債務",
  "menu.customer.no-debt": "債務なし",
  "menu.customer.have-debt": "債務あり",
  "menu.customer.badge": "バッジ",
  "menu.customer.no-badge": "バッジなし",
  "menu.customer.bronze": "ブロンズ",
  "menu.customer.gold": "ゴールド",
  "menu.customer.platinum": "プラチナ",
  "menu.customer.tags": "タグ",
  "menu.provider.transaction": "取引",
  "menu.provider.paid-all": "全額支払済",
  "menu.provider.debt": "債務",
  "menu.provider.no-transaction": "取引なし",
  "menu.provider.products": "商品",
  "menu.staff.work-status": "勤務状況",
  "menu.staff.working": "勤務中",
  "menu.staff.quit": "退職",
  "menu.staff.position": "役職",
  "price.under-1m": "100万未満",
  "price.1m-to-10m": "100万 - 1000万",
  "price.over-10m": "1000万以上",
  "menu.finance.include-statistics": "統計に含める",
  "menu.finance.price-range": "価格帯",
  "menu.finance.creator": "作成者",
  "menu.stock.status": "ステータス",
  "status.draft": "下書き",
  "status.in-progress": "進行中",
  "status.completed": "完了",
  "menu.stock.time": "時間",
  "general.this-month": "今月",
  "general.last-month": "先月",
  "menu.audit.result": "結果",
  "menu.audit.has-discrepancy": "差異あり",
  "status.pending": "保留中",
  "status.approved": "承認済",
  "status.rejected": "却下",
  "menu.disposal.type": "廃棄タイプ",
  "disposal.expired": "期限切れ",
  "disposal.damaged": "破損",
  "menu.stock.statistics": "統計",
  "menu.stock.total-tickets": "総チケット数",
  "menu.stock.total-value": "総額",
  "status.processing": "処理中",
  "menu.warehouse.status": "ステータス",
  "menu.warehouse.quantity-range": "数量",
  "menu.warehouse.unit": "単位",
  "quantity.under-10": "10未満",
  "quantity.10-to-50": "10 - 50",
  "quantity.over-50": "50以上",

  "table.import.success": "成功",
  "table.import.failed": "失敗",
  "table.import.error_reason": "エラー理由",

  "modal.alert.min-one-material": "少なくとも1つの材料を入力してください。",
  "modal.alert.check-required": "必須項目を確認してください:\n\n",
  "modal.alert.missing-unit": '行 {index} - "{name}": 単位が不足しています',

  "unit.placeholder.cafe": "カップ、グラス、プレート...",
  "unit.placeholder.fashion": "枚、足、セット...",
  "unit.placeholder.cosmetics": "ボトル、チューブ、瓶...",
  "unit.placeholder.retail": "個、パック、箱、kg...",
  "unit.placeholder.default": "デフォルト",

  "product.price.cost": "原価",
  "product.promotion-price": "プロモーション価格",

  "general.all": "すべて",
  "general.yes": "はい",
  "general.no": "いいえ",

  "modal.stock.stt": "No.",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "バーコード",
  "modal.stock.supplier": "サプライヤー",
  "modal.stock.remaining": "残り",
  "modal.stock.expired": "有効期限",
  "modal.stock.confirm-import": "入庫確認",
  "modal.add-row": "行を追加",
  "modal.auto-generate": "自動生成",

  "tooltip.unit-hint": "単位を入力 (例: kg, 箱...)",
  "tooltip.not-for-combo": "コンボアイテムには適用されません",
  "tooltip.enable-combo": "コンボ (定量的) を有効にする",

  "label.select-or-create": "選択または作成...",
  "label.create-new": "新規作成",
  "label.select-create-provider": "サプライヤーを選択/作成...",
  "label.enter-barcode": "バーコードを入力...",
  "label.enter-product-name": "商品名を入力...",

  "modal.product.combo": "コンボ",
  "modal.product.paid": "支払済",
  "page.heading.export-filename": "商品リスト",
  "product.validation.missing-name": "商品名",
  "product.validation.missing-category": "カテゴリ",
  "product.validation.missing-price": "価格",
  "product.validation.missing-unit": "単位",
  "product.validation.missing-import-quantity": "入庫数",
  "product.validation.missing-cost-price": "原価",
  "label.create-new-value": '"{value}" を作成',
  "product.template.default": "デフォルト",
  "product.template.cafe": "Cafe_Product_Template.xlsx",
  "product.template.restaurant": "Restaurant_Product_Template.xlsx",
  "product.template.fashion": "Fashion_Product_Template.xlsx",
  "product.template.retail": "Retail_Product_Template.xlsx",
  "product.template.cosmetics": "Cosmetics_Product_Template.xlsx",

  VD: "例",
  "analytics.export.stt": "No.",
  "analytics.export.total": "合計",
  "analytics.update": "更新",
  "product.btn-add": "商品を追加",
  "product.tab.add-multiple": "複数追加",
  "product.tab.add-one": "一つ追加",
  "settings.invoice.process-3-old": "プロセス 3 (旧)",
  "settings.invoice.process-4-old": "プロセス 4 (旧)",

  "settings.shipping.subtitle": "配送業者と連携して配達注文を自動生成します",
  "settings.shipping.upgrade-warn":
    "配送連携機能を使用するには、Basicプランへのアップグレードが必要です。",
  "settings.shipping.business-fit":
    "以下の配送業者はあなたのビジネスに適しています",
  "settings.shipping.modal.current-token":
    "現在のトークン: {token} (変更しない場合は空欄)",
  "settings.shipping.modal.sandbox-label":
    "サンドボックスモード (テスト) - 本番環境の場合はチェックを外してください",
  "settings.shipping.modal.origin-desc":
    "この情報は正確な送料を計算するために使用されます",
  "settings.shipping.alert.disconnect-confirm":
    "この配送業者を切断してもよろしいですか？",
  "settings.shipping.guide.ghtk.step1":
    "khachhang.giaohangtietkiem.vn にログイン",
  "settings.shipping.modal.token-guide.ghn":
    "トークン取得: api.ghn.vn → Documents",
  "settings.shipping.modal.token-guide.ghtk":
    "トークン取得: khachhang.giaohangtietkiem.vn → Shop Info",
  "settings.shipping.modal.token-guide.viettel":
    "トークン取得: partner.viettelpost.vn → Account Config",
  "settings.shipping.provider.ghn.desc": "都市部および全国への高速配送",
  "settings.shipping.provider.viettelpost.desc":
    "全国対応のViettel郵便サービス",

  "settings.staff.shift-desc":
    "デフォルトの勤務シフトを設定します。「設定を保存」をクリックしてシステムに保存します。",
  "settings.staff.position-desc":
    "職種/役職のリスト。×をクリックして削除します。",

  "settings.partner.modal.result.important":
    "重要！このAPIキーを今すぐ保存してください。一度しか表示されません！",
  "settings.partner.pro-feature-tooltip": "Pro Autoプラン以上が必要です",
  "settings.partner.upgrade-alert.action":
    "プラン、APIキーを作成および管理するため。",

  "settings.webhook.alert.empty":
    "Webhookが見つかりません。「+ Webhook作成」をクリックして自動通知を受け取りましょう。",
  "settings.webhook.alert.delete-confirm":
    "このWebhookを削除してもよろしいですか？この操作は元に戻せません！",
  "settings.webhook.alert.rotate-confirm":
    "シークレットキーを再生成してもよろしいですか？古いキーはすぐに無効になります！",
  "settings.webhook.alert.rotate-success": "シークレットキーを再生成しました！",
  "settings.webhook.modal.create.desc":
    "Webhookを使用すると、イベント（新規注文、支払いなど）が発生したときにVMASSからURLに自動通知を送信できます。",
  "settings.webhook.modal.create.url-placeholder":
    "https://your-server.com/webhook",
  "settings.webhook.modal.create.url-help":
    "URLはHTTPSで、POSTリクエストを受け入れる必要があります",
  "settings.webhook.modal.create.events-help":
    "×をクリックして選択したイベントを削除",
  "settings.webhook.modal.secret.important":
    "重要！このシークレットキーを今すぐ保存してください。一度しか表示されません！",
  "settings.webhook.modal.secret.label": "シークレットキー (署名検証用)",
  "settings.webhook.pro-feature-tooltip": "Pro Autoプラン以上が必要です",

  "settings.social.fb.confirm-disconnect":
    "このページを切断してもよろしいですか？",
  "settings.social.zalo.confirm-disconnect":
    "このZalo OAを切断してもよろしいですか？",
  "settings.zalo.desc":
    "Zalo OAを接続して、Zaloからの顧客メッセージを受信および返信します。",
  "settings.zalo.upgrade-warning":
    "Zalo OAを接続するにはBasicプランへのアップグレードが必要です。",

  "upgrade.modal.payment.deduct-intro":
    "システムは毎月あなたのウォレットから自動的に引き落とします。",
  "upgrade.modal.payment.deduct-note":
    "注: ウォレットの残高が不足している場合、サービスは中断されます。",
  "upgrade.modal.payment.instruction": "支払い手順:",
  "upgrade.modal.payment.original-price": "元の価格：",
  "upgrade.modal.payment.total": "支払い額：",
  "upgrade.modal.payment.btn-instant": "確認して今すぐ有効化",
  "upgrade.modal.payment.btn-submit": "支払い確認とアップグレード申請",
  "upgrade.modal.payment.surplus-refund": "余剰分をウォレットに返金：",
  "upgrade.promo.title": "プロモコード",
  "upgrade.promo.placeholder": "プロモコードを入力",
  "upgrade.promo.apply": "適用",
  "upgrade.promo.remove": "削除",
  "upgrade.promo.btn-create": "新規作成",
  "upgrade.promo.empty": "プロモコードはまだありません",
  "upgrade.promo.modal-create": "プロモコード作成",
  "upgrade.promo.modal-edit": "プロモコード編集",
  "upgrade.promo.col-code": "コード",
  "upgrade.promo.col-desc": "説明",
  "upgrade.promo.col-discount": "割引",
  "upgrade.promo.col-packages": "対象プラン",
  "upgrade.promo.col-usage": "使用数 / 上限",
  "upgrade.promo.col-date": "期間",
  "upgrade.promo.col-status": "ステータス",
  "upgrade.promo.discount-type": "割引タイプ",
  "upgrade.promo.discount-value": "値",
  "upgrade.promo.max-discount": "最大割引額",
  "upgrade.promo.max-uses": "最大使用回数",
  "upgrade.promo.start-date": "開始日",
  "upgrade.promo.end-date": "終了日",
  "menu.upgrade-promo": "アップグレードプロモ",
  "upgrade.modal.payment.manual-note": "手動支払い",
  "upgrade.notify.payment-received": "支払いを受け取りました",
  "upgrade.notify.success": "アップグレード成功！",
  "upgrade.modal.downgrade.intro": "下位プランに変更しようとしています。",
  "upgrade.modal.downgrade.warning": "一部の機能が制限される場合があります。",

  Ex: "例: n8n Automation, App Mobile...",
  Example:
    "例:\\n- Wifi: CoffeeHouse / pass: 12345678\\n- 営業時間: 7am - 10pm\\n- 住所: 123 Nguyen Van Linh...",
  "ref.sub-title": "紹介コード",
  "chat.all_messages": "すべてのメッセージ",
  "wizard.sub-title": "セットアップウィザード",
  "wizard.registered": "登録済み",

  /* Missing Keys Added (Translated) */
  "todo.detail": "詳細",
  "todo.cancel": "キャンセル",
  "todo.submit": "送信",
  "todo.status": "ステータス",
  "todo.all-tasks": "すべてのタスク",
  "todo.pending-tasks": "保留中のタスク",
  "todo.completed-tasks": "完了したタスク",
  "todo.categories": "カテゴリ",
  "todo.labels": "ラベル",
  "menu.charts": "チャート",
  "menu.chat": "チャット",
  "menu.survey": "アンケート",
  "input.to": "宛先",
  "input.email": "メールアドレスを入力",
  "product.name": "商品名",
  "modal.alert.warning": "警告",
  "general.done": "完了",
  "general.not-yet": "未完了",
  "product.add.quantity": "数量を追加",
  "user-staff.date_start": "開始日",
  "user-staff.date_end": "終了日",
  "general.other": "その他",
  "stock.inventory": "在庫",
  "stock.total-import": "総輸入",

  "settings.email.placeholder.gmail-email": "Gmailを入力",
  "settings.email.placeholder.smtp-email": "SMTPメールを入力",
  "profile.edit": "プロフィール編集",
  "menu.blank-page": "空白ページ",
  "action.success": "成功",
  "promotion-discount-add": "割引コードを追加",
  "settings.ai.save-btn": "AI設定を保存",
  "settings.partner.env.test-label": "テスト環境",
  "dashboards.total-table-has-customer": "本日の会計数",
  "invoice.tab.einvoice": "電子請求書",
  "einvoice.list.title": "電子請求書一覧",
  "einvoice.status.draft": "下書き",
  "einvoice.status.issued": "発行済み",
  "einvoice.status.signed": "署名済み",
  "einvoice.status.sent": "送信済み",
  "einvoice.status.cancelled": "キャンセル済み",
  "einvoice.action.view-pdf": "PDFを表示",
  "einvoice.action.download-pdf": "PDFをダウンロード",
  "einvoice.action.send-email": "メールを送信",
  "einvoice.action.cancel": "請求書をキャンセル",
  "einvoice.action.check-status": "ステータスを確認",
  "einvoice.correction.adjust": "調整",
  "einvoice.correction.replace": "差し替え",
  "einvoice.correction.edit-draft": "SePay 下書きを編集",
  "einvoice.correction.modal-adjust-title": "SePay 調整請求書",
  "einvoice.correction.modal-replace-title": "SePay 差し替え請求書",
  "einvoice.correction.submit": "SePay に送信",
  "einvoice.mapping.preview": "VMASS 同期プレビュー",
  "einvoice.mapping.applied": "適用済み",
  "einvoice.mapping.pending": "適用待ち",
  "einvoice.mapping.conflict": "競合。新しい書類を作成してください",
  "einvoice.mapping.failed": "技術エラー。再試行します",
  "einvoice.mapping.inventory": "請求書在庫",
  "einvoice.mapping.inventory-applied": "原材料：復元 {restored} 件、差引 {deducted} 件；バリエーション：復元 {variantsRestored}、差引 {variantsDeducted}",
  "einvoice.correction.save-draft": "SePay に下書きを保存",
  "einvoice.correction.issue-now": "今すぐ発行",
  "einvoice.action.issue-official": "正式発行",
  "einvoice.action.reissue": "再発行",
  "einvoice.cancel.reason": "キャンセル理由",
  "einvoice.email.placeholder": "受信者のメールアドレスを入力",
  "einvoice.alert.cancel-confirm":
    "この請求書をキャンセルしてもよろしいですか？",
  "einvoice.alert.email-success": "メールが正常に送信されました！",
  "einvoice.action.edit": "請求書を編集",
  "einvoice.edit.title": "請求書詳細の編集",
  "einvoice.edit.customer-name": "会社/購入者名",
  "einvoice.edit.email": "請求書用メール",
  "einvoice.edit.payment-method": "支払い方法",
  "einvoice.edit.note": "備考",
  "einvoice.edit.placeholder.customer-name": "会社名または顧客の氏名",
  "einvoice.edit.placeholder.tax-id": "企業納税者番号",
  "einvoice.edit.placeholder.address": "会社登録住所",
  "einvoice.edit.placeholder.email": "email@company.com",
  "einvoice.edit.placeholder.phone": "請求書受信用電話番号",
  "einvoice.edit.placeholder.note": "請求書上の備考",
  "button.save-changes": "変更を保存",
  "einvoice.notification.status-updated": "請求書ステータスが更新されました",
  "einvoice.notification.email-required": "メールアドレスを入力してください",
  "einvoice.notification.cancel-reason-required": "キャンセル理由を入力してください",
  "einvoice.notification.cancel-success": "請求書がキャンセルされました",
  "einvoice.notification.issue-official-success": "公式な請求書が発行されました",
  "einvoice.notification.customer-name-required": "会社/購入者名を入力してください",
  "einvoice.notification.update-success": "請求書情報が更新されました",
  "einvoice.notification.missing-contact-info": "請求書にメールアドレスと電話番号がありません。「請求書を編集」を選択して追加してから再発行してください。",

  /* Table Headers - E-Invoice */
  "table.invoice-no": "請求書番号",
  "table.customer": "顧客",
  "table.date": "日付",
  "table.total": "合計",
  "table.status": "ステータス",
  "table.action": "アクション",
  "table.no-data": "データがありません",
  "button.refresh": "更新",
  "button.cancel": "キャンセル",
  "einvoice.checkbox.issue": "電子請求書を発行",
  "einvoice.success.issued": "電子請求書が正常に発行されました",
  "einvoice.error.issue-failed": "電子請求書の発行に失敗しました",
  "table.phone": "電話番号",
  "table.address": "住所",
  "table.email": "メール",
  "table.discount": "割引",
  "table.payment_method": "支払方法",
  "table.note": "備考",
  "table.tax": "税番号",
  "settings.einvoice.sepay-client-id": "クライアントID",
  "settings.einvoice.sepay-client-secret": "クライアントシークレット",
  "settings.einvoice.sepay-template-code": "請求書テンプレートコード",
  "settings.einvoice.automation": "自動化設定",
  "settings.einvoice.auto-issue":
    "常に「請求書を発行」チェックボックスをオンにする（デフォルト：オフ）",
  "settings.einvoice.auto-draft":
    "選択されていない場合、常に下書き請求書を発行する（デフォルト：オン）",
  "settings.email.placeholder.gmail-email": "Gmailを入力",
  "settings.email.placeholder.smtp-email": "SMTPメールを入力",
  "settings.einvoice.title": "電子請求書",
  "settings.einvoice.save-success": "設定が正常に保存されました",
  "settings.einvoice.save-error": "設定の保存中にエラーが発生しました",
  "settings.einvoice.test-success": "接続成功",
  "settings.einvoice.test-fail": "接続失敗",
  "settings.email.save-success": "メール設定が正常に保存されました",
  "settings.email.save-error": "メール設定の保存中にエラーが発生しました",
  "settings.email.test-success": "テストメールが正常に送信されました",
  "settings.email.test-error": "テストメールの送信中にエラーが発生しました",
  /* Shopee */
  "menu.ecommerce": "Eコマース",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "近日公開",
  "ecommerce.coming-soon-desc": "この機能は開発中です。まもなくこのプラットフォームをサポートします！",
  "shopee.tab.connection": "接続",
  "shopee.tab.orders": "注文",
  "shopee.tab.products": "商品",
  "shopee.tab.inventory": "在庫",
  "shopee.connection.title": "Shopeeショップ接続",
  "shopee.connection.desc": "Shopeeショップを接続して注文、商品、在庫を同期します。",
  "shopee.connect.btn": "新しいショップを接続",
  "shopee.connect.error": "Shopee接続エラー",
  "shopee.disconnect.btn": "切断",
  "shopee.disconnect.confirm": "このショップを切断してもよろしいですか？",
  "shopee.disconnect.success": "ショップを切断しました",
  "shopee.disconnect.error": "切断エラー",
  "shopee.oauth.success": "Shopeeショップを接続しました。",
  "shopee.oauth.error.missing-params": "Shopeeから必要な認証情報が返されませんでした。",
  "shopee.oauth.error.invalid-state": "Shopee接続セッションが無効または期限切れです。もう一度お試しください。",
  "shopee.oauth.error.not-configured": "Shopee Partner認証情報が設定されていません。",
  "shopee.oauth.error.shop-already-connected": "このShopeeショップは別のVMASSアカウントに接続されています。",
  "shopee.oauth.error.callback-failed": "Shopee接続を完了できませんでした。もう一度お試しください。",
  "shopee.oauth.error.upgrade-required": "Shopee連携を利用するにはプランをアップグレードしてください。",
  "shopee.oauth.error.generic": "Shopeeが接続リクエストを拒否しました。もう一度お試しください。",
  "shopee.no-shop": "接続されたShopeeショップがありません。",
  "shopee.select-shop": "ショップ選択",
  "shopee.table.name": "ショップ名",
  "shopee.table.id": "ショップID",
  "shopee.table.region": "地域",
  "shopee.table.token-expires": "トークン状態",
  "shopee.table.connected": "接続日",
  "shopee.token.expired": "期限切れ",
  "shopee.token.active": "有効",
  "shopee.orders.filter.all": "全ステータス",
  "shopee.orders.sync-btn": "Shopeeから同期",
  "shopee.orders.bulk-sync": "全てVMASSに同期",
  "shopee.orders.sync.error": "注文同期エラー",
  "shopee.orders.sync-to-bill": "VMASSに同期",
  "shopee.orders.sync-bill.error": "注文同期エラー",
  "shopee.orders.load.error": "注文読み込みエラー",
  "shopee.orders.empty": "注文がありません。",
  "shopee.orders.col.sn": "注文番号",
  "shopee.orders.col.status": "ステータス",
  "shopee.orders.col.buyer": "購入者",
  "shopee.orders.col.amount": "金額",
  "shopee.orders.col.date": "日付",
  "shopee.orders.col.synced": "同期済み",
  "shopee.synced": "同期済み",
  "shopee.not-synced": "未同期",
  "shopee.products.mapped": "商品マッピング",
  "shopee.products.view-shopee": "Shopee商品を表示",
  "shopee.products.import-btn": "Shopeeからインポート",
  "shopee.products.load.error": "商品読み込みエラー",
  "shopee.products.import.error": "インポートエラー",
  "shopee.products.empty": "商品マッピングがありません。",
  "shopee.products.col.name": "商品名",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "価格",
  "shopee.products.col.stock": "在庫",
  "shopee.products.col.vmass": "VMASS連携",
  "shopee.products.linked": "連携済み",
  "shopee.products.not-linked": "未連携",
  "shopee.products.map-btn": "連携",
  "shopee.products.map.success": "商品を連携しました",
  "shopee.products.map.error": "連携エラー",
  "shopee.products.map-modal.title": "Shopee商品をVMASSに連携",
  "shopee.products.map-modal.select": "VMASS商品を選択",
  "shopee.products.map-modal.placeholder": "商品を選択",
  "shopee.products.map-modal.save": "保存",
  "shopee.cancel": "キャンセル",
  "shopee.inventory.title": "在庫同期",
  "shopee.inventory.desc": "VMASS在庫をShopeeに送信します。",
  "shopee.inventory.sync-btn": "在庫をShopeeに同期",
  "shopee.inventory.sync.error": "在庫同期エラー",
  "shopee.inventory.no-linked": "連携商品がありません。",
  "shopee.inventory.col.shopee-stock": "Shopee在庫",
  "shopee.inventory.col.vmass-product": "VMASS商品",
  "shopee.inventory.col.sync-enabled": "同期",
  "shopee.inventory.col.last-sync": "最終同期",
  "shopee.logistics.ship-btn": "発送",
  "shopee.logistics.track-btn": "追跡",
  "shopee.logistics.ship.error": "発送手配エラー",
  "shopee.logistics.track.error": "追跡情報の読み込みエラー",
  "shopee.logistics.modal.title": "物流",
  "shopee.logistics.phone": "電話番号",
  "shopee.logistics.address": "住所",
  "shopee.logistics.carrier": "配送業者",
  "shopee.logistics.tracking-no": "追跡番号",
  "shopee.logistics.arrange": "発送手配",
  "shopee.logistics.pickup-address": "集荷先住所",
  "shopee.logistics.confirm-ship": "発送確認",
  "shopee.logistics.timeline": "追跡タイムライン",
  "shopee.logistics.no-tracking": "追跡情報はまだありません。",
  "shopee.tab.returns": "返品",
  "shopee.tab.analytics": "分析",
  "shopee.tab.settings": "設定",
  "shopee.tab.monitor": "監視",
  "shopee.returns.title": "返品・返金",
  "shopee.returns.refresh": "更新",
  "shopee.returns.empty": "返品・返金リクエストはありません。",
  "shopee.returns.col.sn": "返品番号",
  "shopee.returns.col.order": "注文番号",
  "shopee.returns.col.reason": "理由",
  "shopee.returns.col.status": "ステータス",
  "shopee.returns.col.amount": "返金額",
  "shopee.returns.col.date": "日付",
  "shopee.returns.col.buyer": "購入者",
  "shopee.returns.accept": "承認",
  "shopee.returns.dispute": "異議申立",
  "shopee.returns.load.error": "返品一覧の読み込みエラー",
  "shopee.returns.detail.error": "返品詳細の読み込みエラー",
  "shopee.returns.detail.title": "返品詳細",
  "shopee.returns.confirm.prompt": "この返品を承認してもよろしいですか？",
  "shopee.returns.confirm.error": "返品承認エラー",
  "shopee.returns.dispute.title": "返品異議申立",
  "shopee.returns.dispute.email": "連絡先メール",
  "shopee.returns.dispute.reason": "異議理由",
  "shopee.returns.dispute.submit": "異議を送信",
  "shopee.returns.dispute.success": "異議を送信しました",
  "shopee.returns.dispute.error": "異議送信エラー",
  "shopee.returns.buyer-note": "購入者メモ",
  "shopee.analytics.title": "Shopee分析",
  "shopee.analytics.no-data": "分析データがありません。",
  "shopee.analytics.total-orders": "合計注文数",
  "shopee.analytics.revenue": "売上",
  "shopee.analytics.synced": "VMASS同期済み",
  "shopee.analytics.products-linked": "連携商品",
  "shopee.analytics.by-status": "ステータス別注文",
  "shopee.analytics.last-7-days": "過去7日間",
  "shopee.analytics.col.date": "日付",
  "shopee.analytics.col.orders": "注文数",
  "shopee.analytics.col.revenue": "売上",
  "shopee.analytics.date-range": "期間",
  "shopee.analytics.date-hint": "Shopeeデータの検索範囲は90日（3ヶ月）以内です。期間を選択してください。",
  "shopee.analytics.max-range": "期間は90日（3ヶ月）を超えることはできません",
  "shopee.analytics.invalid-range": "開始日は終了日より前にしてください",
  "shopee.settings.title": "Shopee設定",
  "shopee.settings.auto-sync-orders": "注文自動同期",
  "shopee.settings.auto-sync-orders.desc": "Shopeeから新しい注文を自動取得",
  "shopee.settings.sync-interval": "同期間隔",
  "shopee.settings.sync-interval.desc": "新しい注文のチェック間隔",
  "shopee.settings.auto-bill": "自動請求書作成",
  "shopee.settings.auto-bill.desc": "Shopee注文からVMASS請求書を自動作成",
  "shopee.settings.auto-inventory": "在庫自動同期",
  "shopee.settings.auto-inventory.desc": "VMASS在庫をShopeeに自動送信",
  "shopee.settings.notifications": "通知",
  "shopee.settings.notify-new-order": "新規注文通知",
  "shopee.settings.notify-status": "注文ステータス変更",
  "shopee.settings.notify-return": "返品・返金リクエスト",
  "shopee.settings.save": "設定を保存",
  "shopee.settings.save.success": "設定を保存しました",
  "shopee.settings.save.error": "設定保存エラー",
  "shopee.monitor.health": "接続状態",
  "shopee.monitor.no-shops": "接続中のショップはありません。",
  "shopee.monitor.last-sync": "最終同期",
  "shopee.monitor.expiring-soon": "まもなく期限切れ",
  "shopee.monitor.activity": "アクティビティログ",
  "shopee.monitor.filter.all": "すべて",
  "shopee.monitor.no-activity": "最近のアクティビティはありません。",
  "shopee.push.modal.title": "Shopeeに商品を公開",
  "shopee.push.step": "ステップ",
  "shopee.push.step.select": "VMASS商品を選択",
  "shopee.push.step.category": "Shopeeカテゴリーを選択",
  "shopee.push.step.details": "商品詳細",
  "shopee.push.step.confirm": "確認して公開",
  "shopee.push.form.name": "商品名（5-120文字）",
  "shopee.push.form.description": "説明（最低25文字）",
  "shopee.push.form.price": "価格",
  "shopee.push.form.weight": "重量（kg）",
  "shopee.push.form.condition": "状態",
  "shopee.push.form.condition.new": "新品",
  "shopee.push.form.condition.used": "中古",
  "shopee.push.form.status": "出品ステータス",
  "shopee.push.form.status.normal": "販売中（NORMAL）",
  "shopee.push.form.status.unlist": "非表示（UNLIST）",
  "shopee.push.form.logistics": "配送チャネル",
  "shopee.push.form.attributes": "カテゴリー属性",
  "shopee.push.form.category": "Shopeeカテゴリー",
  "shopee.push.form.dimension": "梱包サイズ",
  "shopee.push.btn.next": "次へ",
  "shopee.push.btn.back": "戻る",
  "shopee.push.btn.push": "Shopeeに公開",
  "shopee.push.btn.push-short": "Shopeeに公開",
  "shopee.push.btn.select": "選択",
  "shopee.push.btn.cancel": "キャンセル",
  "shopee.push.validate.name": "商品名は5-120文字である必要があります",
  "shopee.push.validate.description": "説明は最低25文字必要です",
  "shopee.push.validate.price": "価格は0より大きい必要があります",
  "shopee.push.validate.weight": "重量は0.01〜50kgの範囲で入力してください",
  "shopee.push.validate.category": "カテゴリーを選択してください",
  "shopee.push.validate.logistics": "配送チャネルを1つ以上選択してください",

  "suggestion.title": "おすすめ",
  "suggestion.frequently-bought": "一緒に購入",
  "suggestion.bestseller": "人気商品",
  "analytics.product_customers.title": "購入した顧客",
  "analytics.product_customers.identified": "特定済み顧客",
  "analytics.product_customers.anonymous": "ゲスト注文",
  "analytics.product_customers.quantity": "数量",
  "analytics.product_customers.revenue": "売上",
  "analytics.product_customers.search": "検索",
  "analytics.product_customers.customer": "顧客",
  "analytics.product_customers.orders": "注文数",
  "analytics.product_customers.spent": "購入額",
  "analytics.product_customers.last_purchase": "最終購入",
  "analytics.product_customers.empty": "該当する顧客はいません",
  "analytics.product_customers.customers": "顧客",
  "analytics.summary.total_products_sold_period": "期間内の販売商品数",
  "analytics.summary.total_quantity_sold_period": "期間内の販売数量",
  "analytics.summary.product_revenue_period": "商品売上",
  "analytics.summary.product_cost_period": "商品原価",
  "analytics.summary.product_gross_profit_period": "粗利益",
  "analytics.summary.product_margin_period": "利益率",
  "shopee.workspace.title": "Shopee運用センター",
  "shopee.workspace.subtitle": "店舗ごとの注文、商品、在庫、配送、精算",
  "shopee.workspace.overview": "概要",
  "shopee.workspace.catalog": "カタログ",
  "shopee.workspace.inventory": "在庫",
  "shopee.workspace.fulfillment": "配送",
  "shopee.workspace.returns": "返品",
  "shopee.workspace.finance": "財務",
  "shopee.workspace.automation": "自動化",
  "shopee.workspace.logs": "ログ",
  "shopee.workspace.refresh": "更新",
  "shopee.workspace.search": "検索",
  "shopee.workspace.from-date": "開始日",
  "shopee.workspace.to-date": "終了日",
  "shopee.workspace.loading": "Shopeeデータを読み込み中…",
  "shopee.workspace.no-data": "データがありません",
  "shopee.workspace.actions": "操作",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "返金",
  "shopee.workspace.fees": "Shopee手数料",
  "shopee.workspace.net-revenue": "純売上",
  "shopee.workspace.payout": "受取金額",
  "shopee.workspace.issues": "問題",
  "shopee.workspace.issue-center": "問題センター",
  "shopee.workspace.order-issues": "注文の問題",
  "shopee.workspace.mapping-issues": "マッピングの問題",
  "shopee.workspace.job-issues": "失敗ジョブ",
  "shopee.workspace.retry-selected-orders": "選択した注文を再処理",
  "shopee.workspace.auto-map-selected": "完全一致SKUを自動マッピング",
  "shopee.workspace.create-selected-drafts": "選択した下書きを作成",
  "shopee.workspace.issue-reason": "問題",
  "shopee.workspace.item-model": "商品 / モデル",
  "shopee.workspace.job": "ジョブ",
  "shopee.workspace.replay": "再実行",
  "shopee.workspace.no-issues": "問題はありません",
  "shopee.workspace.confirm-remediation": "修復を確認",
  "shopee.workspace.confirm-remediation-detail": "選択したレコードのみを冪等に処理します。",
  "shopee.workspace.sync": "同期",
  "shopee.workspace.mapping": "マッピング",
  "shopee.workspace.sync-state": "同期状態",
  "shopee.workspace.amount": "金額",
  "shopee.workspace.create-bill": "請求書作成",
  "shopee.workspace.import-catalog": "カタログ取込",
  "shopee.workspace.map-product": "商品をマッピング",
  "shopee.workspace.mapping-wizard": "ShopeeバリエーションをVMASSにマッピング",
  "shopee.workspace.search-product": "VMASS商品を検索",
  "shopee.workspace.choose-product": "VMASS商品を選択",
  "shopee.workspace.choose-variant": "VMASSバリエーションを選択",
  "shopee.workspace.create-draft": "VMASS下書きを作成",
  "shopee.workspace.update-listing": "出品を更新",
  "shopee.workspace.list-listing": "出品",
  "shopee.workspace.unlist-listing": "非表示",
  "shopee.workspace.variant-prices": "バリエーション価格",
  "shopee.workspace.image-urls": "画像URL",
  "shopee.workspace.image-help": "許可されたVMASSアセットURLを1行に1つ入力します。この項目を編集した場合のみ送信されます。",
  "shopee.workspace.length": "長さ (cm)",
  "shopee.workspace.width": "幅 (cm)",
  "shopee.workspace.height": "高さ (cm)",
  "shopee.workspace.vmass-product-id": "VMASS商品ID",
  "shopee.workspace.vmass-variant-id": "VMASSバリエーションID（単一商品の場合は空欄）",
  "shopee.workspace.mapping-help": "保存前にテナント所有権とバリエーションの所属を検証します。",
  "shopee.workspace.sync-stock": "在庫同期",
  "shopee.workspace.shopee-stock": "Shopee在庫",
  "shopee.workspace.state": "状態",
  "shopee.workspace.reservation": "引当",
  "shopee.workspace.tracking": "追跡番号",
  "shopee.workspace.ship": "出荷",
  "shopee.workspace.ship-confirm": "出荷確認",
  "shopee.workspace.shipping-params-error": "配送パラメータを取得できません",
  "shopee.workspace.shipping-method": "受渡方法",
  "shopee.workspace.pickup-address": "集荷住所",
  "shopee.workspace.pickup-time": "集荷時間",
  "shopee.workspace.confirm": "確認",
  "shopee.workspace.accept": "承認",
  "shopee.workspace.dispute": "異議申立",
  "shopee.workspace.return-reason": "返品処理理由",
  "shopee.workspace.return-evidence": "証拠（画像IDをカンマ区切り）",
  "shopee.workspace.sync-finance": "精算同期",
  "shopee.workspace.create-income": "入金票作成",
  "shopee.workspace.save": "保存",
  "shopee.workspace.sync-interval": "同期間隔（分）",
  "shopee.workspace.resource": "リソース",
  "shopee.workspace.attempts": "試行回数",
  "shopee.workspace.created-at": "作成日時",
  "shopee.workspace.retry": "再試行",
  "shopee.workspace.setting.auto_sync_orders": "注文を自動同期",
  "shopee.workspace.setting.auto_create_bill": "出荷準備時に請求書を自動作成",
  "shopee.workspace.setting.auto_sync_inventory": "在庫を自動同期",
  "shopee.workspace.setting.auto_sync_catalog": "商品カタログを自動同期",
  "shopee.workspace.catalog-sync-interval": "カタログ同期間隔（分）",
  "shopee.workspace.catalog-sync-hint": "60～10080分。既定値は1440分（毎日）です。",
  "shopee.workspace.catalog-last-sync": "カタログの最終同期成功日時",
  "shopee.workspace.catalog-next-sync": "次回のカタログ同期",
  "shopee.workspace.select-shop-for-automation": "自動化を設定する店舗を選択してください。",
  "shopee.workspace.select-shop-for-listing": "商品を追加または編集する前に、対象店舗を選択してください。",
  "shopee.workspace.listing-load-incomplete": "Shopeeの商品データを一部読み込めませんでした。読み込み済みの内容を確認して再試行できます。",
  "shopee.workspace.listing-no-candidates": "Shopeeに公開できるVMASS商品がありません。",
  "shopee.workspace.setting.notify_new_order": "Shopee新規注文を通知",
  "shopee.workspace.setting.notify_status_change": "注文ステータス変更を通知",
  "shopee.workspace.setting.notify_return": "返品を通知",
  "shopee.workspace.inventory-safety-buffer": "Shopeeに公開しない安全在庫",
  "shopee.workspace.scope-not-granted": "ショップに必要なShopee権限が付与されていません：",
  "shopee.workspace.group.overview": "概要",
  "shopee.workspace.group.catalog": "在庫・商品",
  "shopee.workspace.group.logistics": "配送・財務",
  "shopee.workspace.group.system": "システム",
  "shopee.workspace.tab.overview": "概要",
  "shopee.workspace.tab.orders": "注文",
  "shopee.workspace.tab.products": "マルチチャネル商品",
  "shopee.workspace.tab.mappings": "商品マッピング",
  "shopee.workspace.tab.inventory": "チャネル別在庫",
  "shopee.workspace.tab.pricing": "チャネル別価格",
  "shopee.workspace.tab.shipping": "配送・梱包",
  "shopee.workspace.tab.returns": "返品・返金",
  "shopee.workspace.tab.reconciliation": "消込・入金",
  "shopee.workspace.tab.issues": "問題センター",
  "shopee.workspace.tab.connections": "チャネルと接続",
  "shopee.workspace.tab.connections-short": "販売チャネル",
  "shopee.workspace.tab.automation": "自動化",
  "shopee.workspace.tab.logs": "タスクログ",
  "shopee.workspace.connect-required.title": "Shopeeアカウントの接続が必要です",
  "shopee.workspace.connect-required.desc": "アカウントはまだどのShopeeショップにも接続されていません。レポートの表示、注文や商品の管理、在庫の同期を行うには、Shopeeショップを接続してください。",
  "shopee.workspace.connect-required.feature.orders": "注文の自動同期",
  "shopee.workspace.connect-required.feature.mapping": "SKUマッピングと在庫管理",
  "shopee.workspace.connect-required.feature.shipping": "配送状況の更新",
  "shopee.workspace.connect-required.feature.finance": "売上消込と入金管理",
  "shopee.workspace.connect-required.connecting": "接続中...",
  "shopee.workspace.connect-required.cta": "🚀 今すぐShopeeショップを接続",
  "shopee.workspace.sidebar.shops-header": "ショップ",
  "shopee.workspace.sidebar.add-shop-title": "新しいShopeeショップを接続",
  "shopee.workspace.sidebar.refresh-title": "データを更新",
  "shopee.workspace.sidebar.all-shops": "📊 すべてのショップ（{count}）",
  "shopee.workspace.sidebar.shop-fallback": "ショップ {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} チャネル接続済み",
  "shopee.workspace.sidebar.not-connected": "未接続",
  "shopee.workspace.common.sending-request": "リクエスト送信中...",
  "shopee.workspace.common.sync": "同期",
  "shopee.workspace.common.edit": "編集",
  "shopee.workspace.common.per-page": "{size} / ページ",
  "shopee.workspace.common.product-name": "商品名",
  "shopee.workspace.common.customer": "顧客",
  "shopee.workspace.common.previous": "前へ",
  "shopee.workspace.common.next": "次へ",
  "shopee.workspace.common.loading": "読み込み中...",
  "shopee.workspace.common.page": "ページ",
  "shopee.workspace.common.of": "/",
  "shopee.workspace.common.rows": "件",
  "shopee.workspace.common.all-statuses": "すべてのステータス",
  "shopee.workspace.common.all-channels": "すべてのチャネル",
  "shopee.workspace.common.filter": "フィルター",
  "shopee.workspace.common.tab-all-count": "すべて（{count}）",
  "shopee.workspace.common.view-all": "すべて表示",
  "shopee.workspace.common.total": "合計",
  "shopee.workspace.common.note": "メモ",
  "shopee.workspace.common.optional": "任意",
  "shopee.workspace.common.note-placeholder": "メモを入力...",
  "shopee.workspace.common.last-7-days": "過去7日間",
  "shopee.workspace.common.last-30-days": "過去30日間",
  "shopee.workspace.catalog.channel-all": "すべて",
  "shopee.workspace.catalog.not-synced-yet": "未同期",
  "shopee.workspace.catalog.minutes-ago": "{count}分前",
  "shopee.workspace.catalog.hours-ago": "{count}時間前",
  "shopee.workspace.catalog.channel-unlisted": "非公開",
  "shopee.workspace.catalog.publish-now": "今すぐ公開",
  "shopee.workspace.catalog.sync-error-short": "同期エラー",
  "shopee.workspace.catalog.out-of-stock": "在庫切れ",
  "shopee.workspace.catalog.listed": "公開中",
  "shopee.workspace.catalog.view-error": "エラーを見る",
  "shopee.workspace.catalog.mapping-saved": "商品マッピングを更新しました",
  "shopee.workspace.catalog.mapping-cleared": "VMASSからShopee商品のマッピングを解除しました",
  "shopee.workspace.catalog.inventory-sync-queued": "在庫同期をスケジュールしました",
  "shopee.workspace.catalog.import-queued": "カタログ取込をスケジュールしました",
  "shopee.workspace.catalog.kpi-total-listings": "出品数合計",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} 行のマッピング",
  "shopee.workspace.catalog.kpi-mapped": "マッピング済み",
  "shopee.workspace.catalog.kpi-page-percent": "ページ内 {percent}%",
  "shopee.workspace.catalog.kpi-unmapped": "未マッピング",
  "shopee.workspace.catalog.note-needs-action": "要対応",
  "shopee.workspace.catalog.kpi-sync-errors": "同期エラー",
  "shopee.workspace.catalog.note-priority": "優先的に対応",
  "shopee.workspace.catalog.kpi-out-of-stock": "在庫切れ",
  "shopee.workspace.catalog.note-at-shopee": "Shopeeチャネル上",
  "shopee.workspace.catalog.kpi-price-pending": "価格更新待ち",
  "shopee.workspace.catalog.note-sync-price": "価格の同調が必要",
  "shopee.workspace.catalog.filter-aria": "商品フィルター",
  "shopee.workspace.catalog.search-placeholder": "商品・SKU・バーコードを検索...",
  "shopee.workspace.catalog.channel-aria": "販売チャネル",
  "shopee.workspace.catalog.mapping-state-aria": "マッピング状態",
  "shopee.workspace.catalog.sync-state-aria": "同期状態",
  "shopee.workspace.catalog.mapping-all": "すべてのマッピング",
  "shopee.workspace.catalog.mapping-mapped": "マッピング済み",
  "shopee.workspace.catalog.mapping-unmapped": "未マッピング",
  "shopee.workspace.catalog.sync-state-all": "同期状態",
  "shopee.workspace.catalog.sync-state-error": "エラーあり",
  "shopee.workspace.catalog.add-product": "商品を追加",
  "shopee.workspace.catalog.select-all-aria": "すべての商品を選択",
  "shopee.workspace.catalog.col-product": "商品",
  "shopee.workspace.catalog.col-sku-vmass": "VMASS SKU",
  "shopee.workspace.catalog.col-price": "販売価格",
  "shopee.workspace.catalog.col-stock": "在庫",
  "shopee.workspace.catalog.col-sync-state": "同期ステータス",
  "shopee.workspace.catalog.col-last-update": "最終更新",
  "shopee.workspace.catalog.select-row-aria": "{name} を選択",
  "shopee.workspace.catalog.no-vmass-mapping": "VMASS未マッピング",
  "shopee.workspace.catalog.no-vmass-sku": "VMASS SKUなし",
  "shopee.workspace.catalog.open-detail-aria": "詳細を開く",
  "shopee.workspace.catalog.pagination-summary": "{total} 行のマッピング中 {from} - {to} を表示",
  "shopee.workspace.catalog.detail-sku-label": "VMASS SKU：",
  "shopee.workspace.catalog.detail-item-label": "Shopee商品：",
  "shopee.workspace.catalog.close-detail-aria": "詳細を閉じる",
  "shopee.workspace.catalog.nav-stock": "在庫",
  "shopee.workspace.catalog.nav-history": "履歴",
  "shopee.workspace.catalog.unmapped-badge": "未マッピング",
  "shopee.workspace.catalog.sku-shopee": "Shopee SKU",
  "shopee.workspace.catalog.update-mapping": "マッピングを更新",
  "shopee.workspace.catalog.map-product-btn": "商品をマッピング",
  "shopee.workspace.catalog.no-channel-info": "商品情報はまだありません",
  "shopee.workspace.catalog.publish-to": "{channel} に出品",
  "shopee.workspace.catalog.sync-shopee-catalog": "Shopeeカタログを同期",
  "shopee.workspace.catalog.unmap": "マッピング解除",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / 商品名",
  "shopee.workspace.catalog.draft-created": "在庫0のVMASS商品ドラフトを作成しました",
  "shopee.workspace.catalog.listing-show-queued": "出品表示リクエストをキューに追加しました",
  "shopee.workspace.catalog.listing-hide-queued": "出品非表示リクエストをキューに追加しました",
  "shopee.workspace.fulfillment.ship-queued": "配送リクエストをキューに追加しました",
  "shopee.workspace.returns.status.requested": "新規リクエスト",
  "shopee.workspace.returns.status.in-inspection": "検品中",
  "shopee.workspace.returns.status.waiting-refund": "返金待ち",
  "shopee.workspace.returns.status.processing": "処理中",
  "shopee.workspace.returns.status.completed": "完了",
  "shopee.workspace.returns.status.rejected": "却下",
  "shopee.workspace.returns.status.restocked": "入庫済み",
  "shopee.workspace.returns.status.waiting-confirm": "確認待ち",
  "shopee.workspace.returns.inspection-confirmed": "返品検品を確認し、在庫を更新しました",
  "shopee.workspace.returns.dispute-queued": "異議申し立てリクエストをキューに追加しました",
  "shopee.workspace.returns.customer-fallback": "顧客",
  "shopee.workspace.returns.reason-other": "その他",
  "shopee.workspace.returns.reason-detail-fallback": "返品リクエスト",
  "shopee.workspace.returns.item-fallback": "商品",
  "shopee.workspace.returns.subtitle": "返品・返金・交換リクエストを一元管理",
  "shopee.workspace.returns.export-excel": "Excel出力",
  "shopee.workspace.returns.report": "レポート",
  "shopee.workspace.returns.create-request": "返品リクエストを作成",
  "shopee.workspace.returns.kpi-requested-note": "新規・確認待ち",
  "shopee.workspace.returns.kpi-processing-note": "検品・処理中",
  "shopee.workspace.returns.kpi-waiting-refund-note": "返金待ち",
  "shopee.workspace.returns.kpi-completed-note": "処理完了",
  "shopee.workspace.returns.kpi-rejected-note": "却下されたリクエスト",
  "shopee.workspace.returns.total-refund-today": "本日の返金合計",
  "shopee.workspace.returns.return-value-today": "本日の返品額",
  "shopee.workspace.returns.pipeline.customer-request": "顧客がリクエスト",
  "shopee.workspace.returns.pipeline.inspect": "商品検品",
  "shopee.workspace.returns.pipeline.approve": "返品承認",
  "shopee.workspace.returns.pipeline.restock-dispose": "入庫 / 廃棄",
  "shopee.workspace.returns.pipeline.refund": "返金",
  "shopee.workspace.returns.search-placeholder": "返品コード・注文番号・名前・電話番号を検索...",
  "shopee.workspace.returns.all-reasons": "すべての理由",
  "shopee.workspace.returns.all-warehouses": "すべての倉庫",
  "shopee.workspace.returns.no-data": "返品リクエストはありません",
  "shopee.workspace.returns.detail-title": "返品詳細",
  "shopee.workspace.returns.original-order": "元の注文",
  "shopee.workspace.returns.customer-media": "顧客の写真/動画",
  "shopee.workspace.returns.no-media": "顧客は写真を添付していません",
  "shopee.workspace.returns.returned-products": "返品商品",
  "shopee.workspace.returns.qty-label": "数量",
  "shopee.workspace.returns.inspection-title": "返品商品の検品",
  "shopee.workspace.returns.check.intact": "商品に破損なし",
  "shopee.workspace.returns.check.packaging": "包装・ラベル",
  "shopee.workspace.returns.check.accessories": "付属品完備",
  "shopee.workspace.returns.check.correct-product": "正しい商品",
  "shopee.workspace.returns.check.defect": "不具合 / 破損",
  "shopee.workspace.returns.processing-title": "返品処理",
  "shopee.workspace.returns.action.restock": "入庫",
  "shopee.workspace.returns.action.exchange": "交換",
  "shopee.workspace.returns.action.discard": "廃棄",
  "shopee.workspace.returns.restock-warehouse": "入庫倉庫",
  "shopee.workspace.returns.confirm-continue": "確認して続行",
  "shopee.workspace.returns.popular-reasons": "返品理由ランキング",
  "shopee.workspace.returns.no-reason-data": "理由データはまだありません",
  "shopee.workspace.returns.top-returned": "返品の多い商品トップ",
  "shopee.workspace.returns.times-suffix": "回",
  "shopee.workspace.returns.no-returned-products": "返品商品はまだありません",
  "shopee.workspace.returns.refund-trend": "期間別返金額",
  "shopee.workspace.returns.performance": "処理パフォーマンス",
  "shopee.workspace.returns.avg-processing-time": "平均処理時間",
  "shopee.workspace.returns.on-time-rate": "期限内完了率",
  "shopee.workspace.returns.sample-processing-time": "1.8日",
  "shopee.workspace.returns.sample-processing-delta": "-0.3日",
  "shopee.workspace.returns.dispute-modal-title": "Shopeeに異議申し立て",
  "shopee.workspace.returns.inspection-modal-title": "返品検品フォーム",
  "shopee.workspace.returns.condition-placeholder": "受け取った商品の実際の状態を入力してください...",
  "shopee.workspace.returns.stock-decision": "在庫処理の決定",
  "shopee.workspace.returns.stock.resellable": "1. 無傷 -> 販売在庫に戻す",
  "shopee.workspace.returns.stock.defective": "2. 破損 / 汚れ -> 不良在庫へ",
  "shopee.workspace.returns.stock.discard": "3. 大破損 / 廃棄 -> 入庫しない",
  "shopee.workspace.returns.stock.shortage": "4. 商品不足 / すり替え -> 不足報告を作成",
  "shopee.workspace.returns.evidence-placeholder": "検品証拠の写真/動画リンク（URL 1、URL 2）...",
  "shopee.workspace.returns.col.sn": "返品コード",
  "shopee.workspace.returns.col.order": "元の注文",
  "shopee.workspace.returns.col.channel": "チャネル",
  "shopee.workspace.returns.col.reason": "返品理由",
  "shopee.workspace.returns.col.refund-value": "返金額",
  "shopee.workspace.returns.col.warehouse": "倉庫",
  "shopee.workspace.returns.col.status": "ステータス",
  "shopee.workspace.returns.col.created-at": "作成日時",
  "shopee.workspace.returns.action.inspect": "検品して入庫",
  "shopee.workspace.returns.action.dispute": "Shopeeに異議申し立てを作成",
  "shopee.workspace.returns.view-detail-title": "詳細を見る",
  "shopee.workspace.automation.settings-saved": "自動化設定を保存しました",
  "shopee.workspace.logs.replayed": "ジョブを再実行しました",
  "shopee.workspace.common.detail": "詳細",
  "shopee.workspace.common.page-count": "/ {total} ページ",
  "shopee.workspace.common.no-data": "データはまだありません",
  "shopee.workspace.common.close": "閉じる",
  "shopee.workspace.orders.status.all": "すべて",
  "shopee.workspace.orders.status.unpaid": "未払い",
  "shopee.workspace.orders.status.ready-to-ship": "対応待ち",
  "shopee.workspace.orders.status.processed": "処理済み",
  "shopee.workspace.orders.status.shipped": "配送中",
  "shopee.workspace.orders.status.to-confirm-receive": "受け取り確認待ち",
  "shopee.workspace.orders.status.completed": "配達完了",
  "shopee.workspace.orders.status.in-cancel": "キャンセル中",
  "shopee.workspace.orders.status.cancelled": "キャンセル済み",
  "shopee.workspace.orders.status-unknown": "不明",
  "shopee.workspace.orders.metric.total": "注文合計",
  "shopee.workspace.orders.metric.total-indicator": "ページ内 {count} 件",
  "shopee.workspace.orders.metric.pending": "対応待ち",
  "shopee.workspace.orders.metric.pending-indicator": "ページの {percent}%",
  "shopee.workspace.orders.metric.deadline": "出荷期限要注視",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} 件が期限超過",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} 件に期限あり",
  "shopee.workspace.orders.metric.deadline-none": "出荷待ちの注文はありません",
  "shopee.workspace.orders.metric.gmv": "注文GMV",
  "shopee.workspace.orders.metric.gmv-indicator": "金額あり {paid}/{eligible} 件",
  "shopee.workspace.orders.metric.delivered": "配達完了",
  "shopee.workspace.orders.tabs-region-aria": "注文ステータスバー。横にスクロールして表示",
  "shopee.workspace.orders.count-tooltip": "現在のページの注文数",
  "shopee.workspace.orders.select-all-aria": "すべての注文を選択",
  "shopee.workspace.orders.select-row-aria": "注文 {sn} を選択",
  "shopee.workspace.orders.col.sn": "注文コード",
  "shopee.workspace.orders.col.channel": "チャネル",
  "shopee.workspace.orders.col.items": "商品",
  "shopee.workspace.orders.col.amount": "合計金額",
  "shopee.workspace.orders.col.tracking": "追跡番号",
  "shopee.workspace.orders.col.time": "日時",
  "shopee.workspace.orders.phone-hidden": "情報は非表示",
  "shopee.workspace.orders.items-count": "{count} 点",
  "shopee.workspace.orders.items-total-x": "合計 x{count}",
  "shopee.workspace.orders.paid-time": "支払日時 {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopeeから支払日時が返されていません",
  "shopee.workspace.orders.sync-queued": "注文同期をスケジュールしました",
  "shopee.workspace.orders.sync-button": "注文を同期",
  "shopee.workspace.orders.selection-banner": "{count} 件の注文を選択中。",
  "shopee.workspace.orders.export-selected": "選択した注文を出力",
  "shopee.workspace.orders.clear-selection": "選択解除",
  "shopee.workspace.orders.empty": "一致する注文はありません。",
  "shopee.workspace.orders.showing-summary": "{total} 件中 {shown} 件の注文を表示",
  "shopee.workspace.orders.filter-title": "検索フィルター",
  "shopee.workspace.orders.clear-filters": "フィルターをクリア",
  "shopee.workspace.orders.filter-status-label": "注文ステータス",
  "shopee.workspace.orders.filter-search-label": "検索キーワード",
  "shopee.workspace.orders.search-placeholder": "注文コードまたは追跡番号...",
  "shopee.workspace.orders.apply-filters": "フィルターを適用",
  "shopee.workspace.orders.chart-title": "ページ内ステータス分布",
  "shopee.workspace.orders.detail-title": "Shopee注文詳細 #{orderSn}",
  "shopee.workspace.orders.detail-loading": "注文詳細を読み込み中...",
  "shopee.workspace.orders.detail-load-error": "追加の注文詳細を読み込めませんでした。",
  "shopee.workspace.orders.phone-label": "電話番号:",
  "shopee.workspace.orders.tracking-label": "追跡番号:",
  "shopee.workspace.orders.total-shopee": "Shopee合計金額",
  "shopee.workspace.orders.created-at": "注文作成日時",
  "shopee.workspace.orders.ship-deadline": "Shopee出荷期限",
  "shopee.workspace.orders.items-title": "商品リスト（{count}）",
  "shopee.workspace.orders.price-per-item": "{price} / 点",
  "shopee.workspace.orders.create-bill": "VMASS請求書を作成",
  "shopee.workspace.orders.bill-created": "Shopee注文から請求書を作成しました",
  "shopee.workspace.orders.csv.order-code": "注文コード",
  "shopee.workspace.orders.csv.phone": "電話番号",
  "shopee.workspace.orders.csv.products": "商品",
  "shopee.workspace.orders.csv.amount": "合計金額",
  "shopee.workspace.overview.webhook.configured": "設定済み",
  "shopee.workspace.overview.webhook.processing": "処理中",
  "shopee.workspace.overview.webhook.degraded": "要確認",
  "shopee.workspace.overview.webhook.not-configured": "未設定",
  "shopee.workspace.overview.webhook.unknown": "不明",
  "shopee.workspace.overview.kpi.new-orders": "新規注文",
  "shopee.workspace.overview.kpi.new-trend": "新着",
  "shopee.workspace.overview.kpi.new-comparison": "本日の新規注文",
  "shopee.workspace.overview.kpi.pending": "対応待ち / 梱包",
  "shopee.workspace.overview.kpi.pending-trend": "要対応",
  "shopee.workspace.overview.kpi.pending-comparison": "引き渡し準備完了",
  "shopee.workspace.overview.kpi.expiring": "出荷期限が近い注文",
  "shopee.workspace.overview.kpi.expiring-priority": "優先",
  "shopee.workspace.overview.kpi.expiring-safe": "安全",
  "shopee.workspace.overview.kpi.expiring-comparison": "早めに対応が必要",
  "shopee.workspace.overview.kpi.gmv": "本日の売上（GMV）",
  "shopee.workspace.overview.kpi.gmv-trend": "GMV合計",
  "shopee.workspace.overview.kpi.gmv-comparison": "総売上",
  "shopee.workspace.overview.kpi.ontime": "期限内配達率",
  "shopee.workspace.overview.kpi.ontime-trend": "基準達成",
  "shopee.workspace.overview.kpi.ontime-comparison": "パフォーマンス指標",
  "shopee.workspace.overview.issue.orders": "対応が必要な注文",
  "shopee.workspace.overview.issue.orders-desc": "配送期限を守るために対応が必要な注文。",
  "shopee.workspace.overview.issue.mappings": "対応が必要なマッピング",
  "shopee.workspace.overview.issue.mappings-desc": "未マッピングまたは誤ってマッピングされたSKU。",
  "shopee.workspace.overview.issue.jobs": "失敗ジョブ",
  "shopee.workspace.overview.issue.jobs-desc": "失敗した同期タスクの確認が必要です。",
  "shopee.workspace.overview.issue.products": "情報不足の商品",
  "shopee.workspace.overview.issue.products-desc": "一部チャネルで情報が不足している商品。",
  "shopee.workspace.overview.issue.reconciliation": "消込差異",
  "shopee.workspace.overview.issue.reconciliation-desc": "消込が必要な差異のある注文。",
  "shopee.workspace.overview.shop-fallback": "Shopee - ショップ {shopId}",
  "shopee.workspace.overview.shop-label": "ショップ {shopId}",
  "shopee.workspace.overview.activity.sync-default": "同期",
  "shopee.workspace.overview.activity.just-now": "たった今",
  "shopee.workspace.overview.activity.success": "成功",
  "shopee.workspace.overview.activity.attempts": "{count} 回実行",
  "shopee.workspace.overview.banner-title": "Shopeeチャネルの健全性とパフォーマンス概要",
  "shopee.workspace.overview.banner-healthy": "システム正常",
  "shopee.workspace.overview.banner-attention": "要注意",
  "shopee.workspace.overview.banner-shops-updated": "{count} ショップ接続中 | 更新時刻: {time}",
  "shopee.workspace.overview.period.today": "今日",
  "shopee.workspace.overview.period.week": "7日間",
  "shopee.workspace.overview.period.month": "30日間",
  "shopee.workspace.overview.reload": "データを再読み込み",
  "shopee.workspace.overview.mapping-title": "SKUマッピング進捗",
  "shopee.workspace.overview.mapping-tooltip": "ShopeeとVMASS間の実在庫同期",
  "shopee.workspace.overview.mapping-percent": "{percent}% マッピング済み",
  "shopee.workspace.overview.mapping-progress": "{total} SKUのうち {mapped} SKUをマッピング済み",
  "shopee.workspace.overview.mapping-note": "新規注文時に実在庫を自動同期し、過剰販売を防止します。",
  "shopee.workspace.overview.mapping-action": "今すぐSKUをマッピング",
  "shopee.workspace.overview.health-title": "同期の健全性とShopee接続状態",
  "shopee.workspace.overview.last-sync": "前回の同期：",
  "shopee.workspace.overview.sparkline-label": "リアルタイム接続ステータス",
  "shopee.workspace.overview.oauth-label": "OAuthトークン:",
  "shopee.workspace.overview.oauth-valid": "有効",
  "shopee.workspace.overview.oauth-invalid": "期限切れ",
  "shopee.workspace.overview.api-label": "API健全性:",
  "shopee.workspace.overview.api-good": "良好（正常）",
  "shopee.workspace.overview.api-bad": "要確認",
  "shopee.workspace.overview.issues-title": "問題センター",
  "shopee.workspace.overview.manage-connections": "接続を管理",
  "shopee.workspace.overview.channels-title": "販売チャネル",
  "shopee.workspace.overview.channel-active": "稼働中",
  "shopee.workspace.overview.channel-error": "接続エラー",
  "shopee.workspace.overview.new-orders-colon": "新規注文:",
  "shopee.workspace.overview.no-shops": "接続済みショップはまだありません",
  "shopee.workspace.overview.connect-more": "別の販売チャネルを接続",
  "shopee.workspace.overview.view-logs": "ログを見る",
  "shopee.workspace.overview.activity-title": "最近の同期アクティビティ",
  "shopee.workspace.overview.no-activity": "最近のアクティビティログはまだありません",
  "shopee.workspace.overview.top-products": "売れ筋商品トップ",
  "shopee.workspace.overview.top-products-note": "注文数順",
  "shopee.workspace.overview.top-period": "過去7日間の統計",
  "shopee.workspace.overview.product-unknown": "未特定の商品",
  "shopee.workspace.overview.sold-count": "{count} 注文",
  "shopee.workspace.overview.no-products": "商品データはまだありません",
  "shopee.workspace.overview.revenue-title": "チャネル別売上分布",
  "shopee.workspace.overview.revenue-period": "過去7日間の売上",
  "shopee.workspace.overview.revenue-total-aria": "総売上 {amount}",
  "shopee.workspace.overview.total-revenue": "総売上",
  "shopee.workspace.error.no-response": "Shopeeへのリクエストが応答しません。RedisとShopeeワーカーを確認してから再試行してください。",
  "shopee.workspace.error.load-failed": "Shopeeデータを読み込めません",
  "shopee.workspace.notice.job-completed": "Shopeeタスクが完了しました",
  "shopee.workspace.notice.job-ended-status": "Shopeeタスクはステータス {status} で終了しました",
  "shopee.workspace.notice.job-status-updated": "ジョブ {status}",
  "shopee.workspace.notice.job-status-default": "更新済み",
  "shopee.workspace.notice.new-order": "Shopeeから新しい注文を受け取りました",
  "shopee.workspace.notice.action-queued": "タスクをキューに追加しました",
  "shopee.workspace.notice.action-success": "更新に成功しました",
  "shopee.workspace.common.back": "戻る",
  "shopee.workspace.common.next-step": "次へ",
  "shopee.workspace.connections.title": "販売チャネルと接続済みショップ",
  "shopee.workspace.connections.subtitle": "OAuth認証、同期ポリシー、Shopeeショップ接続を管理",
  "shopee.workspace.connections.add-shop-wizard": "新しいShopeeショップを追加（6ステップウィザード）",
  "shopee.workspace.connections.status-active": "稼働中",
  "shopee.workspace.connections.region-id": "リージョン: {region} | ショップID: {shopId}",
  "shopee.workspace.connections.scopes-label": "認証済みスコープ：",
  "shopee.workspace.connections.scope.orders": "注文",
  "shopee.workspace.connections.scope.catalog": "カタログ",
  "shopee.workspace.connections.scope.stock": "在庫",
  "shopee.workspace.connections.scope.finance": "財務",
  "shopee.workspace.connections.scope.return": "返品",
  "shopee.workspace.connections.last-sync-colon": "前回の同期:",
  "shopee.workspace.connections.reauth-title": "再認証",
  "shopee.workspace.connections.reauth": "OAuthを再実行",
  "shopee.workspace.connections.disconnect-title": "接続解除",
  "shopee.workspace.connections.disconnected-notice": "ショップ {shop} の接続を解除しました",
  "shopee.workspace.connections.disconnect-btn": "解除",
  "shopee.workspace.connections.empty": "接続済みのShopeeショップはまだありません。",
  "shopee.workspace.connections.connect-new": "+ 新しいShopeeショップを接続",
  "shopee.workspace.connections.wizard.title": "Shopeeショップ接続・有効化ウィザード（ステップ {step}/6）",
  "shopee.workspace.connections.wizard.step1-title": "ステップ1: Shopee OAuth 接続と認証",
  "shopee.workspace.connections.wizard.step1-desc": "ショップにログインするため、Shopee Partner Platform の公式認証ページへリダイレクトされます。",
  "shopee.workspace.connections.wizard.step1-permissions": "アクセス権限には以下が含まれます:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "注文の読み書き、カタログ同期、在庫数の更新、精算履歴の閲覧。",
  "shopee.workspace.connections.wizard.open-oauth": "Shopeeのログイン・認証ページへ移動",
  "shopee.workspace.connections.wizard.step2-title": "ステップ2: 初期データ取込の選択",
  "shopee.workspace.connections.wizard.step2-desc": "ShopeeからVMASSへ取り込むデータ種類を選択してください:",
  "shopee.workspace.connections.wizard.step2-products": "Shopeeのすべての商品とバリエーション",
  "shopee.workspace.connections.wizard.step2-orders": "過去30日間の注文",
  "shopee.workspace.connections.wizard.step2-logistics": "集荷住所と配送パートナー情報",
  "shopee.workspace.connections.wizard.step3-title": "ステップ3: マスターデータ（Source of Truth）の決定",
  "shopee.workspace.connections.wizard.step3-desc": "マスターとなる在庫数を管理するシステムを決定します:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASSをマスターにする（推奨）：",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "注文処理後、VMASSの在庫が自動的にShopeeへ送信されます。",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopeeを初期値にする：",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "初回同期の基準としてShopee上の現在の在庫数を使用します。",
  "shopee.workspace.connections.wizard.step4-title": "ステップ4: SKUマッピングの確認",
  "shopee.workspace.connections.wizard.step4-info": "Shopee SKUの85%がVMASS倉庫のSKUと完全に一致しています。これらのSKUは自動的にマッピングされます。",
  "shopee.workspace.connections.wizard.step4-note": "未マッピングのSKUは有効化後、「商品マッピング」タブで管理できます。",
  "shopee.workspace.connections.wizard.step5-title": "ステップ5: 在庫・価格ポリシーの設定",
  "shopee.workspace.connections.wizard.allocation-label": "在庫配分モード",
  "shopee.workspace.connections.wizard.option-shared": "SHARED（販売可能在庫を100%共有）",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED（固定枠を確保）",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE（割合で分配）",
  "shopee.workspace.connections.wizard.safety-buffer-label": "安全在庫（Safety Buffer）",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "複数チャネルでの販売における過剰販売を防止します。",
  "shopee.workspace.connections.wizard.step6-title": "ステップ6: 確認とショップの有効化",
  "shopee.workspace.connections.wizard.step6-ready-strong": "有効化できます！",
  "shopee.workspace.connections.wizard.step6-ready-detail": "すべての設定が有効で、重大な競合はありません。",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Shopee Partner API v2 の認証が完了",
  "shopee.workspace.connections.wizard.check-sot": "✔ マスター在庫: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ 在庫モード: {mode}（安全在庫: {buffer}）",
  "shopee.workspace.connections.wizard.opening-shopee": "Shopeeポータルを開いています...",
  "shopee.workspace.connections.wizard.connect-now": "今すぐShopee OAuthに接続",
  "shopee.workspace.connections.wizard.activate-done": "新しいShopeeショップを有効化しました",
  "shopee.workspace.connections.wizard.activate-now": "今すぐショップを有効化",
  "shopee.workspace.inventory.status.unknown": "データ不足",
  "shopee.workspace.inventory.status.unmapped": "VMASS未マッピング",
  "shopee.workspace.inventory.status.error": "同期エラー",
  "shopee.workspace.inventory.status.out-of-stock": "Shopee在庫切れ",
  "shopee.workspace.inventory.status.variance": "差異",
  "shopee.workspace.inventory.status.synced": "同期済み",
  "shopee.workspace.inventory.no-name": "Shopeeが商品名を提供していません",
  "shopee.workspace.inventory.sub.on-page": "現在のページ",
  "shopee.workspace.inventory.sub.by-filter": "現在のフィルター条件",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "読み込み済みマッピングデータに基づく",
  "shopee.workspace.inventory.kpi.total": "Shopeeマッピング合計",
  "shopee.workspace.inventory.kpi.synced-sub": "読み込み済み {count} 行のうち",
  "shopee.workspace.inventory.kpi.variance": "在庫差異",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} 件の同期エラー",
  "shopee.workspace.inventory.kpi.last-sync": "最終更新",
  "shopee.workspace.inventory.col.vmass-stock": "VMASS在庫",
  "shopee.workspace.inventory.col.total": "合計",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "状態",
  "shopee.workspace.inventory.col.updated": "更新",
  "shopee.workspace.inventory.col.last": "最終",
  "shopee.workspace.inventory.img-placeholder-aria": "商品画像なし",
  "shopee.workspace.inventory.title": "Shopee在庫",
  "shopee.workspace.inventory.subtitle": "VMASSの販売可能在庫と同期済みShopeeカタログを突き合わせます。",
  "shopee.workspace.inventory.manage-mapping": "商品マッピングを管理",
  "shopee.workspace.inventory.search-placeholder": "商品またはShopee SKUを検索...",
  "shopee.workspace.inventory.filter.all": "すべての状態",
  "shopee.workspace.inventory.shop-colon": "ショップ:",
  "shopee.workspace.inventory.no-shop-selected": "ショップ未選択",
  "shopee.workspace.inventory.loading": "Shopeeデータを読み込み中...",
  "shopee.workspace.inventory.empty": "フィルターに一致するShopeeマッピングはありません。",
  "shopee.workspace.inventory.pagination-summary": "{total} 件のShopeeマッピング中 {from} - {to} を表示",
  "shopee.workspace.inventory.side.overview-title": "在庫概要",
  "shopee.workspace.inventory.legend.filtered": "フィルター条件のマッピング",
  "shopee.workspace.inventory.legend.synced-page": "ページ内同期済み",
  "shopee.workspace.inventory.legend.variance-page": "ページ内差異あり",
  "shopee.workspace.inventory.side.top-variance": "在庫差異トップ",
  "shopee.workspace.inventory.side.no-variance": "読み込み済みデータに在庫差異はありません。",
  "shopee.workspace.inventory.side.alerts-title": "在庫アラート",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} 商品がShopeeで在庫切れ",
  "shopee.workspace.inventory.alert.variance": "{count} 商品に在庫差異あり",
  "shopee.workspace.inventory.alert.variance-desc": "ShopeeとVMASSに差があります",
  "shopee.workspace.inventory.alert.unmapped": "{count} 商品がVMASS未マッピング",
  "shopee.workspace.inventory.alert.unmapped-desc": "比較前に商品をマッピングしてください",
  "shopee.workspace.pricing.kpi.total": "SKU合計",
  "shopee.workspace.pricing.kpi.synced": "価格同期済み",
  "shopee.workspace.pricing.kpi.variance": "価格差異",
  "shopee.workspace.pricing.kpi.pending": "未更新",
  "shopee.workspace.pricing.kpi.pending-sub": "ShopeeまたはVMASSの価格が不足",
  "shopee.workspace.pricing.kpi.errors": "価格エラー",
  "shopee.workspace.pricing.subtitle": "VMASSと販売チャネル間の商品価格を管理・同期します",
  "shopee.workspace.pricing.search-placeholder": "商品名・SKU・バーコードを検索...",
  "shopee.workspace.pricing.category.all": "すべてのカテゴリ",
  "shopee.workspace.pricing.category.fashion": "ファッション",
  "shopee.workspace.pricing.category.electronics": "電子機器",
  "shopee.workspace.pricing.category.food": "食品",
  "shopee.workspace.pricing.warehouse.main": "主要倉庫",
  "shopee.workspace.pricing.warehouse.hanoi": "ハノイ倉庫",
  "shopee.workspace.pricing.warehouse.hcm": "ホーチミン倉庫",
  "shopee.workspace.pricing.pagination-summary": "{total} 商品中 {from} - {to} を表示",
  "shopee.workspace.pricing.col.vmass-price": "VMASS価格",
  "shopee.workspace.pricing.col.price-small": "販売価格",
  "shopee.workspace.pricing.col.diff-range": "最高 - 最低",
  "shopee.workspace.pricing.action.adjust-price": "価格調整",
  "shopee.workspace.pricing.action.sync-price-list": "価格リストを同期",
  "shopee.workspace.pricing.action.cancel-rule": "価格ルールを取消",
  "shopee.workspace.pricing.action.sync-price": "価格を同期",
  "shopee.workspace.pricing.action.batch-update": "一括更新",
  "shopee.workspace.pricing.action.price-rules": "価格ルール",
  "shopee.workspace.pricing.alert.higher": "{count} 商品が高価格",
  "shopee.workspace.pricing.alert.lower": "{count} 商品が低価格",
  "shopee.workspace.pricing.alert.unavailable": "{count} 商品の価格データ不足",
  "shopee.workspace.pricing.alert.threshold-desc": "VMASS比 > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "ページ内",
  "shopee.workspace.pricing.side.variance-title": "価格差異概要",
  "shopee.workspace.pricing.side.top-variance": "価格差異トップ",
  "shopee.workspace.pricing.side.no-variance": "読み込み済みShopeeデータに価格差異はありません。",
  "shopee.workspace.pricing.side.alerts-title": "価格アラート",
  "shopee.workspace.pricing.rule.title": "チャネル別販売価格ルール設定",
  "shopee.workspace.pricing.rule.policy-mode": "価格ポリシーモード",
  "shopee.workspace.pricing.rule.option-direct": "VMASS価格を直接使用",
  "shopee.workspace.pricing.rule.option-percent": "率による値上げ",
  "shopee.workspace.pricing.rule.option-fixed": "固定額の上乗せ",
  "shopee.workspace.pricing.rule.option-cost-plus": "原価＋経費＋利益",
  "shopee.workspace.pricing.rule.markup-percent-label": "上乗せ率 (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "上乗せ金額 (VND)",
  "shopee.workspace.pricing.rule.fee-label": "想定チャネル手数料 (%)",
  "shopee.workspace.pricing.rule.packaging-label": "梱包費用 (VND)",
  "shopee.workspace.pricing.rule.rounding-label": "丸めルール",
  "shopee.workspace.pricing.rule.rounding-none": "丸めなし",
  "shopee.workspace.pricing.rule.rounding-thousand": "千円単位 (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "9.000 末尾 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "適用式:",
  "shopee.workspace.pricing.rule.formula-text": "チャネル価格 = [VMASS価格 + 固定費] / (1 - チャネル手数料%) -> 丸め処理。",
  "shopee.workspace.pricing.rule.preview-no-base": "プレビュー用のVMASS価格が読み込み済みShopeeデータにありません。",
  "shopee.workspace.pricing.rule.preview-from": "VMASS価格 {base} からのプレビュー: {result}",
  "shopee.workspace.pricing.rule.save-preview": "ルールを保存してプレビュー",
  "shopee.workspace.pricing.approve.title": "一括価格リストのShopeeへの承認・送信の確認",
  "shopee.workspace.pricing.approve.warning-strong": "安全警告:",
  "shopee.workspace.pricing.approve.warning-detail": "この操作により新しい価格ルールが適用され、商品価格リストがShopeeへ同期されます。",
  "shopee.workspace.pricing.approve.items-total": "商品総数",
  "shopee.workspace.pricing.approve.rule-applied": "適用ルール",
  "shopee.workspace.pricing.approve.fee-deducted": "控除されるチャネル手数料",
  "shopee.workspace.pricing.approve.queued": "Shopeeへの一括価格更新タスクを開始しました",
  "shopee.workspace.pricing.approve.confirm": "承認して価格を更新",
  "shopee.workspace.mapping.model-simple": "単一商品",
  "shopee.workspace.mapping.draft-created-from-listing": "Shopee出品からVMASS商品を作成しました",
  "shopee.workspace.mapping.no-provider-data": "Shopeeからデータが提供されていません",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · 価格 {price} · 在庫 {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "価格 {price} · 在庫 {stock}",
  "shopee.workspace.mapping.stock-colon": "在庫:",
  "shopee.workspace.mapping.price-label": "価格",
  "shopee.workspace.mapping.col.vmass-product": "VMASS上の商品",
  "shopee.workspace.mapping.col.mapping": "マッピング",
  "shopee.workspace.mapping.pick-product-aria": "マッピングするVMASS商品を選択",
  "shopee.workspace.mapping.no-mapping-permission": "商品をマッピングする権限がありません",
  "shopee.workspace.common.pick-product": "商品を選択",
  "shopee.workspace.common.retry": "再試行",
  "shopee.workspace.common.yes": "はい",
  "shopee.workspace.common.no": "いいえ",
  "shopee.workspace.mapping.state-conflict": "競合",
  "shopee.workspace.mapping.auto-map-launched": "{count} 件のShopeeマッピングの自動マッピングを開始しました",
  "shopee.workspace.mapping.inventory-sync-queued": "Shopee商品の在庫同期をスケジュールしました",
  "shopee.workspace.mapping.no-shop-selected": "Shopeeショップが選択されていません。実際のマッピングデータを読み込むにはショップに接続または選択してください。",
  "shopee.workspace.mapping.kpi.total-sub": "APIから {count} 行のマッピング",
  "shopee.workspace.mapping.kpi.rate-page": "現在のページの {percent}%",
  "shopee.workspace.mapping.kpi.rate": "マッピング率",
  "shopee.workspace.mapping.search-placeholder": "SKU・バーコード・商品名を検索...",
  "shopee.workspace.mapping.title": "Shopeeマッピング",
  "shopee.workspace.mapping.data-scope-banner": "ショップ {shop} のデータ。ステータス指標は現在のページで計算されます。",
  "shopee.workspace.mapping.shop-unselected": "未選択",
  "shopee.workspace.mapping.loading": "Shopeeからマッピングデータを読み込み中...",
  "shopee.workspace.mapping.empty": "ショップと現在のフィルターに一致するマッピングはShopeeから返されませんでした。",
  "shopee.workspace.mapping.detail-title": "マッピング詳細",
  "shopee.workspace.mapping.tab-info": "情報",
  "shopee.workspace.mapping.tab-history": "履歴",
  "shopee.workspace.mapping.status.disabled": "同期停止",
  "shopee.workspace.mapping.status.error": "同期エラー",
  "shopee.workspace.mapping.status.healthy": "正常",
  "shopee.workspace.mapping.status.mapping-required": "未マッピング",
  "shopee.workspace.mapping.status.out-of-stock": "在庫切れ",
  "shopee.workspace.mapping.section-vmass": "VMASS情報",
  "shopee.workspace.mapping.section-shopee": "Shopeeデータ",
  "shopee.workspace.mapping.available-stock": "利用可能在庫",
  "shopee.workspace.mapping.shopee-name-colon": "Shopee上の名称:",
  "shopee.workspace.mapping.not-linked": "Shopeeチャネルに未リンク",
  "shopee.workspace.mapping.sync-enabled-colon": "同期許可:",
  "shopee.workspace.mapping.auto-map-this": "このSKUを自動マッピング",
  "shopee.workspace.mapping.change": "マッピング変更",
  "shopee.workspace.mapping.remove": "マッピング解除",
  "shopee.workspace.mapping.history-created": "マッピング作成:",
  "shopee.workspace.mapping.history-updated": "マッピング更新:",
  "shopee.workspace.mapping.history-last-sync": "前回Shopee同期:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "在庫をShopeeへ同期",
  "shopee.workspace.mapping.modal-title": "マッピングするVMASS商品を選択",
  "shopee.workspace.mapping.candidate-search-placeholder": "VMASSの商品名・SKU・バーコードで検索",
  "shopee.workspace.mapping.candidates-loading": "VMASS商品を読み込み中...",
  "shopee.workspace.mapping.choose-product": "VMASS商品を選択",
  "shopee.workspace.mapping.nameless-product": "名称なし商品",
  "shopee.workspace.mapping.choose-variant": "VMASSのバリアントを選択",
  "shopee.workspace.mapping.no-variants-note": "このVMASS商品にはバリアントがありません。マッピングでは親商品の在庫を使用します。",
  "shopee.workspace.mapping.no-candidates": "検索に一致するVMASS商品はありません。",
  "shopee.workspace.mapping.create-product": "新規商品を作成",
  "shopee.workspace.mapping.save": "マッピングを保存",
  "shopee.workspace.mapping.auto-map-selected": "選択を自動マッピング（{count}）",
  "einvoice.filter.issuance-status": "発行ステータス",
  "einvoice.filter.invoice-status": "請求書ステータス",
  "einvoice.filter.all": "すべて",
  "einvoice.issuance-status.pending": "処理中",
  "einvoice.issuance-status.success": "成功",
  "einvoice.issuance-status.failed": "失敗",
  "einvoice.invoice-status.draft": "下書き",
  "einvoice.invoice-status.issued": "発行済み",
  "template.badge": "サンプルデータ",
  "template.convert": "実データに変換",
  "product.btn-update": "商品を更新",
  "template.profile.title": "ガイド用サンプルデータ",
  "template.profile.description": "サンプルの商品と原材料でシステムを確認できます。必要に応じて非表示または再表示できます。",
  "template.profile.dismiss": "サンプルデータを非表示",
  "template.profile.show": "サンプルデータを再表示",
  "template.profile.confirm": "サンプルデータとそれから作成した注文は非表示になり、使用したサンプル在庫は復元されます。続行しますか？",
  "template.profile.show-confirm": "サンプルデータを再度表示してもよろしいですか？",
  "template.profile.success": "サンプルデータを非表示にしました",
  "template.profile.show-success": "サンプルデータを再表示しました！",
  "shopee.workspace.shipping.customer-fallback": "顧客 {number}",
  "shopee.workspace.shipping.product-fallback": "Shopee商品",
  "shopee.workspace.shipping.service-standard": "標準配送",
  "shopee.workspace.shipping.status.ready-pickup": "集荷待ち",
  "shopee.workspace.shipping.status.processing": "処理中",
  "shopee.workspace.shipping.checklist.inspect": "商品の検品",
  "shopee.workspace.shipping.checklist.protect": "緩衝梱包",
  "shopee.workspace.shipping.col.order-sub": "注文コード | チャネル",
  "shopee.workspace.shipping.col.phone-sub": "電話",
  "shopee.workspace.shipping.col.amount": "商品金額",
  "shopee.workspace.shipping.col.progress-sub": "進捗",
  "shopee.workspace.shipping.print-slip-title": "伝票印刷",
  "shopee.workspace.shipping.alert.print-slip": "注文 {sn} の配送伝票を印刷",
  "shopee.workspace.shipping.alert.update-status": "注文 {sn} のステータスを更新",
  "shopee.workspace.shipping.action.update-status": "ステータスを更新",
  "shopee.workspace.shipping.alert.cancel-order": "注文 {sn} をキャンセル",
  "shopee.workspace.shipping.action.cancel-order": "注文をキャンセル",
  "shopee.workspace.shipping.subtitle": "全チャネルの注文に対する処理・梱包・配送フローを管理します。",
  "shopee.workspace.shipping.create-shipping-order": "配送注文を作成",
  "shopee.workspace.shipping.alert.print-labels-bulk": "ラベル一括印刷",
  "shopee.workspace.shipping.action.print-bulk": "一括印刷",
  "shopee.workspace.shipping.alert.export-excel": "リストをExcelに出力",
  "shopee.workspace.shipping.alert.syncing-orders": "各チャネルから新規注文を同期中...",
  "shopee.workspace.shipping.kpi.overdue": "期限超過 {count} 件",
  "shopee.workspace.shipping.kpi.packing": "梱包中",
  "shopee.workspace.shipping.kpi.packing-sub": "1 件対応中",
  "shopee.workspace.shipping.kpi.pickup-today": "本日集荷",
  "shopee.workspace.shipping.kpi.handover": "引き渡し済み",
  "shopee.workspace.shipping.kpi.shipping": "配達中",
  "shopee.workspace.shipping.kpi.shipping-sub": "輸送中",
  "shopee.workspace.shipping.step.delivered": "完了",
  "shopee.workspace.shipping.step.picking": "ピッキング",
  "shopee.workspace.shipping.action.print-label": "配送ラベルを印刷",
  "shopee.workspace.shipping.search-placeholder": "注文コード・顧客名・電話番号を検索...",
  "shopee.workspace.shipping.filter.all-carriers": "すべての配送業者",
  "shopee.workspace.common.yesterday": "昨日",
  "shopee.workspace.common.this-month": "今月",
  "shopee.workspace.shipping.pagination-summary": "{total} 件中 1 - {count} 件を表示",
  "shopee.workspace.shipping.perf.performance-today": "本日のパフォーマンス",
  "shopee.workspace.shipping.perf.updated-at": "10:30 更新",
  "shopee.workspace.shipping.perf.processed": "処理済み",
  "shopee.workspace.shipping.perf.orders-value": "{count} 件",
  "shopee.workspace.shipping.perf.on-time": "期限内",
  "shopee.workspace.shipping.perf.overdue": "期限超過",
  "shopee.workspace.shipping.perf.success-rate": "配達成功率",
  "shopee.workspace.shipping.perf.returns": "返送注文",
  "shopee.workspace.shipping.perf.top-carriers": "上位配送業者",
  "shopee.workspace.shipping.alert.close-detail": "詳細パネルを閉じる",
  "shopee.workspace.shipping.section-customer": "顧客情報",
  "shopee.workspace.shipping.title.call": "電話をかける",
  "shopee.workspace.shipping.alert.call": "{phone} に電話",
  "shopee.workspace.shipping.title.address": "住所を見る",
  "shopee.workspace.shipping.section-products": "商品（{count}）",
  "shopee.workspace.shipping.section-shipping-info": "配送情報",
  "shopee.workspace.shipping.col.carrier": "配送業者",
  "shopee.workspace.shipping.title.copy-code": "コードをコピー",
  "shopee.workspace.shipping.alert.copied": "コピーしました: {code}",
  "shopee.workspace.shipping.col.service": "サービス",
  "shopee.workspace.shipping.col.shipping-fee": "送料",
  "shopee.workspace.shipping.col.cod": "代金引換（COD）",
  "shopee.workspace.shipping.col.total-collect": "合計回収額",
  "shopee.workspace.shipping.checklist-title": "梱包チェックリスト",
  "shopee.workspace.shipping.alert.print-label": "{sn} の配送ラベルを印刷",
  "shopee.workspace.shipping.action.print-slip": "納品書を印刷",
  "shopee.workspace.shipping.alert.print-slip-order": "{sn} の納品書を印刷",
  "shopee.workspace.shipping.action.packed-done": "梱包完了",
  "shopee.workspace.shipping.notice.packed-handover": "梱包が完了し、「引き渡し待ち」ステータスに移行しました",
  "shopee.workspace.shipping.alert.packed-done": "注文 {sn} の梱包が完了しました",
  "shopee.workspace.shipping.action.complete-handover": "完了して引き渡し待ちへ",
  "shopee.workspace.shipping.action.report-shortage": "不足を報告",
  "shopee.workspace.shipping.action.delay-packing": "梱包を保留",
  "shopee.workspace.shipping.scan.title": "梱包ステーション - 注文コードをスキャン",
  "shopee.workspace.shipping.scan.desc": "バーコードをスキャンするか、追跡番号/Shopee注文コードを入力して検品・ラベル印刷を即時に行います：",
  "shopee.workspace.shipping.scan.label": "注文コード / 追跡番号",
  "shopee.workspace.shipping.scan.placeholder": "例: SP24072201 または GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "コードに一致する注文が見つかりません: {code}",
  "shopee.workspace.shipping.scan.now": "今すぐスキャン",
  "shopee.workspace.finance.channel-pos": "POS - 店舗",
  "shopee.workspace.finance.status.paid": "支払済み",
  "shopee.workspace.finance.status.pending-payment": "入金待ち",
  "shopee.workspace.finance.status.discrepancy": "差異",
  "shopee.workspace.finance.status.dispute": "係争中",
  "shopee.workspace.finance.bank-encrypted": "暗号化された口座",
  "shopee.workspace.finance.payout.transferred": "送金済み",
  "shopee.workspace.finance.payout.processing": "処理中",
  "shopee.workspace.finance.sync-queued": "消込同期をスケジュールしました",
  "shopee.workspace.finance.subtitle": "すべての販売チャネルの支払いを追跡・消込・管理します",
  "shopee.workspace.finance.forecast": "入金予測",
  "shopee.workspace.finance.export-report": "レポートを出力",
  "shopee.workspace.finance.action.sync": "消込を同期",
  "shopee.workspace.finance.kpi.revenue": "売上",
  "shopee.workspace.finance.kpi.vs-prev-period": "前期比",
  "shopee.workspace.finance.kpi.pending-reconciliation": "消込待ち",
  "shopee.workspace.finance.kpi.holding": "保留中",
  "shopee.workspace.finance.kpi.refund": "返金",
  "shopee.workspace.finance.kpi.fees": "手数料・控除",
  "shopee.workspace.finance.cashflow-title": "キャッシュフロー",
  "shopee.workspace.finance.net-received": "実受取額",
  "shopee.workspace.finance.forecast.tomorrow": "明日",
  "shopee.workspace.finance.forecast.next-3-days": "今後3日間",
  "shopee.workspace.finance.forecast.next-week": "来週",
  "shopee.workspace.finance.forecast.view-detail": "予測の詳細を見る →",
  "shopee.workspace.finance.filter.all-banks": "すべての銀行口座",
  "shopee.workspace.finance.col.sn": "精算コード",
  "shopee.workspace.finance.col.period": "精算期間",
  "shopee.workspace.finance.col.order-count": "注文数",
  "shopee.workspace.finance.col.payout-date": "支払日",
  "shopee.workspace.finance.action.export-excel-file": "Excelファイルを出力",
  "shopee.workspace.finance.detail-title": "精算詳細",
  "shopee.workspace.finance.meta.period": "精算期間：",
  "shopee.workspace.finance.meta.payout-date": "支払日：",
  "shopee.workspace.finance.meta.bank-account": "受取口座：",
  "shopee.workspace.finance.meta.transaction-code": "取引コード：",
  "shopee.workspace.finance.meta.status": "ステータス：",
  "shopee.workspace.finance.tab-orders": "注文詳細（{count}）",
  "shopee.workspace.finance.bd.gross-revenue": "総売上",
  "shopee.workspace.finance.bd.platform-deduction": "プラットフォーム控除 ^",
  "shopee.workspace.finance.bd.voucher": "プラットフォームクーポン",
  "shopee.workspace.finance.bd.shipping-buyer": "送料（購入者負担）",
  "shopee.workspace.finance.bd.seller-discount": "プラットフォーム割引",
  "shopee.workspace.finance.bd.payment-fee": "決済手数料",
  "shopee.workspace.finance.bd.service-fee": "サービス料",
  "shopee.workspace.finance.bd.tax": "税金",
  "shopee.workspace.finance.bd.refunds": "返金 / 返品 ^",
  "shopee.workspace.finance.bd.refund-fee": "返金手数料",
  "shopee.workspace.finance.bd.other-deductions": "その他控除",
  "shopee.workspace.finance.action.view-documents": "消込証憑を見る",
  "shopee.workspace.finance.action.download-statement": "精算表をダウンロード",
  "shopee.workspace.finance.discrepancy.alert": "確認が必要な差異：",
  "shopee.workspace.finance.discrepancy.desc": "VMASSとチャネル間で差異のある注文が {count} 件あります。",
  "shopee.workspace.finance.widget.success-rate": "消込成功率",
  "shopee.workspace.finance.legend.success": "成功：",
  "shopee.workspace.finance.legend.failed": "失敗：",
  "shopee.workspace.finance.widget.top-revenue-channels": "売上上位チャネル",
  "shopee.workspace.finance.channel-others": "その他",
  "shopee.workspace.finance.widget.popular-refund-reasons": "返金理由ランキング",
  "shopee.workspace.finance.reason.wrong-color": "色違い：",
  "shopee.workspace.finance.reason.wrong-size": "サイズ不合：",
  "shopee.workspace.finance.reason.defect": "商品不良：",
  "shopee.workspace.finance.reason.not-liked": "気に入らない：",
  "shopee.workspace.finance.insight.unpaid-orders": "配達から10日以上経過しても未入金のShopee注文が {count} 件あります。",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopeeは明日（{date}）に約4,200万を振り込みます。",
  "shopee.workspace.finance.insight.fee-increase": "TikTok Shopの送料は先月より{percent}上昇しました。",
  "shopee.workspace.finance.insight.view-more": "インサイトをもっと見る →",
  "shopee.workspace.issues.channel-other": "その他チャネル",
  "shopee.workspace.common.order-hash": "注文",
  "shopee.workspace.common.product-hash": "商品",
  "shopee.workspace.tab.shipping-short": "配送",
  "shopee.workspace.issues.subtitle": "接続・同期・システムの問題を追跡し、処理・解決します",
  "shopee.workspace.issues.severity.critical": "重大",
  "shopee.workspace.issues.severity.high": "高",
  "shopee.workspace.issues.severity.medium": "中",
  "shopee.workspace.issues.severity.low": "低",
  "shopee.workspace.issues.status.unresolved": "未処理",
  "shopee.workspace.issues.status.in-progress": "対応中",
  "shopee.workspace.issues.status.waiting": "待機中",
  "shopee.workspace.issues.status.resolved": "解決済み",
  "shopee.workspace.issues.status.ignored": "除外",
  "shopee.workspace.issues.type.order-sync": "注文同期",
  "shopee.workspace.issues.type.product-sync": "商品同期",
  "shopee.workspace.issues.type.system-task": "システムタスク",
  "shopee.workspace.issues.type.system": "システム",
  "shopee.workspace.issues.type.stock-sync": "在庫同期",
  "shopee.workspace.issues.type.api-connection": "API接続",
  "shopee.workspace.issues.type.payment": "支払い",
  "shopee.workspace.issues.filter.all-types": "すべての種類",
  "shopee.workspace.issues.filter.all-severities": "すべての重要度",
  "shopee.workspace.issues.error.order-sync": "注文同期エラー",
  "shopee.workspace.issues.error.check-order-status": "注文ステータスを確認してください",
  "shopee.workspace.issues.error.sku-mapping": "SKUマッピングエラー",
  "shopee.workspace.issues.error.sku-unmapped": "VMASSに未マッピングのSKUまたは在庫同期エラー",
  "shopee.workspace.issues.error.job-ended-status": "ジョブはステータス {status} で終了しました",
  "shopee.workspace.issues.error.retried-times": "{count} 回再試行",
  "shopee.workspace.issues.action.process-label": "問題 {id} を処理",
  "shopee.workspace.issues.action.process-now": "今すぐ処理",
  "shopee.workspace.issues.action.ignore-label": "問題 {id} を除外",
  "shopee.workspace.issues.action.ignore": "除外",
  "shopee.workspace.issues.action.mark-resolved": "解決済みとしてマーク",
  "shopee.workspace.issues.empty": "一致する問題データが見つかりません",
  "shopee.workspace.issues.pagination-of": "/ {total} 件の問題",
  "shopee.workspace.issues.total-errors": "問題合計",
  "shopee.workspace.issues.chart.by-channel": "チャネル別問題",
  "shopee.workspace.issues.chart.by-type": "種類別問題",
  "shopee.workspace.issues.chart.by-severity": "重要度別問題",
  "shopee.workspace.issues.chart.timeline": "問題の推移",
  "shopee.workspace.issues.chart.top-errors": "発生頻度の高い問題",
  "shopee.workspace.issues.times-count": "{count} 回",
  "shopee.workspace.issues.top.order-list": "注文リストを取得できません",
  "shopee.workspace.issues.top.invalid-data": "無効なデータ",
  "shopee.workspace.issues.top.negative-stock": "在庫マイナス",
  "shopee.workspace.issues.top.payment-not-found": "決済トランザクションが見つかりません",
  "shopee.workspace.issues.activity.processed": "TikTok Shop - 商品同期の問題を処理しました",
  "shopee.workspace.issues.activity.resolved": "問題を解決しました",
  "shopee.workspace.issues.drawer.title": "問題詳細",
  "shopee.workspace.issues.drawer.info-title": "問題情報",
  "shopee.workspace.issues.drawer.error-code": "エラーコード",
  "shopee.workspace.issues.drawer.request": "リクエスト",
  "shopee.workspace.issues.drawer.request-detail": "リクエスト詳細",
  "shopee.workspace.issues.drawer.response-detail": "レスポンス詳細",
  "shopee.workspace.issues.drawer.impact-title": "影響",
  "shopee.workspace.issues.drawer.impact-orders": "影響を受けた注文",
  "shopee.workspace.issues.drawer.impact-products": "影響を受けた商品",
  "shopee.workspace.issues.drawer.impact-revenue": "影響を受けた売上",
  "shopee.workspace.issues.drawer.suggestions-title": "対処の提案",
  "shopee.workspace.issues.suggest.check-api": "Shopee API接続を確認",
  "shopee.workspace.issues.suggest.check-status": "Shopeeシステムステータスを確認",
  "shopee.workspace.issues.suggest.retry-sync": "数分後に再同期を試してください",
  "shopee.workspace.issues.suggest.contact-support": "問題が続く場合はサポートに連絡",
  "shopee.workspace.issues.drawer.note-title": "内部メモ",
  "shopee.workspace.issues.confirm.title": "問題処理の確認",
  "shopee.workspace.issues.confirm.desc": "この操作を実行してもよろしいですか？",
  "shopee.workspace.issues.confirm.items": "{label}（{count} 件）",
  "shopee.workspace.issues.confirm.ok": "確認",
  "shopee.workspace.issues.confirm.queued": "修復タスクをキューに追加しました",
  "shopee.workspace.issues.kpi.all": "すべての問題",
  "shopee.workspace.issues.kpi.all-sub": "検出された問題の合計",
  "shopee.workspace.issues.kpi.unresolved-sub": "要即時確認",
  "shopee.workspace.issues.kpi.in-progress": "対応中の問題",
  "shopee.workspace.issues.kpi.in-progress-sub": "現在処理中",
  "shopee.workspace.issues.kpi.resolved": "解決済みの問題",
  "shopee.workspace.issues.kpi.resolved-sub": "正常に解決されました",
  "shopee.workspace.issues.kpi.critical": "重大な問題",
  "shopee.workspace.issues.kpi.critical-sub": "高・重大レベル",
  "shopee.workspace.issues.action.configure-alerts": "アラートを設定",
  "shopee.workspace.issues.action.system-logs": "システムログ",
  "shopee.workspace.issues.col.channel-source": "チャネル / ソース",
  "shopee.workspace.issues.col.type": "問題の種類",
  "shopee.workspace.issues.col.severity": "重要度",
  "shopee.workspace.issues.col.object": "対象",
  "shopee.workspace.issues.col.message": "エラーメッセージ",
  "shopee.workspace.listing.description-template": "{name} - 高品質商品",
  "shopee.workspace.listing.err.no-shop": "Shopeeショップが未選択です",
  "shopee.workspace.listing.err.no-product": "VMASS商品が未選択です",
  "shopee.workspace.listing.err.name-length": "商品名は5〜120文字で入力してください",
  "shopee.workspace.listing.err.desc-length": "説明は25文字以上必要です",
  "shopee.workspace.listing.err.price": "価格は0より大きくしてください",
  "shopee.workspace.listing.err.variant-price": "すべてのバリアントの価格は0より大きくしてください",
  "shopee.workspace.listing.err.weight": "重量は0.01〜50kgの範囲で入力してください",
  "shopee.workspace.listing.err.no-category": "Shopeeカテゴリが未選択です",
  "shopee.workspace.listing.err.brand-load-failed": "Shopeeブランドを読み込めませんでした",
  "shopee.workspace.listing.err.no-brand": "Shopeeブランドが未選択です",
  "shopee.workspace.listing.err.no-logistics": "配送チャネルが未選択です",
  "shopee.workspace.listing.err.missing-attribute": "属性が不足しています: {attribute}",
  "shopee.workspace.listing.err.dimensions": "3つのサイズすべてに0より大きい値を入力してください",
  "shopee.workspace.listing.update-queued": "出品更新リクエストをキューに追加しました",
  "shopee.workspace.listing.publish-queued": "商品をShopeeへの出品キューに追加しました",
  "shopee.workspace.listing.label.shop": "Shopeeショップ *",
  "shopee.workspace.listing.no-shops": "利用可能なShopeeショップはありません",
  "shopee.workspace.listing.primary-mark": "メイン",
  "shopee.workspace.listing.shop-hint": "カテゴリ・ブランド・配送データは選択したショップに基づいて読み込まれます。",
  "shopee.workspace.listing.label.brand": "Shopeeブランド",
};

export default jaJp;
